import { TranslationsType } from './language-types';

export const en: TranslationsType = {
  /* diamonds search */
  search_diamonds: 'Search Diamonds',
  search_standard_view: 'Standard View',
  search_compact_view: 'Compact View',
  search_classic_view: 'Classic View',
  button_reset: 'Reset',
  button_search: 'Search',
  button_save: 'Save',
  button_load: 'Load',
  button_apply: 'Apply',
  button_send: 'Send',
  button_cancel: 'Cancel',
  select_saved_search: 'Select Saved Search',
  search_save_search: 'Save Search',
  notify_immediately: 'Notify Immediately',
  notify_daily: 'Notify Daily',
  notification_of_matching_diamonds: 'Notification of matching diamonds',
  create_group: 'Create Group',
  include_in_group: 'Include in group',
  saved_search_name: 'Saved Search Name',
  add_new_group: 'Add New Group',
  milky_from: 'Milky from',
  milky_to: 'Milky to',
  to: 'To',
  from: 'From',
  select: 'Select',
  basic: 'Basic',
  shape: 'Shape',
  size: 'Size',
  clarity: 'Clarity',
  color: 'Color',
  colors: 'Colors',
  fancy: 'Fancy',
  white: 'White',
  inclusions: 'Inclusions',
  inclusion_s: 'Inclusion(s)',
  eye_clean: 'Eye Clean',
  open_inclusions: 'Open Inclusions',
  white_inclusions: 'White Inclusions',
  black_inclusions: 'Black Inclusions',
  cut: 'Cut',
  polish: 'Polish',
  symmetry: 'Symmetry',
  finish: 'Finish',
  popular: 'Popular',
  advanced: 'Advanced',
  key_to_symbols: 'Key to Symbols',
  treatment: 'Treatment',
  measurements: 'Measurements',
  preferences: 'Preferences',
  rapspec: 'RapSpec',
  stock_numbers: 'Stock Number(s)',
  rating: 'Rating',
  rap_id_company_codes: 'Rap ID/Company Codes',
  sellers: 'Seller(s)',
  flexible_delivery: 'Flexible Delivery',
  enter_locations: 'Enter Location(s)',
  location: 'Location',
  locations: 'Locations',
  location_s: 'Location(s)',
  grading_report: 'Grading Report',
  general: 'General',
  specific: 'Specific',
  shade: 'Shade',
  shades: 'Shades',
  no_bgm: 'No BGM',
  display_type: 'Display Type',
  contains: 'Contains',
  does_not_contain: 'Does not contain',
  only_contains: 'Only contains ',
  height_percent: 'Height %',
  angle: 'Angle',
  crown: 'Crown',
  culet_condition: 'Culet Condition',
  culet_size: 'Culet Size',
  girdle: 'Girdle',
  metric: 'Metric',
  depth: 'Depth',
  width: 'Width',
  length: 'Length',
  depth_percent: 'Depth %',
  pavilion: 'Pavilion',
  percentage: 'Percentage',
  table_percent: 'Table %',
  ratio: 'Ratio',
  media: 'Media',
  my_notes: 'My Notes',
  with_cash_price: 'With Cash Price',
  price: 'Price',
  price_lower_case: 'price',
  price_per_carat: '$/Ct',
  price_per_carat_lower_case: '$/ct',
  total: 'Total',
  rap_percent: 'Rap%',
  show_only: 'Show Only',
  no_treatment: 'No treatment',
  show_only_treated: 'Show only treated',
  include_treated_diamonds_in_results: 'Include treated diamonds in results',
  intensities: 'Intensities',
  start_typing_location_name: 'Start typing location name',
  rapspec_all: 'RapSpec(All)',
  rapspec_gia: 'RapSpec (GIA)',
  include_cash_price: 'Include Cash Price',
  all_filters: 'All Filters',
  filters: 'Filters',
  display_only_the_below_brands_in_the_results: 'Display only the below brands in the results',
  all_notes: 'All Notes',
  results_sorting: 'Results Sorting',
  labs: 'Labs',
  diamonds: 'diamonds',
  diamonds_first_letter_uppercase: 'Diamonds',
  diamond_details: 'Diamond Details',
  last_update: 'Last Update',
  inscription: 'Inscription',
  fluorescence: 'Fluorescence',
  star_length: 'Star Length',
  brand: 'Brand',
  supplier_link: 'Supplier Link',
  supplier_comment: 'Supplier Comment',
  report_shape: 'Report Shape',
  report_comment: 'Report Comment',
  lot_diamond_n: 'Lot Diamond #',
  availability: 'Availability',
  diamond_location: 'Diamond Location',
  stock_no: 'Stock No#',
  cash: 'Cash',
  report: 'Report',
  diagram: 'Diagram',
  images: 'Images',
  video: 'Video',
  modify: 'Modify',
  new_search: 'New Search',
  total_carats: 'Total Carats',
  total_value: 'Total Value',
  average_discount: 'Average Discount',
  average: 'Average',
  open_close_all: 'Open/Close All',
  show_selected: 'Show Selected',
  show_all: 'Show All',
  add_to_compare: 'Add to Compare',
  email_selected: 'Email Selected',
  custom_columns: 'Custom Columns',
  print: 'Print',
  custom_print_email: 'Custom Print / Email',
  contact_seller_selected: 'Contact Seller Selected',
  more_options: 'More Options',
  other_locations: 'Other Locations',
  rapnet_id_n: 'RapNet ID#',
  rapnet_users: 'RapNet Users',
  contact_person: 'Contact person',
  show_phone_number: 'Show phone number',
  upgrade_your_account: 'Upgrade Your Account',
  track_this_diamond: 'Track this diamond',
  untrack_this_diamond: 'Untrack this diamond',
  rapNet_verified: 'RapNet Verified',
  write_a_personal_note: 'Write a personal note...',
  contact_seller: 'Contact Seller',
  compare: 'Compare',
  more: 'More',
  you_have_already_contacted_this_seller_on: 'You have already contacted this seller on',
  the_status_of_your_offer_is: 'The status of your offer is',
  report_incorrect_listings: 'Report Incorrect Listings',
  email_results: 'Email Results',
  calculate_your_price: 'Calculate Your Price',
  seller_details: 'Seller Details',
  highest_bid: 'Highest Bid',
  bids: '# Bids',
  expires_in: 'Expires In',
  place_bid: 'Place Bid',
  seller: 'Seller',
  rate: 'Rate',
  loc: 'Loc',
  symm: 'Symm',
  symm_short: 'Symm',
  fluor: 'Fluor.',
  table: 'Table',
  lab: 'Lab',
  percent_rap: '%Rap',
  culet: 'Culet',
  phone: 'Phone',
  vendor_stock_number: 'Vendor Stock number',
  fax: 'Fax',
  city: 'City',
  state: 'State',
  country: 'Country',
  rap_spec: 'RapSpec',
  report_number: 'Report Number',
  lab_comment: 'Lab Comment',
  report_date: 'Report Date',
  member_comment: 'Member Comment',
  cert_comment: 'Cert Comment',
  lab_location: 'Lab Location',
  last_updated: 'Last Updated',
  diamond_id: 'Diamond ID',
  inclusion: 'Inclusion',
  overtone: 'Overtone',
  cash_price_per_carat: 'Cash: $/ct',
  cash_percent_rap: 'Cash: %Rap',
  cash_total: 'Cash: Total',
  brand_s: 'Brand(s)',
  milky: 'Milky',
  open: 'Open',
  black: 'Black',
  fancy_colors: 'Fancy Colors',
  overtones: 'Overtones',
  fancy_intensity: 'Fancy Intensity',
  intensity: 'Intensity',
  conditions: 'Conditions',
  rap_category_code: 'Rap Category Code',
  access_code: 'Access Code',
  lab_report_number: 'Lab Report Number',
  stock_number_s: 'Stock Number(s)',
  rapnet_lot_number_s: 'RapNet Lot Number(s)',
  seller_s: 'Seller(s)',
  sort_by: 'Sort By',
  carat: 'Carat',
  carat_lower_case: 'carat',
  average_price: 'Average Price',
  average_price_ct: 'Average Price/Ct.',
  total_price: 'Total Price',
  showing: 'Showing',
  show: 'Show',
  results: 'results',
  last: 'Last',
  first: 'First',
  some_results_may_not_be_displayed: 'Some results may not be displayed',
  rapnet_trade_center_is_live: 'IMPORTANT NOTICE - RAPNET TRADE CENTER IS LIVE',
  your_inquiry_offer_will_be_delivered_to_the_seller:
    'Your inquiry/offer will be delivered to the seller in the RapNet Trade Center, where you and the seller can securely finalize negotiations.',
  your_message: 'Your Message',
  your_offer: 'Your Offer',
  keep_your_offers_organized_in_trade_center: 'Keep your offers organized in Trade Center',
  transaction_type: 'Transaction Type',
  select_group_or_create_a_new_group_by_typing_below:
    'Select group or create a new group by typing below',
  contact_seller_not_available: 'contact seller to your own diamond(s) is not available',
  contact_seller_ignored: 'contact seller to your own diamond(s) was ignored',
  single_stones: 'Single Stones',
  /* end diamonds search */

  /* member directory */
  company: 'Company',
  company_type: 'Company Type',
  rapnet_id: 'RapNet ID',
  joined: 'RapNet ID',
  simple: 'Simple',
  all_members: 'All Members',
  primary_suppliers: 'Primary Suppliers',
  diamonds_listed: 'Diamonds Listed',
  company_code: 'Company Code',
  company_name: 'Company Name',
  member_name: 'Member Name',
  telephone: 'Tel.',
  website: 'Website',
  min_of_ratings: 'Min # of Ratings',
  member_directory_search_by_name: 'Name: Search by company name, member or RapNet ID.',
  member_directory_search_by_location: 'Location: Search by city, state, country or zip code.',
  /* end member directory */

  /* articles */
  articles: 'Articles',
  list_view: 'List View',
  back_to_articles: 'Back to articles',
  no_details_found: 'No details found',
  no_results_to_show: 'No results to show',
  view_mode: 'View Mode:',
  gallery_view: 'Gallery View',
  /* articles end */

  /* buy-request */
  contact_buyer: 'Contact Buyer',
  post_buy_request: 'Post Buy Request',
  send_upper_case: 'SEND',
  preferred_seller_location: 'Preferred Seller Location',
  dollar_total: '$Total',
  buy_request_details: 'Buy Request Details',
  expires: 'Expires',
  matched_pair: 'Matched Pair',
  buyer_comment: 'Buyer Comment',
  delete_buy_requests: 'Delete Buy Requests',
  are_you_sure_you_want_to_delete_these_requests: 'Are you sure you want to delete these requests?',
  print_all: 'Print All',
  print_selected: 'Print Selected',
  delete_selected: 'Delete Selected',
  dollar_slash_ct: '$/Ct',
  buy_requests: 'Buy Requests',
  include_expired: 'Include Expired',
  /* buy-request end */

  /* calculator */
  calculate_upper_case: 'CALCULATE',
  save_result_upper_case: 'SAVE RESULT',
  reset_upper_case: 'RESET',
  dollar_total_upper_case: '$TOTAL',
  persent_rap_upper_case: '%RAP',
  delete_all_upper_case: 'DELETE ALL',
  print_upper_case: 'PRINT',
  email_upper_case: 'EMAIL',
  export_upper_case: 'EXPORT',
  dollar_slash_ct_upper_case: '$/CT',
  your_price: 'Your Price',
  dollar_c_t: '$CT',
  rapaport: 'Rapaport',
  rapnet_agv: 'RapNet AVG',
  rapnet_best: 'RapNet BEST',
  calculator: 'Calculator',
  note_the_diamond_details_will_automatically_be_inserted:
    'Note: The diamond details will automatically be inserted here as part of your message',
  the_diamond_details_will_automatically_be_inserted:
    'The diamond details will automatically be inserted here as part of your message',
  to_email: 'To Email',
  instructions: 'Instructions',
  enter_the_shape_color_clarity: 'Enter the shape, color, clarity and size of your diamond.',
  you_can_adjust_your_price: 'You can adjust your price and save your results.',
  adjust_your_total_price_and_print:
    'Adjust your total price and print, email or export your results to excel (.csv file format).',
  include_in_total: 'Include in Total',
  name: 'Name',
  persent_slash_rap: '%/Rap',
  dollar_slash_total: '$/Total',
  rap_total: 'rap Total',
  difference_list_price_slash_your_price: 'Difference List Price/Your Price',
  total_dollar_sign: 'Total $',
  /* calculator end */

  /* compare diamonds */
  there_are_no_diamonds_to_compare: 'There are no diamonds to compare.',
  compare_diamonds: 'Compare Diamonds',
  advanced_details: 'Advanced Details',
  note_s: 'Note(s)',
  pavillion: 'Pavillion',
  cash_dollar_slash_ct: 'Cash $/ct',
  cash_rap_dollar: 'Cash Rap%',
  cash_dollar_total: 'Cash $Total',
  memo_dollar_slash_ct: 'Memo $/ct',
  memo_rap_percent: 'Memo Rap%',
  memo_dollar_total: 'Memo $Total',
  price_dollar_slash_ct: 'Price $/ct',
  price_rap_percent: 'Price Rap%',
  price_dollar_total: 'Price $Total',
  companye: 'Company',
  rap_ide: 'RAP ID',
  delete: 'Delete',
  pin: 'pin',
  /* compare diamonds end */

  /* contact-us */
  rapnet_customer_support: 'To: RapNet Customer Support',
  subject: 'Subject',
  your_email_address: 'Your email address',
  your_phone_number: 'Your phone number',
  select_feature: 'Select Feature...',
  enter_your_question_slash_concern: 'Enter your question/concern',
  email_rapaport_representative: 'Email Rapaport Representative',
  email: 'Email',
  message: 'Message',
  office_of_the_chairman: 'Office of the Chairman',
  Chairman: 'Chairman',
  webmaster: 'Webmaster',
  rapnet_customer_service: 'RapNet Customer Service',
  rapnet_technical_support: 'RapNet Technical Support',
  diamond_trading_and_auctions: 'Diamond Trading and Auctions',
  director_of_trading_operations: 'Director of Trading Operations',
  laboratory_services: 'Laboratory Services',
  belgium: 'Belgium',
  india: 'India',
  israel: 'Israel',
  rapaport_magazine: 'Rapaport Magazine',
  subscriptions: 'Subscriptions',
  editor_in_chief: 'Editor-in-Chief',
  publisher: 'Publisher',
  advertising: 'Advertising',
  sales_director: 'Sales Director',
  global_sales_manager: 'Global Sales Manager',
  india_sales_manager: 'India Sales Manager',
  senior_analyst: 'Senior Analyst',
  news_writer: 'News Writer',
  media_contact: 'Media Contact',
  fair_trade_coordinator: 'Fair Trade Coordinator',
  contact_us: 'Contact Us',
  regional_offices: 'Regional Offices',
  /* contact-us end */

  /* custom-report */
  rows: 'rows',
  custom_reports: 'Custom Reports',
  there_are_no_reports_to_show: 'There are no reports to show',
  /* custom-report end */

  /* dashboard */
  your_subscription_automatically_renews_on: 'Your subscription automatically renews on',
  no_action_isnecessary_on_your_part: 'No action is necessary on your part',

  before: 'before',
  your_account_is_currently_in_poor_standing_status_with_an_outstanding_balance_to_settle_any_outstanding_payments:
    'Your account is currently in poor standing status with an outstanding balance. To settle any outstanding payments,',
  click_here: 'Click here ',
  no_new_announcements: 'No new announcements',
  announcements: 'Announcements',
  all_announcements: 'All Announcements',
  trade: 'Trade',
  all: 'All',
  user: 'User',
  there_are_no_events: 'There are no events',
  events: 'Events',
  rapaport_events: 'Rapaport Events',
  ideas: 'Ideas',
  change: 'Change',
  financial_data: 'Financial Data',
  currencies: 'Currencies',
  indexes: 'Indexes',
  metals: 'Metals',
  latest_jewelry: 'Latest Jewelry',
  news: 'News',
  all_news: 'All News',
  round: 'Round',
  pear: 'Pear',
  princess: 'Princess',
  cushion_brilliant: 'Cushion Brilliant',
  emerald: 'Emerald',
  radiant: 'Radiant',
  there_is_no_data_to_display: 'There is no data to display',
  rapaport_diamond_ndexes: 'Rapaport Diamond Indexes ©Copyright Rapaport 2018 All Rights Reserved',
  the_rapi_is_the_average_asking_price:
    'The RAPI is the average asking price in hundred $/ct. of the 10% best-priced diamonds for each of the top 25 quality round diamonds (D-H, IF-VS2, GIA-graded, RapSpec-A3 and better) offered for sale on RapNet.',
  rapnet_statistics: 'RapNet Statistics',
  number_of_diamonds: 'Number of diamonds',
  diamonds_pricing_indexes: 'Diamonds pricing indexes',
  breakdown_of_diamonds: 'Breakdown of diamonds',
  total_diamond_value: 'Total Diamond Value (Unique)',
  white_diamond_value: 'White Diamond Value',
  round_white_diamonds: 'Round Diamonds (White)',
  fancy_shaped_diamonds: 'Fancy Shaped Diamonds (White)',
  parcel_diamonds: 'Parcel Diamonds (All)',
  search_upper_case: 'SEARCH',
  weekly_market_comment: 'Weekly Market Comment',
  read_more: 'Read More',
  world_clock: 'World Clock',
  welcome: 'Welcome',
  customer_service_representative: 'Customer Service Representative',
  unread_trades: 'Unread Trades',
  price_matched: 'Price Matched',
  signature_waiting: 'Signature Waiting',
  /* dashboard end */

  /* diamonds-file-manajer */
  are_you_sure_you_want_to_delete_all: 'Are you sure you want to delete all',
  unconnected: 'unconnected',
  are_you_sure_you_want_to_delete_this_file: 'Are you sure you want to delete this file?',
  are_you_sure_you_want_to_delete_these_files: 'Are you sure you want to delete these files?',
  upload: 'Upload',
  connect: 'Connect',
  to_diamond: 'to diamond',
  disconnect: 'Disconnect',
  are_you_sure_you_want_to_disconnect_listing:
    'Are you sure you want to disconnect the file from your diamond listing?',
  disconnect_from_diamond: 'Disconnect from diamond',
  connect_to_diamond: 'Connect to diamond',
  delete_all: 'Delete all',
  download: 'Download',
  download_upper_case: 'DOWNLOAD',
  delete_upper_case: 'DELETE',
  connect_upper_case: 'CONNECT',
  connected: 'Connected',
  file_name: 'File Name',
  report_lattice: 'Report #',
  stock_lattice: 'Stock #',
  diamond_lattice: 'Diamond #',
  date: 'Date',
  lot__lattice: 'Lot#',
  stocklattice: 'Stock#',
  show_only_connected: 'Show Only Connected',
  show_only_unconnected: 'Show Only Unconnected',
  no_sort: 'No Sort',
  sort_by_name: 'Sort By Name',
  sort_by_date: 'Sort By Date',
  filter_upper_case: 'FILTER',
  drag_and_drop_or: 'Drag & Drop or',
  browse: 'Browse',
  upload_upper_case: 'UPLOAD',
  rapaport_booth: 'Rapaport Booth:',
  view_more_trade_events_on: 'View More Trade Events on the Rapaport Calendar',
  /* diamonds-file-manajer end */

  /* ideas */
  redirecting_to_ideas: 'Redirecting to ideas...',
  please_consult_with_your_website_designer:
    'Please consult with your website designer and computer programmer regarding your custom search engine design. Using this method of web services allows programmers to integrate a shopping cart and more advanced features into your website.',
  the_following_technical_data_must_be_provided:
    'The following technical data must be provided to your programmer based on your RapNet account details and selections you made in order to connect your search engine with RapNet.',
  your_username_and_password_for_rapnet: 'Your username and password for RapNet',
  the_following_diamond_selection_details: 'The following diamond selection details:',
  provide_the_following_links: 'Provide the following links from TechNet to your programmer:',
  shapes_are_required: 'Shapes are required',
  clarity_is_required: 'Clarity is required',
  grading_report_is_required: 'Grading Report is required',
  sizes_are_required: 'Sizes are required',
  sizes_must_be_a_number: 'Sizes must be a number',
  total_prices_are_required: 'Total prices are required',
  total_prices_range_should_be_valid: 'Please specify price range from low to high',
  table_percent_range_should_be_valid: 'Please specify table% range from low to high',
  depth_percent_range_should_be_valid: 'Please specify depth% range from low to high',
  total_price_must_be_a_number: 'Total price must be a number',
  finish_cut_polish: 'Finish Cut, Polish and Symmetry are required',
  color_is_required: 'Color is required',
  fancy_color_is_required: 'Fancy Color is required',
  must_be_a_number: 'Must be a number',
  select_all_the_diamonds:
    'Select all the diamonds criteria that you would like to include in your widget.',
  save_upper_case: 'SAVE',
  lets_get_started: "Let's get started! First, let's give your new feed a title.",
  parameters_are_marked_with: 'Required parameters are marked with',
  feed_title: 'Feed title',
  enter_name: 'Enter Name...',
  enter_your_description: 'Enter your description',
  description: 'Description',
  markups: 'Markups',
  persent_markup: '% Markup',
  dollar_markup: '$ Markup',
  add_upper_case: 'ADD',
  actions: 'Actions',
  persent_mark_up: '% Markup',
  dollar_mark_up: '$ Mark-Up',
  save_markups: 'Save Markups',
  markups_error: 'Markups Error',
  markups_are_not_allowed: 'Markups are not allowed',
  your_retail_price_for_your_customers:
    'Set retail prices for your customers to see. You can apply different markup rules depending on the price range of the stone or the weight. Click “add” after each markup until all your stones have retail prices set for them.',
  mark_up_type: 'Markup Type',
  mark_up_example: 'Markup Example',
  valid_markup_up: 'Valid Markup',
  mark_up: 'Markup',
  overlapping_mark_ups: 'Overlapping markups are not allowed',
  gaps_between_mark_ups: 'Gaps between markups are not allowed',
  disclaimer:
    'Disclaimer: The markup examples shown in no way reflect the opinion of the Rapaport Group or RapNet. Special attention should be paid when considering what to markup in the inventory',
  displayed_in_your_feed:
    "displayed in your feed. Rapaport employees or acting agents are unable to give accurate advice regarding what you should use for markup percentages. Each member's business is unique",
  and_factors_such_as_geographic:
    'and factors such as geographic region, economic climate, and individual financial goals make',
  it_impossible_to_give_sound: 'it impossible to give sound profit margin advice.',
  edit: 'Edit',
  only_suppliers_who_have_permitted:
    'Only Suppliers who have permitted you to download their inventory will be available to you.',
  request_rermission: 'Request Permission',
  remove: 'Remove',
  add_to_list: 'Add to list',
  all_suppliers: 'All suppliers',
  rap_id: 'RapID',
  company_and_rating: 'Company & Rating',
  action: 'Action',
  add: 'Add',
  selected_suppliers: 'Selected suppliers',
  lattice_of_diamonds: '# of Diamonds',
  show_only_primary_suppliers: 'Show only Primary Suppliers',
  is_requesting_to_showcase_your:
    'is requesting to showcase your RapNet diamond listings in their online store inventory through RapNet’s Instant Inventory add-on.',
  this_may_help_your_diamonds_sell:
    'This may help your diamonds sell faster by making it available for their customers to view and potentially buy.',
  in_order_to_allow_your: 'In order to allow your listings to appear in',
  site_do_one_of_the_following: '’s site, do one of the following:',
  click_here_to_go_to_their_member_profile: 'Click here to go to their member profile',
  and_in_the_user_setting_in:
    'and in the “user setting” in the bottom right corner turn on "Allow this member to download my listings".',
  if_you_would_like_all:
    'If you would like all members to be able to showcase your diamonds in Instant Inventory,',
  change_your_listings_permissions_preferences:
    'change your “listings Permissions” preferences in your Settings menu. You can then choose which members to include/exclude.',
  member_request_to_showcase_your_diamond_listings:
    'RapNet member request to showcase your diamond listings',
  send_request: 'Send Request',
  lets_get_started_first: "Let's get started! First, let's give your new feed a title.",
  cancel: 'Cancel',
  are_you_sure_you_want_to: 'Are you sure you want to delete this feed?',
  completed: 'Completed',
  in_progress: 'In progress',
  less: 'Less...',
  more_dots: 'More...',
  copy: 'Copy',
  main_feed_can_not_be_deleted: 'Main Feed can not be deleted',
  create_new_feed: 'Create New Feed',
  an_existing_feed_from_the_list_below_in:
    'Select an existing feed from the list below in order to modify it, create a new one OR import from your own stock. All the feeds appear in a single instant inventory widget',
  duplicate: 'Duplicate',
  setup_at_least_one_feed_to:
    'Setup at least one feed to create your new instant inventory widget.',
  the_feed_will_contain_the_diamond_types:
    'The feed will contain the diamond types and suppliers that will be displayed in your widget.',
  are_you_sure_you_want_delete: 'Are you sure you want to delete this diamond?',
  delete_diamonds: 'Delete Diamonds',
  are_you_sure_you_want_to_delete: 'Are you sure you want to delete the selected diamond?',
  are_you_sure_you_want: 'Are you sure you want to delete all diamonds?',
  certificate: 'Certificate',
  replace_ll: 'Replace All',
  important_upper_case: 'IMPORTANT',
  please_make_sure_to_follow:
    'Please make sure to follow our CSV file structure, you can download our',
  csv_template: 'CSV template',
  not_sure_how_to_creat: 'Not sure how to creat your own CSV file? Read this',
  short_guide: 'short guide',
  remove_selected: 'Remove Selected',
  import_own_stock_from_an: 'Import your own stock from an existing file.',
  please_note_that_all_the_feeds:
    'Please note that all the feeds will appear in a single Instant Inventory widget.',
  not_sure_how_to_create: 'Not sure how to create your own CSV file? Read this',
  after_uploading_your_file:
    'After uploading your file, please wait and give the system 2 minutes to process the file before refreshing the page.',
  from_rapnet: 'From Rapnet',
  import_own_stock: 'Import Own Stock',
  choose_a_template: 'Choose a template',
  create_at_least_one_feed: 'Create at least one feed',
  from_rapnet_or_from_your_own_stock: '(from RapNet or from your own stock)',
  you_didnt_finish_your_nstant_nventory_setup: "You didn't finish your Instant Inventory setup",
  please_see_complete_the_unfinished:
    'Please see complete the unfinished steps below in order to create and publish your instant inventory widget.',
  publish_upper_case: 'PUBLISH',
  publish_instant_nventory: 'Publish Instant Inventory',
  done_upper_case: 'DONE',
  ok_got_it_upper_case: 'OK, GOT IT',
  provide_the_script_below_to: 'Provide the script below to your website developer',
  send_via_email: 'Send via email',
  copy_to_clipboard: 'Copy to Clipboard',
  copy_stock_number_to_clipboard: 'Copy Stock # to clipboard',
  no_data_in: 'no data in',
  best_price: 'Best Price',
  usage: 'Usage',
  suppliers: 'Suppliers',
  all_countries: 'All Countries',
  all_types: 'All Types',
  no_data_with_current_filter: 'no data with current filter',
  searches: 'Searches',
  no_data_between_dates: 'no data between dates',
  load_report: 'LOAD REPORT',
  updates: 'Updates',
  legal_terms: 'Legal Terms',
  help: 'Help',
  selected_lower_case: 'selected',
  select_lower_case: 'select',
  the_basic_html_template_allows_you_to:
    'The basic HTML template allows you to showcase diamond on your website.',
  this_template_allows_more_freedom:
    'This template allows more freedom, with its responsive design capabilities.',
  basic_html_iframe: 'Basic HTML (iFrame)',
  responsive_design: 'Responsive design (Mobile & Tablet support)',
  basic_search: 'Basic Search',
  ideal_for_ecommerce: 'Ideal for eCommerce',
  template: 'Template',
  styles: 'Styles',
  font: 'Font',
  background_color: 'Background Color',
  pager_color: 'Pager Color',
  selected_pager_color: 'Selected Pager Color',
  show_price: 'Show Price',
  save_changes: 'Save Changes',
  preview_widget: 'Preview Widget',
  widget: 'Widget',
  these_customization_options: 'These customization options are available',
  only_for_the_new_template: 'only for the new template',
  please_upgrade_to_the_new: 'Please upgrade to the new template to',
  unlock_these_options: 'unlock these options',
  switch_to_new_template: 'Switch to New Template',
  theme_color: 'Theme Color',
  page_size: 'Page Size',
  show_prices: 'Show Prices',
  hide_or_show_diamond_prices: 'Hide or show diamond prices.',
  contact_form: 'Contact Form',
  allow_for_users_to_contact_you:
    'Allow for users to contact you to find out more information about a particular diamond.',
  add_to_cart: 'Add to Cart',
  rap_trade: 'RapTrade Diamonds',
  rap_net: 'RapNet Diamonds',
  type_of_search: 'How Would You Like To Search?',
  description_search_type: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam',
  click_to_read_this_additional:
    'Click to read this additional documentation for more information on setting this up',
  instant_inventory: 'Instant Inventory',
  /* ideas end */

  /* jewelry */
  no_results_found: 'No results found',
  clear_all: '',
  apply_filters: 'Apply Filters',
  seller_account_id: 'Seller Account ID',
  favorite: 'Favorite',
  load_upper_case: 'LOAD',
  please_enter_the_percentage_price:
    'Please enter the percentage price change for the selected items',
  ok_upper_case: 'OK',
  free_search: 'Free Search',
  title_company: 'Title, Company, Stock #, etc.',
  jewelry_type: 'Jewelry Type',
  collection: 'Collection',
  material: 'Material',
  stone_type: 'Stone Type',
  stone_shape: 'Stone Shape',
  diamond_fancy_color: 'Diamond Fancy Color',
  diamond_white_color: 'Diamond White Color',
  brands_designers: 'Brands/Designers',
  condition: 'Condition',
  reset_all: 'Reset All',
  are_you_sure_you_want_to_delete_selected_items: 'Are you sure you want to delete selected items?',
  bulk_price_update: 'Bulk Price Update',
  select_none: 'Select None',
  select_all: 'Select All',
  export_selected: 'Export Selected',
  refresh_list: 'Refresh List',
  export_all: 'Export All',
  add_new: 'Add New',
  update_price: 'Update Price',
  load_saved_searches: 'Load Saved Searches',
  stock_lot_or_Item_title: 'Stock #, Lot# or Item Title',
  item_title: 'Item Title',
  no_items: 'No Items',
  name_dots: 'Name...',
  connect_image_to_jewelry: 'Connect Image to Jewelry',
  jewelry_disconnect_image: 'Jewelry Disconnect Image',
  disconnect_image_from_jewelry: 'Disconnect Image from Jewelry',
  are_you_sure_you_want_to_disconnect: 'Are you sure you want to disconnect selected images?',
  connect_to_jewelry: 'Connect to jewelry',
  disconnect_from_jewelry: 'Disconnect from jewelry',
  write_your_message: 'Write your message...',
  send_yur_offer_upper_case: 'SEND YOUR OFFER',
  terms: 'Terms',
  payment: 'Payment',
  pay_with: 'Pay with',
  business_days: 'business days',
  business_day: 'business day',
  quantity: 'Quantity',
  bid_valid_for: 'Bid valid for',
  email_me_a_copy: 'Email me a copy of this message',
  your_contact_details: 'Your contact details',
  add_attachment: 'Add Attachment',
  item_details: 'Item Details',
  edit_item: 'Edit Item',
  all_details: 'All Details...',
  save_this_item: 'Save this item',
  more_from_this: ' More From This',
  set: 'Set',
  oops: 'Oops!',
  item_is_not_available_anymore: 'This item is not available anymore.',
  pro_tip: 'Pro tip:',
  move_faster_next_time: 'Move faster next time. Good deals fly! ;)',
  go_back: 'Go Back',
  sorry: 'Sorry!',
  could_not_find_item: 'We could not find this item',
  item_sku_exist: 'Item already exists. Please, change the SKU',
  invalid_format: 'Model is not valid',
  item_does_not_exist: 'Entity with a given ID doesn’t exist',
  item_exists: 'Item already exists',
  item_was_deleted: 'Item was deleted',
  /* jewelry end */

  /* login */
  account_log_in: 'Account Log In',
  dont_have_an_account: "Don't have an account?",
  choose_a_plan: 'Choose a Plan',
  your_device_limit_has_been_reached: 'Your device limit has been reached.',
  your_rapnet_account_is_being: 'Your RapNet account is being accessed by too many devices',
  please_contact: 'Please contact',
  customer_service: 'customer service',
  secure_your_account: 'secure your account.',
  your_device_is_not_recognized: 'Your device is not recognized.',
  please_log_in_again: 'Please log in again.',
  your_account_verification: 'Your account verification is incomplete.',
  contact_your_local_customer:
    'Contact your local customer service office to complete your verification.',
  your_subscription_has_expired: 'Your subscription has expired.',
  please_add_a_credit_card_through_the: 'Please add a credit card through the',
  or_contact_customer_service: 'or contact customer service for assistance.',
  your_rapnet_trial_has_expired: 'Your RapNet Trial has expired.',
  to_see_your_upgrade: 'To see your upgrade options',
  or: 'or',
  contact: 'Contact',
  a_local_rapnet_representative: 'a local RapNet representative.',
  all_content_copyright: 'All Content © Copyright 1982-2025 by Rapaport USA Inc',
  all_rights_reserved: 'All rights reserved',
  /* login end */

  /* Messaging */
  messaging: 'Messaging',
  similar_diamonds_price_distribution: 'Similar Diamonds Price Distribution',
  no_data_to_display_for_this_diamond: 'No data to display for this diamond',
  diamond_clicks: 'Diamond Clicks',
  number_of_clicks_this_week: 'Number of clicks this week',
  search_results_ranking: 'Search Results Ranking',
  out_of: 'Out of',
  similar_diamonds: 'similar diamonds',
  pricing_serformance_simulator: 'Pricing Performance Simulator',
  this_is_an_estimate_intended_to_give:
    'This is an estimate intended to give you a better idea of how your pricing will compare to the same diamonds in the market. The figure is only an estimation and does not guarantee results.',
  check_new_ranking: 'Check New Ranking',
  update_diamond_price: ' Update Diamond Price',
  add_to: 'Add to',
  remove_from: 'Remove from',
  change_status: 'Change Status',
  guaranteed_availability: 'Guaranteed Availability (G)',
  out_on_memo: 'Out On Memo (M)',
  subject_to_prior: 'Subject to Prior Sale (STPS)',
  not_available: 'Not Available (NA)',
  beta_upper_case: 'BETA',
  new_beta_feature: 'New Beta Feature',
  overview: 'Overview',
  ranking: 'Ranking',
  my_listings: 'My Listings',
  reset_filters: 'Reset Filters',
  position_this_diamond: 'Position this diamond',
  raplist: 'Raplist',
  note: 'Note',
  cash_price: 'Cash Price',
  quota_exceeded: 'Quota Exceeded',
  own_stock: 'Own Stock',
  potential_investment: 'Potential Investment',
  blocked: 'Blocked',
  are_you_sure_you_want_to_delete_these: 'Are you sure you want to delete these diamonds?',
  edit_diamond: 'Edit Diamond',
  update: 'Update',
  total_value_of_diamonds_listed_on: 'Total value of diamonds listed on RapNet',
  total_value_of_diamonds: 'Total value of diamonds exceeding quota',
  blocked_diamonds: 'Blocked diamonds',
  rap_upper_case_persent: 'RAP%',
  show_only_diamonds_i_listed_on: 'Show only diamonds I listed on',
  edit_registration_for: 'Edit Registration for',
  register_your_booth_for: 'Register your booth for',
  you_must_register_your_booth: 'You must register your booth for your diamonds to be listed on ',
  rapnet_diamond_listing_service: 'RapNet Diamond Listing Service - Exhibitor Registration',
  you_are_not_authorized_to_view_this:
    'You are not authorized to view this content. Please contact your account admin.',
  /* Messaging end */

  /* search  */
  contact_rapnet: 'Contact RapNet',
  retrieving_older_messages: 'Retrieving older messages...',
  for_instant_inventory: 'for Instant Inventory',
  diamond_request_details: ' Diamond Request Details',
  customer_name: 'Customer name',
  rapne_price: 'RapNet Price',
  your_price_total_usd: 'Your Price (Total USD)',
  your_price_total: 'Your Price (Total',
  selling: 'Selling',
  buying: 'Buying',
  agreeing_to_all_terms: ' Agreeing to all terms',
  invoice: 'Invoice',
  agreed_on: 'Agreed on ',
  buyer: 'Buyer',
  view_results: 'View Results',
  diamonds_details: 'Diamonds Details',
  type: 'Type',
  avg_size: 'Avg. Size',
  amount: 'Amount',
  avg_color: 'Avg. Color',
  sieve: 'Sieve',
  avg_clarity: 'Avg. Clarity',
  comment: 'Comment',
  total_size: 'Total Size',
  parcel_and_bundle_besults: 'Parcel & Bundle Results',
  totals_for_this_page: 'Totals for this page',
  average_price_slash_ct: 'Average Price/Ct',
  some_results_may_not_be_displayed_due_to_seller:
    'Some results may not be displayed due to seller permissions',
  no_price_changes_between: 'No price changes between',
  and: 'and',
  number_of: 'Number of',
  rapaport_price_list_changes: 'Rapaport Price List Changes',
  changes: 'changes',
  round_prices: 'Round Prices',
  pear_prices: 'Pear Prices',
  all_data_files_in_zip_format: 'All data files in Zip format',
  updated: 'Updated',
  rapaport_price_list: 'Rapaport Price List',
  rapaport_diamonds_prices_pdf_format: 'Rapaport Diamond Prices - PDF Format',
  round_and_pear_price_lists_updated_on_thursday_midnight_nytime:
    'Round and Pear price lists updated on Thursday Midnight NY time',
  parcel_price_lists_updated: 'Parcel Price Lists updated on the first of the month',
  rapaport_price_list_in_rupees: 'Rapaport Price List In Rupees',
  prices_in_other_data_formats: 'Prices In Other Data Formats',
  rapaport_diamonds_specifications_upper_case: 'RAPAPORT DIAMONDS SPECIFICATIONS',
  the_rapaport_price_list_is_based_on_rapaport_diamond_specification_a3:
    'The Rapaport Price List is based on Rapaport Diamond Specification A3',
  effective_april_13_2015_the_rapaport:
    'Effective April 13, 2015, The Rapaport Price List will be based on the new "Rapaport Diamond Specification A3"',
  rapnet_the_rapaport_diamond_trading:
    'RapNet, the Rapaport Diamond Trading Network will be enabling the characterization and sorting of diamonds based on the new specifications in the near future',
  the_diamond_specifications: 'The diamond specifications are subject to change',
  the_diamond_specifications_are_subject_to_change:
    'The diamond specifications are subject to change. Members of the diamond trade are encouraged to comment on the specifications via email to ',
  minimum_millimeters_for_rapspecs_a_and_a: 'Minimum Millimeters for RapSpecs A1 & A2',
  delete_saved_searches: 'Delete Saved Searches',
  are_you_sure_you_want_to_delete_all_saved_searches:
    'Are you sure you want to delete all saved searches? All the below saved searches will no longer appear in this list and you will no longer receive any match notifications for these searches',
  saved_searches: 'Saved Searches',
  all_searches: 'All searches',
  there_are_no_saved_searches: 'There are no saved searches',
  delete_saved_search: 'Delete Saved Search',
  are_you_sure_you_want_to_delete_this_saved_search:
    'Are you sure you want to delete this saved search?',
  notify_me: 'Notify me',
  daily: 'Daily',
  immediately: 'Immediately',
  group_name: 'Group Name',
  submit_upper_case: 'SUBMIT',
  you_have_exceeded_the_column_limit: 'You have exceeded the column limit',
  advanced_settings: 'Advanced settings',
  use_advanced_settings: 'Use advanced settings',
  markup_percent: 'Markup Percent',
  percent_of_price_e_g: '*percent of price, e.g 110 is 10% over the actual price',
  we_recommend_you_print_this_report:
    "*We recommend you print this report using the landscape option. You can set this in yourprinter's properties",
  save_pdf: 'Save PDF',
  view_video: 'view video',
  view_report: 'view report',
  enter_group_name: 'Enter group name...',
  view_image: 'view image',
  attach_certificate: 'Attach Certificate',
  create_new: 'Create New',
  /* search end */

  /* settings */
  current_plan: 'Current Plan',
  your_plan_subscription_will_expire_on: 'Your plan subscription will expire on',
  no_action_is_necessary_on_your_part: 'No action is necessary on your part',
  manage_your_plans: 'Manage your plans',
  sizes: 'Sizes',
  must_be_less_than: 'Must be less than',
  must_be_greater_than: 'Must be greater than',
  properties_flexibility: 'Properties Flexibility',
  define_the_flexibility_of_the_diamond_properties:
    'Define the flexibility of the diamond properties',
  for_example_if_you_select_low_flexibility:
    "For example, if you select Low Flexibility (-/+1), the result you'll get for a diamond color E will include D",
  non_flexible: 'Non Flexible',
  what_is_flexibility: 'What is Flexibility',
  exact_value: 'Exact value',
  low_flexibility: 'Low Flexibility',
  medium_flexibility: 'Medium Flexibility',
  high_flexibility: 'High Flexibility',
  exact_and_better: 'Exact And Better',
  exact_value_and_higher: 'Exact value and higher',
  size_groups_preferences: 'Size Groups Preferences',
  use_rapnets_default_pricing_group: "Use RapNet's default pricing group",
  use_customized_pricing_group: 'Use customized pricing group',
  email_notifications: 'Email Notifications',
  send_all_notifications_to: ' Send all notifications to',
  notify_me_regularly_if_my_trades_have_been_updated_in_trade_center:
    'Notify me regularly if my trades have been updated in Trade Center',
  language: 'Language',
  enter_member_slash_company: 'Enter Member/Company or Rap ID...',
  blocked_accounts: 'Blocked Accounts',
  to_prevent_your_listings_being_displayed:
    'To prevent your listings from being displayed to a particular member, add the name to the list below',
  to_prevent_diamonds_from_a_particular_member:
    'To prevent diamonds from a particular member appearing in your search results, add the name to the list below',
  download_specification: 'Download Specification',
  specify_which_of_your_stones: 'Specify which of your stones are allowed in downloads',
  guaranteed: 'Guaranteed',
  on_memo: 'On Memo',
  subject_to_prior_sale: 'Subject to Prior Sale',
  notify_seller_forwarded_to_head_office: 'Notify seller forwarded to head office',
  billing_address: 'Billing Address',
  enter_zip_code: 'Enter zip Code',
  zip_code: 'Zip Code',
  enter_address: 'Enter address',
  address: 'Address',
  enter_additional_address: 'Enter Additional Address',
  additional_address: 'Additional Address',
  business_details: 'Business Details',
  enter_registration_number: 'Enter Registration Number',
  registration_number: 'Registration Number',
  company_logo: 'Company Logo',
  drop_or_upload: 'Drop or Upload',
  drag: 'Drag',
  upload_your_company_logo_in_png:
    "Upload your company logo in PNG, JPG or SVG format only. Image size shouldn't be bigger than 2 MB. Recommended dimension of image is 150X75",
  contact_details: 'Contact Details',
  enter_phone: 'Enter phone',
  enter_fax: 'Enter Fax',
  enter_website: 'Enter website',
  enter_email: 'Enter Email',
  document_numbering: 'Document Numbering',
  enter_invoice_baseline_number: 'Enter Invoice Baseline Number',
  invoice_baseline_number: 'Invoice Baseline Number',
  preview_invoice: 'Preview Invoice',
  invoice_preview: 'Invoice Preview',
  purchase_order: 'Purchase order',
  payment_method: 'Payment Method',
  pay_within_days: 'Pay Within Days',
  returns: 'Returns',
  return_within_days: 'Return Within Days',
  returns_accepted: 'Returns Accepted',
  shipping: 'Shipping',
  default_shipping_location: 'Default Shipping Location',
  paid_by: 'Paid By',
  transactions: 'Transactions',
  load_default: 'Load Default',
  enter_contact_person: 'Enter Contact Person',
  term_sheet: 'Term Sheet',
  manage_listings: 'Manage Listings',
  permissions: 'Permissions',
  settings: 'Settings',
  no_tabs: 'no tabs',
  users: 'Users',
  chat_settings: 'Chat Settings',
  account_relations: 'Account Relations',
  shipping_details: 'Shipping Details',
  invoice_template: 'Invoice Template',
  listings_permissions: 'Listings Permissions',
  blocking: 'Blocking',
  trade_can_only_be_viewed: 'Trades can only be viewed by the Account Holder and Assigned Members',
  access_key: 'Access Key',
  access_keys: 'Access Keys',
  settings_preferences: 'Settings & Preferences',
  /* settings end */

  /* show-listings */
  thank_you_for_registering: 'Thank you for registering',
  your_contact_information_is_now_live_in_show_listings:
    ' Your contact information is now live in Show Listings and can be viewed by thousands of buyers worldwide prior to and during the show.',
  to_ensure_that_buyers_have_access_to_your_diamond:
    'To ensure that buyers have access to your diamond listings, we recommend that you upload the diamonds that you will be selling at the show as soon as possible.',
  rapnet_show_listings_is_used_by_thousands_of_people:
    'RapNet Show Listings is used by thousands of people to find diamonds at major industry trade shows. If you’re an exhibitor, you can list your diamonds and allow buyers to ',
  easily_find_you_if_youre_a_buyer_you_can_find:
    'easily find you. If you’re a buyer, you can find the diamonds and suppliers you need, fast and effortlessly. Search results include details such as booth number and contact information. This service is provided by RapNet as part of your membership.',
  enter_company_name: 'Enter Company Name',
  enter_the_url_of_the_widget: 'Enter the URL of the widget location',
  company_website: 'Company Website',
  company_email_address: 'Company Email Address',
  enter_contacts_name: "Enter Contact's name",
  contacts_name_at_show: "Contact's name at Show",
  enter_phone_number: 'Enter phone Number',
  contact_persons_phone: 'Contact Person’s Telephone (at show)',
  contact_persons_email: 'Contact Person’s Email (at show)',
  enter_booth_number: 'Enter Booth Number',
  your_booth_number: 'Your Booth Number',
  enter_booth_location: 'Enter Booth Location',
  booth_location: 'Booth Location',
  description_of_company: 'Description of Company:',
  clear_details: 'Clear Details',
  save_slash_register: 'Save/Register',
  sign_agreement_upper_case: ' SIGN AGREEMENT',
  i_agree_upper_case: 'I AGREE',
  company_profile: 'Company Profile',
  personal_profile: 'Personal Profile',
  refer_a_friend: 'Refer a Friend',
  rapnet_classic: 'RapNet Classic',
  log_off: 'Log off',
  this_free_trial_version: 'This free trial version will expire in',
  get_full_acces_upper_case: 'GET FULL ACCESS',
  get_full_acces: 'Get full access',
  dashboard: 'Dashboard',
  find_diamonds: 'Find Diamonds',
  find_jewelry: 'Find Jewelry',
  trade_center: 'Trade Center',
  my_diamonds: 'My Diamonds',
  my_diamond_listings: 'My Diamond Listings',
  upload_diamonds: 'Upload Diamonds',
  upload_history: 'Upload History',
  my_jewelry: 'My Jewelry',
  my_jewelry_listings: 'My Jewelry Listings',
  media_management: 'Media Management',
  upload_jewelry: 'Upload Jewelry',
  search_tools: 'Search Tools',
  saved_search: 'Saved Search',
  tracked_diamonds: 'Tracked Diamonds',
  investment_grade: 'Investment Grade',
  archived_messages: 'Archived Messages',
  prices: 'Prices',
  tradescreen: 'TradeScreen',
  price_changes: 'Price Changes',
  rapSpecs: 'RapSpecs',
  rapnet_price_list: 'RapNet Price List',
  member_directory: 'Member Directory',
  tools: 'Tools',
  rapnet_xl: 'RapNet XL',
  technet_and_apis: 'Technet & APIs',
  videos: 'Videos',
  support_center: 'Support Center',
  video_tutorials: 'Video Tutorials',
  product_updates: 'Product Updates',
  notifications: 'Notifications',
  tracked_group: 'Tracked group',
  delete_tracked_group: 'Delete Tracked Group',
  are_you_sure_you_want_to_delete_this: 'Are you sure you want to delete this tracked group?',
  edit_group_name: 'Edit Group Name',
  view_this_group: 'View this group',
  update_upper_case: 'UPDATE',
  /* show-listings end */

  /* trade */
  singles: 'Singles',
  groups: 'Groups',
  mark_all_as_unread: 'Mark all as unread',
  mark_all_as_read: 'Mark all as read',
  delete_offer: 'Delete Offer',
  this_action_will_delete_this_offer_permanently:
    'This action will delete this offer permanently. Are you sure you want to proceed?',
  mark_as_read: 'Mark as read',
  mark_as_unread: 'Mark as unread',
  delete_all_offers: 'Delete All Offers',
  this_action_will_delete_this_negotiation:
    'This action will delete this negotiation and all related offers. Are you sure you want to proceed?',
  delete_all_negotiations: 'Delete All Negotiations',
  delete_negotiations_message:
    'This action will delete the selected negotiations permanently. Are you sure you want to proceed?',
  delete_offers_message:
    'This action will delete the selected offers permanently. Are you sure you want to proceed?',
  search_for_buyer: 'Search for buyer',
  view_offers_from_this_buyer: 'View offers from this buyer',
  agreement_signed: 'Agreement signed: Negotiation Completed!',
  negotiation_completed: 'negotiation completed',
  this_offer_has_expired: 'this offer has expired',
  the_negotiation_was_reopened: 'the negotiation was reopened',
  item_type: 'Item Type',
  diamond: 'Diamond',
  founded: 'Founded',
  member_for: 'Member for',
  about: 'About',
  endorsements: 'Endorsements',
  members: 'Members',
  delete_item: 'Delete Item',
  this_action_will_delete_this_item:
    'This action will delete this item from negotiation. Are you sure you want to proceed?',
  parcel: 'Parcel',
  lot_number: 'Lot Number',
  avgsize: 'Avg.Size',
  sieve_no: 'Sieve No',
  term_sheet_agreement_upper_case: 'TERM SHEET AGREEMENT',
  send_standard_invoice: 'Send standard Invoice',
  send_purchase_order: 'Send purchase order',
  agreement_signed_first_letter_upper_case: 'Agreement Signed',
  mark_as_completed_upper_case: 'MARK AS COMPLETED',
  send_invoice_upper_case: 'SEND INVOICE',
  view_invoice_upper_case: 'VIEW INVOICE',
  payment_due_date: 'Payment Due Date',
  invoice_no: 'Invoice No.',
  purchase_no: 'Purchase No.',
  cansel_upper_case: 'CANCEL',
  preview_invoice_upper_case: 'PREVIEW INVOICE',
  preview_purchase_order_upper_case: 'PREVIEW PURCHASE ORDER',
  issue_invoice_upper_case: 'ISSUE INVOICE',
  issue_purchase_order_upper_case: 'ISSUE PURCHASE ORDER',
  you_agreed_and_signed: 'You Agreed & Signed',
  waiting_for: 'Waiting for',
  agreement: 'agreement',
  cancel_agreement: 'Cancel Agreement',
  agree_and_sign: 'Agree and Sign',
  by_clicking_agree_and_sign:
    'By clicking agree and sign, you are committing to the terms of the deal.\n This is a binding commitment and, in the best of diamond traditions, is the electronic equivalent of saying "Mazal U\'Bracha". Mazal U\'Bracha means "Fortune and Blessings" and signifies a deep commitment to honor the terms of the deal. One\'s reputation is at stake if a "Mazal" commitment is not honored.',
  agree_and_sign_upper_case: 'AGREE AND SIGN',
  enter_your_comment: 'Enter your comment here...',
  pay_within: 'Pay Within',
  within: 'within',
  shipping_address: 'Shipping Address',
  buyers_address: "Buyer's address",
  my_location_pickup_by_buyer: 'My location (pickup by buyer)',
  other: 'Other',
  enter_shipping_address: 'Enter Shipping Address',
  shipping_price: 'Shipping Price',
  term_description: 'Term description...',
  payment_terms: 'Payment Terms',
  transaction: 'Transaction',
  shipping_terms: 'Shipping Terms',
  trading_terms: 'Trading Terms',
  comments: 'Comments',
  additions: 'Additions',
  add_another_term: 'Add another term',
  your_price_upper_case: 'YOUR PRICE',
  update_price_upper_case: 'UPDATE PRICE',
  sent_on: 'Sent on',
  edit_price: 'Edit Price',
  match_price_upper_case: 'MATCH PRICE',
  price_upper_case: 'PRICE',
  yes_within: 'Yes within',
  yes: 'Yes',
  no: 'No',
  final_price: 'Final Price',
  price_match_upper_case: 'PRICES MATCH',
  shipping_location: 'Shipping Location',
  additional_terms: 'Additional Terms',
  once_you_edit_the_price_the: 'Once you edit the price, the',
  will_be_notified_of_it: 'will be notified of it. Are you sure you want to edit the price?',
  keep_prise_upper_case: 'KEEP PRICE',
  edit_price_upper_case: 'EDIT PRICE',
  cancel_edit_terms: 'Cancel Edit Terms',
  edit_terms: 'Edit Terms',
  not_graded: 'Not Graded',
  assigned_to_upper_case: 'ASSIGNED TO',
  cancel_offer: 'Cancel offer',
  are_you_sure_you_want_to_cancel: 'Are you sure you want to cancel this offer?',
  view_profile: 'View profile',
  trading: 'Trading',
  trading_details: 'Trading Details',
  no_terms_agreed_and_signed_for_this_offer: 'No terms agreed and signed for this offer',
  activity_log: 'Activity Log',
  company_details: 'Company Details',
  ppc: 'PPC',
  jewelry: 'Jewelry',
  by_status: 'By Status',
  by_read_status: 'By Read Status',
  assigned_to: 'Assigned to',
  active_slash_inactive_only: 'Active/ Inactive Only',
  active_trades: 'Active Trades',
  inactive_trades: 'Inactive Trades',
  completed_cancelled_expired: '(Completed, Cancelled, Expired)',
  filtered_by_buyer: 'Filtered by Buyer',
  filter: 'Filter',
  apply_upper_case: 'APPLY',
  filters_upper_case: 'FILTERS',
  new: 'New',
  newest_first: 'Newest First',
  last_activity: 'Last Activity',
  showing_all: 'Showing all',
  here: 'here',
  click: 'Click',
  to_see_latest: 'to see latest',
  there_are_no_trades_to_show: 'There are no trades to show',
  by_type: 'By Type',
  select_saved_filter: 'Select Saved Filter',
  saved_filter_name: 'Saved Filter Name',
  view_all_sizes: 'View All Sizes',
  for_detailed_instruction_and_allowed:
    'for detailed instructions and allowed values. After uploading your stock, click on',
  to_upload_images: 'to upload images',
  select_file: 'Select File',
  drop_file_here_or: 'Drop File Here Or',
  options: 'Options',
  replace_all: 'Replace All',
  lots_not_included: 'Lots not included in the upload will be deleted.',
  add_and_update: 'Add & Update',
  new_lots_will_be_added_and_existing:
    'New lots will be added and existing lots will be updated. Lots not included will remain untouched.',
  send_an_upload_report_now_to_my_email: 'Send an upload report now to my email',
  send_me_report_by_email: 'Send me report by email',
  upload_file: 'Upload File',
  seller_spec: 'Seller Spec',
  asking_price: 'Asking Price',
  ct_upper_case: 'CT',
  location_must_be_selected_with: 'Location must be selected with Guaranteed Available diamond',
  stock_number: 'Stock Number',
  is_pair_separable: 'Is Pair Separable',
  allows_approved_members_to_download_this:
    'Allows approved members to download this diamond via Download Listing Services or Instant Inventory.',
  trade_show: 'Trade Show',
  there_are_no_active_trade_shows: 'There are no active trade shows',
  enter_size: 'Enter size...',
  diamond_with_gia: 'Diamond with GIA cannot have clarity of SI3',
  enter_length: 'Enter length...',
  enter_width: 'Enter width...',
  enter_depth: 'Enter depth...',
  enter_table: 'Enter table...',
  enter_angle: 'Enter angle...',
  height: 'Height',
  enter_height: 'Enter height...',
  min_dot: 'Min.',
  max_dot: 'Max.',
  girdle_persent: 'Girdle %',
  laser_inscription: 'Laser Inscription',
  fancy_color: 'Fancy Color',
  type_link_here: 'Type Link Here',
  not_found: 'Not found',
  upload_link: 'Upload Link',
  general_information: 'General Information',
  report_nformation: 'Report Information',
  other_information: 'Other Information',
  images_and_report_scans: 'Images and Report Scans',
  additional_diamond_information: 'Additional Diamond Information',
  save_lot: 'Save Lot',
  report_file: 'Report File',
  browse_upper_case: 'BROWSE',
  diamond_image: 'Diamond Image',
  download_this_stock: 'Download this stock',
  sarine_loupe: 'Sarine Loupe',
  sarine_id: 'Sarine ID',
  repeat_this_upload: 'Repeat this upload',
  download_invalid_diamonds: 'Download invalid diamonds',
  replaced_stock: 'Replaced Stock',
  status: 'Status',
  lots_received: 'Lots Received',
  valid_lots: 'Valid Lots',
  invalid_lots: 'Invalid/Pending Lots',
  includes_invalid_lots:
    'Includes invalid lots \nor lots pending confirmation \nfrom GIA of gemological details',
  duration: 'Duration',
  added: 'Added',
  export_the_above_list: ' Export the above list of missing values to a CSV file',
  cancel_the_upload: 'Cancel the upload',
  fill_out_the_missing_values: 'Fill out the missing values and upload the file again',
  upload_your_stock_listings:
    'Upload your stock listings without the items that include missing values',
  discard: 'Discard',
  skip: 'Skip',
  import_multiple_jewelry_listings: 'Import multiple jewelry listings',
  acceptable_file_type: 'Acceptable file type',
  download_template: 'Download template',
  for_further_information: 'For upload instruction and guidance. read this article.',
  jewelry_manual: 'Jewelry Manual',
  click_here_for_the_instructions:
    'Click here for instructions how to list jewelry items with multiple stones/metals/images.',
  upload_multiple_jewelry_items: 'Upload Multiple Jewelry Items',
  create_listings: 'Create Listings',
  please_match_the_columns:
    'Please match the columns in your uploaded file to RapNet Jewelry fields',
  there_are_empty_required_columns: 'There are empty required columns',
  please_fill_them: 'Please fill them and reupload your CSV file',
  note_here_are_missing:
    'Note: There are missing values in your CSV file, please select one of the actions below',
  your_value: 'Your Value',
  appearances: 'Appearances',
  correction: 'Correction',
  are_you_sure_you_want_to_delete_this_value: 'Are you sure you want to delete this value?',
  please_review_the_column_values_below: 'Please review the column values below',
  if_you_notice_incorrect_values:
    'If you notice incorrect values, you can either replace them or remove them by clicking on the edit icon',
  number_of_incorrect_values: 'Number of incorrect values',
  note_please_recheck_your_skus:
    "Note: please recheck your SKUs and select which you don't want to add/replace",
  existing_product_skus: 'Existing Product SKUs',
  new_product_skus: 'New Product SKUs',
  import_listings: 'Import Listings',
  upload_multiple_images: 'Upload Multiple Images',
  acceptable_file_types: 'Acceptable file types: JPEG, JPG, PNG or ZIP files',
  make_sure_that_the_images: 'Make sure that the images are at least 1280px wide',
  the_best_photos_use_natural:
    'The best photos use natural or diffused lighting, and don’t use a flash',
  make_sure_that_the_images_titles:
    'Make sure that the images titles are similar to the titles in the uploaded listings file',
  please_wait_for_all: 'Please wait for all images to be processed',
  all_images_were_uploaded_successfully: 'All images were uploaded successfully',
  unable_to_upload_the_images_below:
    'Unable to upload the image(s) below: the image(s) dimensions are smaller than the requirements.',
  next: 'Next',
  there_is_a_column_without_a_title:
    'WARNING! There is a column without a title in your file which has values, please complete it and upload the file again',
  want_to_upload_multiple_jewelry_items: ' Want to upload multiple jewelry items? ',
  contact_us_at: " Contact us at product@diamonds.net and we'll be happy to assist",
  multiple: 'Multiple',
  single: 'Single',
  media_files: 'Media Files',
  buy: 'Buy',
  sell: 'Sell',
  account_settings: 'Account Settings',
  export_to_excel: 'Export to Excel',
  days: 'days',
  /* trade end */

  /* instant inventory */
  guarateed_available: 'Guaranteed Available',
  guaranteed_available_tooltip:
    'Note: Guaranteed Available means the seller has immediate access to the diamond. Selecting this option will reduce the amount of diamonds in your feed',
  with_scanned_ceritifcates: 'With scanned reports',
  /* instant inventory end */

  /* chat */
  typing: 'typing',
  search_or_start_new_chat: 'Search or start new chat',
  file_size_must_be_less_than: 'File size must be less than',
  file_type_is_invalid: 'File type is invalid',
  reply_to_message: 'Reply to message...',
  notification_settings: 'Notification Settings',
  expiration_date: 'Expiration Date (Limit/Default: 2 weeks from now)',
  parcel_type: 'Parcel Type',
  pieces_per_carat: 'Pieces Per Carat',
  advanced_measurements: 'Advanced Measurements',
  only_available_diamonds: 'Only Available Diamonds',
  cash_price_only: 'Cash Price Only',
  blocked_only: 'Blocked Only',
  cert_images: 'Cert Images PDF',
  show_with_reports: 'Show with PDF',
  show_auto_added_reports: 'Show Auto-Added Reports',
  date_created: 'Date Created',
  date_expires: 'Date Expires',
  only_with_images: 'Only With Images',
  only_wo_images: 'Only W/O Images',
  show_only_own_stock: 'Show Only Own Stock',
  show_only_quota_exceeded: 'Show Only Quota Exceeded',
  with_photos: 'With Photos',
  with_video: 'With Video',
  with_lab_report: 'With Lab report',
  latest_listings: 'Latest Listings',
  matched_pairs: 'Matched Pairs',
  guaranteed_available: 'Guaranteed Available',
  laser_drilled: 'Laser Drilled',
  clarity_enhanced: 'Clarity Enhanced',
  color_ecnhanced: 'Color Enhanced',
  irradiated: 'Irradiated',
  other_treatment: 'Other Treatment',
  hpht: 'HPHT',
  invalid_file_type: 'Invalid file type',
  file_larger_than: 'File larger than ',
  uploade_faild: 'Upload failed',
  uploaded: 'uploaded',
  failed_upload_again: 'failed. upload again',
  remove_from_list: 'Remove from list',
  were_sorry_something_went_wrong: "We're sorry, something went wrong",
  Click: 'Click',
  to_refresh_the_page_or: 'to refresh the page or',
  to_redirect_to_dashboard: 'to redirect to Dashboard',
  choose_file_which_you_want_to_upload: 'Choose file which you want to upload',
  kb_upper_case: 'KB',
  remove_upper_case: 'REMOVE',
  files_are_not_supported: 'file(s) are not supported',
  size_limit: 'Unable to upload files larger than 500MB',
  please_try_again: 'Please try again',
  try_again: 'Try Again',
  something_went_wrong: 'Something went wrong',
  the_file_couldnt_be_uploaded: ' The file couldn’t be uploaded',
  uploaded_first_letter_upper_case: 'Uploaded',
  failed: 'Failed',
  image: 'image',
  save_changes_upper_case: 'SAVE CHANGES',
  delete_image: 'Delete Image',
  are_you_sure_you_want_to_delete_image: 'Are you sure you want to delete image',
  edit_image_name: 'Edit image name',
  unmatched: 'Unmatched',
  matched: 'Matched',
  cancel_upper_case: 'CANCEL',
  no_images_connected_to_items: 'No image(s) connected to item(s)',
  there_are_no_unmatched_images: 'There are no unmatched images',
  no_images_uploaded_by_you: 'No image(s) uploaded by you',
  there_are_no_results_matching_these_criteria: 'There are no results matching these criteria',
  clear: 'Clear',
  to_try_again: 'to try again',
  features: 'Features',
  materials: 'Materials',
  stones: 'Stones',
  show_more: 'Show More',
  show_less: 'Show Less',
  no_image_uploaded: 'No image uploaded',
  no_video_uploaded: 'No video uploaded',
  labratory_report: 'Laboratory Report',
  check_report: 'Check Report',
  email_report: 'Email Report',
  no_report_uploaded: 'No Report Uploaded',
  lab_report: 'Lab Report',
  no_diagram_uploaded: 'No diagram uploaded',
  certificate_information: 'Certificate information',
  verified: 'Verified',
  submitted: 'Submitted',
  register_to_bid: 'Register to bid',
  once_you_have_completed_the_verification_process:
    'Once you have been approved to bid, you’ll be able to find great deals on hundreds of diamonds that are priced to sell on April 15 & 16.',
  error_unable_to_load_data: 'Error - unable to load data',
  youre_good_to_go_your_account_is_all_set:
    'You are approved to bid.  All bids are binding and cannot be deleted.',
  application_pending_reviewed: 'Your application has been received and is pending review.',
  results_first_upper_case: 'Results',
  get_full_access: 'Get Full Access',
  total_upper_case: 'TOTAL',
  please_specify_what_is_wrong: 'Please specify what is wrong with this diamond listing',
  jewelry_certificate: 'Jewelry Certificate',
  parent_stock_number: 'Parent Stock Number',
  manufacture_date: 'Manufacture Date',
  fluorescence_intensity: 'Fluorescence Intensity',
  fluorescence_color: 'Fluorescence Color',
  main_color: 'Main Color',
  secondary_color: 'Secondary Color',
  fancy_color_overtone: 'Fancy Color Overtone',
  jewelry_total_weight: 'Jewelry Total Weight',
  jewelry_total_length: 'Jewelry Total Length',
  jewelry_total_width: 'Jewelry Total Width',
  jewelry_location: 'Jewelry Location',
  jewelry_lab: 'Jewelry Lab',
  jewelry_brand: 'Jewelry Brand',
  jewelry_designer: 'Jewelry Design',
  jewelry_condition: 'Jewelry Condition',
  jewelry_state: 'Jewelry State',
  jewelry_collection: 'Jewelry Collection',
  jewelry_style: 'Jewelry Style',
  jewelry_material: 'Jewelry Material',
  material_weight: 'Material Weight',
  if_the_item_has_multiple: 'If the item has multiple diamonds set the minimum color scale',
  color_scale: 'Color Scale',
  style: 'Style',
  add_another_material_type: ' Add Another Material Type',
  add_another_stone_type: 'Add Another Stone Type',
  designer: 'Designer',
  currency: 'Currency',
  total_carat: 'Total Carat',
  if_the_item_has_multiple_diamonds: 'If the item has multiple diamonds set the minimum clarity',
  include_keywords_that_buyers: 'Include keywords that buyers would use to search for your item',
  start_with_a_brief_overview_that_describes:
    "Start with a brief overview that describes your item's finest features",
  select_as_main: 'Select as Main',
  tags: 'Tags',
  what_words_might_someone_use: 'What words might someone use to search for your listings?',
  use_all_tags_to_get_found: 'Use all 10 tags to get found. Please, separate them with a comma',
  material_karat: 'Material Karat',
  piece: 'piece',
  msrp_upper_case: 'MSRP',
  available_for_memo: 'Available for Memo',
  minimum_order_of: 'Minimum order of',
  item_is_currently_out_of_stock: 'Item is currently Out of Stock',
  select_from_existing_images: 'Select From Existing Images',
  upload_high_quality_images_acceptable_file_types:
    'Upload high-quality images. Acceptable file types: JPEG, JPG, PNG or ZIP archive. Images must have a minimum size of 1280X1280 pixels (HD size). The maximum supported ZIP archive size is 500MB',
  you_have: 'You have',
  invalid_images_please_remove_them:
    'invalid image(s). Please remove them from the list before saving the product.',
  video_optional: 'Video (Optional)',
  add_video_link_from: 'Add video link from YouTube, Vimeo or Picup Media',
  save_item: 'Save Item',
  please_fill_the_required_fields: 'Please fill the required fields',
  keywords: 'Keywords',
  image_and_video: 'Image & Video',
  existing_images: 'Existing images',
  re_order_sorting: 'Re-order sorting',
  all_notifications: 'All Notifications',
  diamond_nalysis_is_a_new_sophisticated_rapnet:
    '‘Diamond Analysis’ is a new sophisticated RapNet pricing tool that is being offered exclusively to Primary Suppliers. Your input is extremely important for us to improve RapNet’s pricing analysis tools, so please email your feedback to us at',
  this_graph_shows_how_many_times_your_diamond:
    'This graph shows how many times your diamond was clicked in the search results. All clicks are counted, including your own clicks',
  eye_clean_means_that: '”Eye Clean” means that',
  no_inclusions_black_white:
    'No inclusions (black, white, red or any other color) can be seen by a non-expert grader when viewing the diamond from a face-up position (looking at the table) with the naked eye',
  eye_clean_does_not_include:
    'Eye clean does not include looking at the diamond under any magnification (loupe, microscope etc…) or instrumentation',
  max_price: 'Max price',
  top_ten_price: 'Top 10% price',
  is_the_average_price_for_all_diamonds:
    'is the average price for all diamonds that fall into the same category as your diamond. The categories are calculated by selecting diamonds of similar shape, size, color, clarity, lab, cut, polish, symmetry and fluorescence to your diamond',
  is_the_cheapest_price: 'is the cheapest price of the diamond in this category',
  is_the_price_of_the_most_expensive: 'is the price of the most expensive diamond in this category',
  is_the_average_price_of_the: 'is the average price of the top 10% of diamonds in this category',
  for_more_information: 'For more information',
  report_numbers: 'Report Numbers',
  for_multiple_reports: "For multiple reports use ',' to separate",
  these_numbers_represent_your_diamond:
    'These numbers represent your diamond ranking in the search results, by price. Your diamond is compared to other diamonds of similar shape, size, color, clarity, lab, cut, polish, symmetry and fluorescence',
  uploads_waiting_to_be_processed: 'uploads waiting to be processed',
  start_time: 'Start Time',
  upload_type: 'Upload Type',
  Lots_received: 'Lots Received/Valid/Invalid',
  file_validation: 'File validation',
  preparing_for_database: 'Preparing for database',
  updating_database: 'Updating Database',
  you_have_unsaved_changes: 'You have unsaved changes',
  are_you_sure_you_want_to_leave: 'Are you sure you want to leave this tab?',
  show_without_reports: 'Show without PDF',
  export_failed_images_lis: 'Export Failed Images list',
  jewelry_upload_image_mapping_note: 'Click on an image to match/unmatch to the item',
  weight: 'Weight',
  upload_file_confirm_message: 'Are you sure you want to send this file: ',
  sold_by: 'Sold by',
  general_and_features: 'General & Features',
  gems: 'Gems',
  see_more: 'See more',
  see_less: 'See less',
  /* chat end */

  /* auction promo */
  rapnet_uppercase: 'RAPNET',
  live_uppercase: 'LIVE',
  live: 'Live',
  faq_uppercase: 'FAQ',
  terms_conditions_apply: 'Terms and Condition apply',
  terms_conditions: 'Terms & Conditions',
  deleted: 'Deleted',
  history: 'History',
  /* auction promo end */

  /* Auctions */
  current_bid: 'Current Bid',
  auctions: 'Auctions',
  auction: 'Auction',
  im_selling_transaction: 'Transactions',
  im_selling_waiting_response: 'Waiting for Response',
  im_selling_history: 'History',
  item_description: 'Item Description',
  reserve: 'Reserve',
  above_reserve: '% Above Reserve',
  response_required_by: 'Response Required By',
  select_placeholder: 'Select ...',
  max_bid_range_title: 'Percentage Above Reserve Price',
  min_bid_range_title: 'Percentage Below Reserve Price',
  min_reserve_price_tooltip:
    'Notify seller of bids that were below the reserve price to allow the seller to consider selling',
  min_reserve_price_title: 'Notify seller below reserve price',
  start_in: 'Start in',
  reports: 'Reports',
  in_process: 'In Process',
  button_download_csv: 'DOWNLOAD CSV',
  button_delete_all: 'Delete All',
  import_csv: 'Import CSV',
  load_listings: 'Load Listings',
  listings: 'Listings',
  listing_information: 'Listing Information',
  delete_listing: 'Delete Listing',
  reserve_price: 'Reserve Price',
  reserve_price_visible: 'Reserve Price Visible',
  insured_value: 'Insured Value',
  buy_now: 'BuyNow',
  delivery_locations: 'Delivery Locations',
  owner_accout_id: 'Owner account ID',
  there_are_no_listings: 'There are no listings to show',
  are_you_sure_you_want_to_delete_this_listing: 'Are you sure you want to delete this listing?',
  place_bid_message_modal_first_part: 'You are about to place a bid for',
  place_bid_message_modal_second_part: 'total.  This bid cannot be canceled',
  you: 'You',
  won: 'Won',
  you_have_won: 'You have won!',
  views: 'views',
  place_new_bid: 'Place New Bid',
  close: 'Close',
  current_highest_bid: 'Current Highest Bid',
  bids_placed: 'Bids Placed',
  end_date: 'End Date',
  sorry_you_can_not_add_more: 'Sorry, you can not add more than 50 items at a time',
  manage_my_jewelry: 'Manage My Jewelry',
  items: 'items',
  search_jewelry: 'Search Jewelry',
  catalog_lattice: 'Cat#',
  catalog_number: 'Catalog Number',
  track_selected: 'Track Selected',
  /* Auctions end */

  rapspecs: 'RapSpecs',
  pending_changes: 'You have pending changes',
  show_changes: 'Show Changes',
  hide_changes: 'Hide Changes',
  change_background_image: 'Change background image',
  send_message: 'Send Message',
  request_feedback: 'Request Feedback',
  request_endorsement: 'Request Endorsement',
  resize_logo: 'Resize Logo',
  resize_cover_image: 'Resize Cover Image',
  feedback_request: 'Feedback Request',
  endorsement_request: 'Endorsement Request',
  membership_valid_until: 'Membership: Valid until',
  company_size: 'Company Size',
  listing: 'Listing',
  member: 'Member',
  display_all_details: 'Display all details on my company’s public profile',
  enter_primary_address: 'Enter primary address...',
  enter_secondary_address: 'Apt, suite, etc...',
  enter_fax_number: 'Enter fax number...',
  enter_skype_username: 'Enter skype username...',
  enter_url: 'Enter URL',
  no_phone: 'No Phone',
  no_fax: 'No Fax',
  no_website: 'No Website',
  edit_contact_info: 'Edit Contact Information',
  edit_company_info: 'Edit Company’s Information',
  about_company: 'About the Company',
  no_available_info: 'There is no available information',
  display_company_description: 'Display company description on my public profile',
  insert_video_url: 'Insert video URL',
  primary_company_type: 'Primary Company Type',
  secondary_company_type: 'Second Company Type',
  third_company_type: 'Third Company Type',
  edit_trading_terms: 'Edit Trading Terms',
  information_not_provided: 'Information not provided by member',
  memos_return_polices: 'Memos and Return policies',
  memos_conditions: 'We offer sales on Memo. Conditions apply',
  write_notes: 'Write your notes here...',
  returns_subject_condition: 'Returns accepted, subject to condition',
  payment_options: 'Payment Options',
  bank_wire: 'Bank Wire',
  bank_wire_within: 'Bank wire within',
  cash_on_delivery: 'Cash on delivery',
  check: 'Check',
  credit_card: 'Credit Card',
  escrow: 'Escrow.com',
  additional_notes: 'Additional notes',
  shipping_options: 'Shipping Options',
  diamonds_shipping_time: 'Diamonds Shipping Time',
  diamonds_shipped_time: 'Diamonds will be shipped within',
  free_shipping: 'Free Shipping',
  shipping_fees: 'Shipping fees will apply based on buyer’s location',
  pick_up_available: 'Pick up available',
  additional_shipping_fees: 'Additional shipping fees (local taxes, etc.) to be paid by buyer',
  shipping_comment: 'Shipping Comment',
  shows_and_events: 'Shows and Events',
  create_new_event: 'Create new event',
  no_available_events: 'There aren’t any available events',
  event_name: 'Event name',
  enter_event_name: 'Enter event name...',
  company_booth_number: 'Company Booth Number',
  create_event: 'Create Event',
  update_event: 'Update Event',
  start_date: 'Start Date',
  venue_name: 'Venue Name',
  enter_venue_name: 'Enter Venue Name...',
  venue_address: 'Venue Address',
  enter_venue_address: 'Enter Venue Address...',
  details: 'Details',
  enter_event_details: 'Write more details about the event...',
  is_event_private: 'Is This Event Private?',
  edit_event: 'Edit Event',
  delete_event: 'Delete Event',
  confirm_delete_event: 'Are you sure you want to delete this event?',
  venue: 'Venue',
  booth: 'Booth',
  past_year: 'Past Year',
  all_time: 'All Time',
  write_feedback: 'Write a Feedback',
  edit_rate: 'Edit Rate',
  submit_rating: 'SUBMIT RATING',
  rating_tip: 'Negative ratings are published after 48 hours.',
  this_rating_is: 'This rating is:',
  positive: 'Positive',
  neutral: 'Neutral',
  negative: 'Negative',
  enter_comment: 'Enter comment...',
  reason_for_rating: 'Reason for rating:',
  i_bought: 'I Bought',
  i_sold: 'I Sold',
  memo_sale: 'Memo Sale',
  diamond_doesnot_exist: "Diamond Doesn't Exist",
  credit_problem: 'Credit Problem',
  rapnet_lot: 'RapNet Lot #',
  enter_rapnet_lot: 'Enter lot #...',
  enter_description: 'Enter description...',
  enter_price: 'Enter price...',
  days_due: 'Days due',
  enter_days_due: 'Enter days due...',
  confirm_rate_comment: 'I confirm that my comments are factual and avoid personal remarks',
  terms_agreement: 'I agree to the Ratings Terms and Conditions',
  please_agree_terms: 'Please agree to the terms and conditions',
  please_confirm: 'Please confirm',
  feedback: 'Feedback',
  ask_for_feedback: 'Ask for Feedback',
  no_available_feedback: "There isn't any available feedback",
  report_unfair_rating: 'Report unfair rating',
  send_report: 'Send Report',
  message_content: 'Message Content',
  post: 'Post',
  endorsement: 'Endorsement',
  endorse: 'Endorse',
  ask_for_endorsement: 'Ask For Endorsement',
  add_endorsement: 'Add Endorsement',
  who_do_you_want_to_ask: 'Who do you want to ask?',
  listed_diamonds: 'Listed Diamonds',
  guaranteed_listed: 'Guaranteed Listed',
  no_listings_found: 'No listings found for this account',
  edit_showcased_diamond_title: 'Edit Showcased Diamonds Title',
  add_diamonds_by_stock: 'Add diamonds by certificate#, lot# or stock#',
  write_personal_note: 'Write a Personal Note',
  add_new_note: 'Add new note',
  no_notes_found: 'No notes found for this account',
  user_settings: 'User Settings',
  allow_member_download_my_listings: 'Allow this member to download my listings',
  show_member_diamonds_in_my_search: "Show this member's diamonds in my search",
  you_can_download_member_listings: 'You can download this member’s listings',
  you_cannot_download_member_listings: 'You can not download this member’s listings',
  ask_download_permission: 'Ask Download Permission',
  ask_member_to_allow_download_listing:
    'Ask this member to allow you to download their listings by',
  or_phone: 'or phone',
  no_subject: 'No Subject',
  new_member: 'New Member',
  reached_max_num_of_members:
    'You have reached your maximum number of members! You cannot activate any new members.',
  or_contact_your_local: 'or contact your local',
  office_to_purchase_additional_activations: 'office to purchase additional activations',
  you_can_activate: 'You can activate',
  one: 'one',
  more_member_to_activate: 'more member or contact your local',
  no_any_available_members: "There aren't any available members",
  edit_member: 'Edit Member',
  rapnet_member_application_agreement: 'RapNet Member Application and Agreement',
  title: 'Title',
  last_name: 'Last Name',
  first_name: 'First Name',
  delete_member: 'Delete member',
  delete_member_confirm_modal_alert: 'Are you sure you want to delete this member?',
  deactivate_member: 'Deactivate member',
  activate_member: 'Activate member',
  job_title: 'Job Title',
  main_phone: 'Main Phone',
  mobile_phone: 'Mobile Phone',
  username: 'Username',
  password: 'Password',
  password_security: 'Password & Security',
  change_password: 'Change Password',
  show_in_member_directory: 'Show in Member Directory',
  click_to_see_id: 'Click to see ID',
  upload_scan_government_id:
    'Please upload a scan / photo of a current government issued ID (with photograph) for compliance purposes.',
  drag_drop_or_upload: 'Drag & Drop or Upload',
  government_issue_id: 'GOVERNMENT ISSUED ID',
  member_profile_is_not_available: 'This member profile is not available for viewing.',
  rapnet_rating_request: 'RapNet Rating Request',
  submit: 'Submit',
  sign_agreement: 'Sign Agreement',
  manage_bids: 'Manage Bids',
  are_you_sure_you_want_to_delete_this_bid: 'Are you sure you want to delete this bid?',
  delete_bid: 'Delete Bid',
  bids_no_to_show: 'There are no bids to show',
  bid: 'Bid',
  buyer_id: 'Buyer ID',
  buyer_company_name: 'Buyer Company Name',
  catalog_lattice_shot: 'Cat#',
  most_popular_items: 'Most Popular Items',
  show_statistic_for: 'Show statistics per:',
  top_bidders: 'Top Bidders',
  bid_placed: 'Bid Placed',
  bidder: 'Bidder',
  bidders: 'Bidders',
  account_id: 'Account ID',
  no_data_to_display_for_this_auction: 'No data to display for this auction',
  bids_over_reserve_price: 'Bids Over Reserve Price',
  average_bid: 'Average Bid',
  average_sale: 'Average Sale',
  items_sold: 'Items Sold',
  total_bids: 'Total Bids',
  total_bidders: 'Total Bidders',
  diamond_and_jewelry_trading: 'Diamond and Jewelry Trading',
  diamond_and_jewelry_auctions: 'Diamond and Jewelry Auctions',
  click_here_for_the: 'Click here for a full list of fields and values.',
  filelds_and_values: 'Fields and Values dictionary ',
  the_maximum_supported: 'The maximum supported ZIP archive size is 500MB.',
  reserveprice_met: 'Reserve Price Has Been Met',
  reserveprice_notmet: 'Reserve Price Not Met',

  /* Reports */
  my_reports: 'My Reports',
  date_submitted: 'Date submitted',
  number_of_rows: 'Number of rows',
  link: 'Link',
  read: 'Read',
  /* Reports End */

  /* Daily Deals */
  daily_deals: 'Daily Deals',
  manage_my_deals: 'Manage My Deals',
  image_first_letter_upper_case: 'Image',
  available_in: 'Available in',
  sold_upper_case: 'SOLD',
  expired_upper_case: 'EXPIRED',
  hurry: 'Hurry',
  ends_soon: 'ends soon',
  choose_existing_item: 'Choose Existing Item',
  search_by_stock_number: 'Search by #Stock Number',
  add_description: 'Add Description',
  important_note_price_must_be_final:
    'Important note: Price must be final, for cash transaction, in USD. Shipping is not included.',
  pricing: 'Pricing',
  total_price_in_cash: 'Total Price in Cash',
  rapport_office_location: 'Rapport Office Location',
  office_location: 'Office Location',
  select_type: 'Select Type',
  create: 'Create',
  col_dot: 'Col.',
  clr_dot: 'Clr.',
  pol_dot: 'Pol.',
  sym_dot: 'Sym.',
  post_new_deal: 'Post New Deal',
  expired_on: 'Expired on',
  expired: 'Expired',
  back_to_daily_deals: 'Back to Daily Deals',
  you_havent_posted: 'You haven`t posted a new deal in the last 24 hours.',
  manage_your_daily_deals: 'Manage Your Daily Deals',
  active_deals: 'Active Deals',
  there_are_no_deals: 'There are no previous deals',
  delete_daily_deal: 'Delete Daily Deal',
  are_you_sure_to_delete_this_deal: 'Are you sure you want to delete this daily deal?',
  before_you_continue: 'Before You Continue…',
  rapnets_goal_is_to_provide_the:
    'RapNet’s goal is to provide the most secure and trusted diamond trading network. To help us maintain the highest level of security, we require all sellers to agree to the terms listed below before posting a Daily Deal.',
  the_item_is_available_for_immediate_sale: 'The item is available for immediate sale',
  the_price_us_final_and_nonnegotiable: 'The price us final and non-negotiable',
  you_will_remove_the_deal_post:
    'You will remove the Daily Deal post immediately when it is sold or becomes unavailable',
  diamonds_sourced_from: 'Diamonds sourced from Marange, Zimbabwe are forbidden',
  ship_the_item_within_one:
    'Ship the item within one business day after payment has been confirmed',
  agree_to_the_deals_terms_of_use: 'I agree to the Daily Deals terms of use',
  continue: 'Continue',
  /* Daily Deals  End */

  /*  auctions */
  reserve_price_notice:
    'This item has a reserve price.  Bids below the reserve price may not result in a sale.',
  views_title: 'Views',
  once_you_have_completed_the_verification_process_june:
    'Once you have been approved to bid, you’ll be able to find great deals on hundreds of diamonds that are priced to sell.',
  i_accept_uppercase: 'I ACCEPT',

  /* My listings */
  generate_report: 'Generate Report',
  attention_positoning_report: `Attention: the report won't include {{ number }} diamond due to insufficient info.`,
  attention_positoning_report_plural: `Attention: the report won't include {{ number} } diamonds due to insufficient info.`,
  report_in_process: 'Your report is in process.',
  to_view_report: 'to view report.',

  /* My listings  End */
  /*  auctions end */

  /* settings */
  size_groups_message:
    "When using the customized option, you're required to create at least 5 size groups with the minimum amount of 0.15 carats and the maximum amount of 10.00 carats. Please note that overlapping and gaps between size groups are not allowed. The gap between groups must be 0.01ct.",
  size_groups_message_example:
    'e.g. Size group 1.50ct - 3.50ct and 2.50ct - 4.50ct or 1.00ct - 2.00ct and 3.00ct - 4.00ct are not allowed.',
  size_group_error_min_value: 'The minimum value must be more than 0.15ct',
  size_group_error_max_value: 'The maximum value must be less than 10ct',
  size_group_error_count: "You're required to create at least 5 size groups",
  size_group_error_gaps: 'The gap must be 0.01',
  size_group_error_overlapping: 'There is overlapping with previous group',
  /* settings End */

  /* search result */
  find_similar: 'Find Similar',
  /* search result End */

  /* my listings */
  edit_settings: 'Edit Settings',
  /* my listings End */

  /* positioning settings */
  measurements_flexibility: 'Measurements Flexibility',
  /* positioning settings End */

  hot: 'hot',
  /* system notifications */
  unread_notifications: `You have {{ number }} unread notification`,
  unread_notifications_plural: `You have {{ number }} unread notifications`,
  no_unread_notifications: 'You have no unread notifications',
  /* login */
  view_plans_and_subscribe: 'to view our plans and subscribe',

  /* trade */
  archived_trades: 'Archived Trades',
  by_active_status: 'By Active Status',
  deleted_trades: 'Deleted Trades',
  showing_active_trades: 'Showing active trades',
  showing_inactive_trades: 'Showing inactive trades',
  showing_archived_trades: 'Showing archived trades',
  showing_deleted_trades: 'Showing deleted trades',
  filtered_list: 'Filtered list',

  /* translation fixes */
  certificates: 'Certificates',
  requests: 'requests',
  created: 'Created',
  buyer_location: 'Buyer Location',
  all_requests: 'All Requests',
  my_requests: 'My Requests',
  add_request: 'Add Request',
  view_purchase_order_upper_case: 'VIEW PURCHASE ORDER',
  confirm_upper_case: 'CONFIRM',
  tracking_number: 'Tracking #',
  shipment_sent: 'Shipment Sent',
  shipment_received: 'Shipment Received',
  payment_sent: 'Payment Sent',
  payment_received: 'Payment Received',
  pickup_location: 'Pickup Location',
  quality_control_required: 'Quality Control Required',
  newest_to_oldest: 'Newest To Oldest',
  oldest_to_newest: 'Oldest to Newest',
  price_high_to_low: 'Price: High to Low',
  price_low_to_high: 'Price: Low to High',
  active: 'active',
  no_ratings: 'no ratings',
  rapnet_excel: 'RapNet Excel',
  what_is_rapnet_excel: 'What is RapNet Excel?',
  what_does_it_offer: 'What does it offer?',
  all_events: 'All Events',
  buy_request_upper_case: 'BUY REQUEST',
  buy_requests_upper_case: 'BUY REQUESTS',
  message_upper_case: 'MESSAGE',
  messages_upper_case: 'MESSAGES',
  listing_upper_case: 'LISTING',
  listings_upper_case: 'LISTINGS',
  latest_articles: 'Latest Articles',
  mining: 'Mining',
  rough_markets: 'Rough Markets',
  polished_markets: 'Polished Markets',
  manufacturing: 'Manufacturing',
  retail: 'Retail',
  financial_slash_legal: 'Financial/Legal',
  research: 'Research',
  marketing: 'Marketing',
  technology: 'Technology',
  gemstones: 'Gemstones',
  watches: 'Watches',
  fair_trade: 'Fair Trade',
  analysis: 'Analysis',
  trade_alerts: 'Trade Alerts',
  statistics: 'Statistics',
  please_enter_your_details: 'Please enter your details below and make sure they are valid.',
  you_will_be_able_to_change:
    'You will be able to change them at a later stage using the "Settings" tab.',
  website_url: 'Website URL',
  email_address: 'Email Address',
  save_details_upper_case: 'SAVE DETAILS',
  write_a_description: 'Write a description about your company...',
  date_of_foundation_mm: 'Date of foundation MM/DD/YYYY',
  date_of_foundation: 'Date of foundation',
  paste_youtube_url: 'Paste Youtube URL...',
  zip: 'ZIP',
  select_state: 'Select State',
  enter_website_url: 'Enter website URL...',
  facebook: 'Facebook',
  enter_facebook_page_url: 'Enter Facebook page URL...',
  enter_linkedin_page_url: 'Enter Linkedin page URL...',
  enter_twitter_page_url: 'Enter Twitter page URL...',
  checkbox: 'Checkbox',
  head_office: 'Head Office',
  request: 'Request',
  starting_date: 'Starting date',
  ending_date: 'Ending date',
  select_country: 'Select Country',
  drop_or: 'Drop or',
  mobile: 'Mobile',
  send_message_upper_case: 'SEND MESSAGE',
  create_upper_case: 'CREATE',
  lot_lattice: 'Lot #',
  amount_over_due: 'Amount Over Due',
  enter_amount_over_due: 'Enter amount over due...',
  would_like_to_report_a: 'would like to report a rating given by',
  the_following: 'the following',
  i_am_writing_t_you: 'I am writing to you to request that you endorse me on RapNet. Please click',
  to_leave_me_an_endorsement: 'to leave me an endorsement. Thank you.',
  enter_member_name: 'Enter Member’s Name or ID...',
  i_am_writing_t_you_for_feetback:
    'I am writing to you to request that you rate me positively on RapNet.',
  please_go_to: 'Please go to',
  to_rate_me_thank_you: 'to rate me. Thank you.',
  business_days_must_be_greater_than: 'Business Days must be greater than 0',
  business_days_must_be_whole: 'Bussiness Days must be a whole number',
  payment_comment: 'Payment Comment',
  free_shipping_is: 'Free Shipping is not valid with shipping fees',
  people_have_endorsed: 'People have endorsed',
  for: 'for',
  no_address: 'No Address',
  you_can_activate_one: 'You can activate one more member or contact your local',
  more_members_or_contact: 'more members. or contact your local',
  write_your_comment: 'Write your comment here...',
  memo_policy: 'Memo Policy',
  return_policy: 'Return Policy',
  can: 'can',
  can_not: 'can not',
  download_this_members_listings: 'download this member’s listings',
  primary_supplier_account: 'Primary Supplier Account',
  dealer_account: 'Dealer Account',
  the_rapnet_prise_list_along:
    'The RapNet Price List, along with the RAP Indices are crucial supplements to the Rapaport Price List. Both sets of information provide real trading statistics from the previous week of transactions on RapNet. These numbers will allow a person to determine present-day, real-world discounts from the Rapaport Price List and have a clear advantage in the negotiation of diamond transactions.',
  the_standart_rapaport_prise:
    'The standard Rapaport Price List will continue as a primary source of diamond price information for the diamond industry. Continuous 24/7 price information is available on RapNet trading screens.',
  all_rapnet_data_including_the_rapnet:
    'All RapNet data, including the RapNet Price List, is copyrighted and owned by Martin Rapaport. All rights reserved. No part thereof may be copied, transferred, transmitted, distributed, recompiled, or published in any manner or form without the express written permission of the copyright holder. Duplicating or sharing information with third parties is strictly prohibited. For more information please contact us.',
  rapnet_price_list_changes_between: 'RapNet Price List changes between',
  dollar_change: '$Change',
  persent_change: '%Change',
  latest_rapnet_prise_list: 'Latest RapNet Price List',
  report_filter: 'Report Filter',
  potential_investment_grade: 'Potential Investment Grade',
  view_transaction: 'View Transaction',
  depth__percent: 'Depth%',
  table__percent: 'Table%',
  raplab_comment: 'RapLab Comment',
  view_gia: 'View GIA Certificate',
  view_video_and_raplab: 'View Video and RapLab Certificate',
  only_my_favorites: 'Only My Favorites',
  tracked_groups: 'Tracked Groups',
  are_you_sure_you_want_to_delete_selected_img: 'Are you sure you want to delete selected images?',
  new_offers: 'New Offers',
  /* Melee Calculator */
  melee_calculator: 'Melee Calculator',
  round_diamonds_only: 'Round Diamonds Only',
  mm_uppercase: 'MM',
  sieve_pound: 'Sieve #',
  /* End Melee Calculator */
  diamond__lattice: 'Diamond#',
  price_dollar_per_carat: 'Price: $/ct',
  price_percent_rap: 'Price: %Rap',
  preferred_seller_locations: 'Preferred Seller Location(s)',
  shape_name_as_appears: 'Shape name as appears on lab report',
  start_typing_shape_name: 'Start typing shape name...',
  privacy_policy: 'Privacy Policy',
  trading_rules_and_code_of_conduct: 'Trading Rules & Code of Conduct',
  member_license_agreement: 'Member License Agreement',
  rapaport_representative: 'Rapaport Representative',
  general_support: 'General Support',
  watched: 'watched',
  items_im_selling: `Items I'm Selling`,
  my_bids: 'My Bids',
  active_auctions: 'Active Auctions',
  minimum_order: 'Minimum Order',
  manufactured_date: 'Manufactured Date',
  ring_size: 'Ring Size',
  diamond_fancy_color_overtone: 'diamond fancy color overtone',
  diamond_color_a_z: 'diamond color(d-z)',

  // new AuctionOwner //
  pending: 'Pending',
  see_invoice: 'See Invoice',
  button_download_csv_template: 'Download CSV template',
  button_load_from_csv_file: 'Load from CSV file',
  owner_act_id: 'Owner Act.ID',
  remove_all: 'Remove All',
  date_time: 'Date/Time',
  listing_bidded_on: 'Listing Bidded On',
  show_only_winnig_bids: 'Show only winning Bids',
  above_res_price: 'Above Res.Price',
  below_res_price: 'Below Res.Price',
  none_upper_case: 'NONE',
  high_bid: 'High Bid',
  bids_above_reserve_price: 'Bids Above Reserve Price',
  bids_below_reserve_price: 'Bids Below Reserve Price',
  listings_sold: 'Listings Sold',
  total_sold_dollar: 'Total $ Sold',
  listings_purchased: 'Listings Purchased',
  listings_purchased_dollar: 'Total $ Purchased',
  position: 'Position',
  account_lattice: 'Account#',
  no_data_to_display_for_this_bidder: 'No data to display for this bidder',
  download_as_csv: 'Download as CSV',
  update_listings_from_CSV: 'Update Listing from CSV',
  /* Search Result */
  similar_results: 'Similar Results',
  your_diamond: 'Your Diamond',
  original_diamond: 'Original Diamond',
  list_price: 'List Price',
  parcels: 'Parcels',
  rapaport_prices: 'Rapaport Prices',
  /* quick search */
  serach_by: 'Search by Shape, Color, Stock # etc.',
  /* dashboard */
  dashboard_expiration_alert_part_one:
    'Your RapNet subscription is about to expire. For continuous service, click',
  dashboard_expiration_alert_expired: 'Your RapNet subscription has expired. To renew,',
  renew_now: 'renew now',
  dashboard_expiration_alert_part_two: 'or contact customer service.',
  unsave_this_item: 'Unsave this item',
  /* system notifications */
  delete_notification: 'Delete notification',
  are_you_sure_you_want_to_delete_all_listings:
    'Are you sure you want to delete all listings in this auction?',
  delete_all_listings: 'Delete All Listings',
  /* auction catalog */
  catalog: 'Catalog',
  assign_to: 'Assign to',
  more_actions: 'More Actions',
  sorted_by_last_activity: 'Sorted by last activity',
  sorted_by_newest_first: 'Sorted by newest first',
  select_preset_ratio: 'Select Preset Ratio...',
  feeds: 'Feeds',
  feed: 'Feed',
  templates: 'Templates',
  select_date: 'Select Date',
  type_a_number: 'Type a Number',
  my_account_and_settings: 'My Account & Settings',
  my_account: 'My Account',
  log_out: 'Log Out',
  manage_my_diamonds: 'Manage My Diamonds',
  register: 'Register',
  parcel_search: 'Parcel Search',
  inquiry: 'Inquiry',
  /* Search Results */
  print_email: 'Print / Email',
  done: 'Done',
  enter_focus_mode: 'Enter focus mode',
  exit_focus_mode: 'Exit focus mode',
  representative: 'Representative',
  post_an_idea: 'Post an Idea',
  faq: 'Faq',
  active_buy_trades: 'Active Buy Trades',
  active_unread_buy_trades: 'Active/Unread Buy Trades',
  unread_buy_trades: 'Unread Buy Trades',
  active_sell_trades: 'Active Sell Trades',
  active_unread_sell_trades: 'Active/Unread Sell Trades',
  unread_sell_trades: 'Unread Sell Trades',
  jewelry_listed: 'Jewelry Listed',
  raptrade_purchases: 'RapTrade Purchases',
  raptrade_sales: 'RapTrade Sales',
  dark: 'Dark',
  light: 'Light',
  /* Custom Columns */
  you_must_pick_at_least_one_column: 'You must pick at least one column',
  selected_upper_case: 'Selected',
  /* Settings */
  my_profile: 'My Profile',
  profile: 'Profile',
  plans: 'Plans',
  plans_purchase_history: 'Plans & Purchase History',
  positioning: 'Positioning',
  search_members: 'Search Members',
  member_profile: 'Member Profile',
  notifications_center: 'Notifications Center',
  devices: 'Devices',
  bid_increment_min: 'Minimum Bid Increment',
  set_min_increment: 'Set minimum bid increment',
  type_a_minutes: 'Minutes',
  bids_over_min_reserve_price: 'Bids Over min reserve price',
  active_first_letter_upper_case: 'Active',
  sold: 'Sold',
  awaiting_acceptance: 'Awaiting Acceptance',
  read_only: 'Read Only',
  /* Device Settings */
  manage_devices: 'Manage Devices',
  current_active_members: 'Current Active Members',
  remove_device: 'Remove Device',
  this_action_will_remove_the_device_from_the_list_of_active_devices:
    'This action will remove the device from the list of active devices.',
  web_active_devices: 'Web Active Devices',
  mobile_active_devices: 'Mobile Active Devices',
  filter_by: 'Filter By',
  /* chat */
  change_chat_language: 'Change chat language preferences',
  attach_reports: 'Attach Report(s)',
  /* mylistings */
  check_shortly_to_view_report: 'Check back shortly to view your report in',
  center: 'center',
  home: 'Home',
  /* contact seller */
  contact_selected_seller: 'Contact Selected Seller(s)',
  diamonds_from_sellers: (diamonds: any, sellers: any) =>
    `${diamonds} ${diamonds > 1 ? 'diamonds' : 'diamond'} selected from ${sellers} ${
      sellers > 1 ? 'sellers' : 'seller'
    }`,
  important_notice: 'Important Notice',
  contact_seller_notice:
    'Your message will be delivered to the seller in the RapNet Trade Center, where you and the seller can securely finalize negotiations.',
  buyer_groups_label: 'Choose / create a Trade Center Group to archive your message',
  required: 'Required',
  send: 'Send',
  choose_transaction_type: 'Choose a transaction type...',
  type_here: 'type here...',
  redirecting_to_technet: 'Redirecting to Technet',
  addons: 'Add-ons',

  diamonds_selected: (diamonds: any) =>
    `${diamonds} ${diamonds > 1 ? 'diamonds' : 'diamond'} selected
    `,
  diamonds_selected_uppercase: (diamonds: number) =>
    `${diamonds} ${diamonds > 1 ? 'Diamonds' : 'Diamond'} Selected
      `,
  trading_rules: 'Trading Rules',
  /* Track Diamonds */
  choose_create_group_track_diamonds: 'Choose / create a group to track the diamonds',
  type_here_3_dots: 'Type here...',
  sorting_order: 'Sorting Order',
  /* reports */
  in_queue: 'In Queue',
  please_select_the_account_type_that_applies_to_you:
    'Please select the account type that applies to you',
  phone_number: 'Phone Number',
  email_address_with_comments:
    'E-mail Address (this should pre-populate as they will be logged into their RapNet account)',
  comment_box: 'Comment (box)',
  busines_license_and_tvp_should_be_required_for_all_bidders:
    'Business License and TPV should be required for all bidders',
  resale_certificate_should_be_required_for_all_us_bidders:
    'Resale Certificate should be required for all US bidders',
  delete_the_copy_that_is_currently_displaying_below_the_resale_certificate_field:
    'Delete the copy that is currently displaying below the Resale Certificate field',
  your_account_is_currently_pending_review_we_will_contact_you:
    'Your account is currently pending review. We will contact you as soon as your registration has been approved.',
  please_click_here_to_complete_the_registration_process:
    'Please click here to complete the registration process in order to be able to bid in an auction.',
  my_lots_for_sale: 'My Lots for Sale',
  line: 'Line #',
  column_name: 'Column Name',
  issues_description: 'Issues Description',
  there_are_validation_errors_in_your_csv_file: 'There are validation errors in your CSV file.',
  report_center: 'Report Center',
  reports_center: 'Reports Center',
  /* support center */
  support: 'Support',
  this_comment: 'This Comment',
  /* system notifictions */
  show_all_notifications: 'Show All Notifications',
  mark_all_as_read_capital: 'Mark All as Read',
  not_sold: 'Not Sold',

  help_articles: 'Help Articles',
  reply: 'Reply',
  to_enjoy_all_the_benefits_of_rapnet: 'To enjoy all the benefits of RapNet',
  click_here_lowercase: 'click here',
  approved_bidders: 'Approved Bidders',
  high_bid_ct: 'High Bid $/CT',
  high_bid_total: 'High Bid $ Total',
  this_bid_cannot_be_canceled: 'This bid cannot be canceled',
  place_bid_notes_above_reserve_price:
    'Your bid is above the reserve price and you are currently the highest bidder. If there are no further bids, you will win the lot.',
  place_bid_notes_below_reserve_price:
    'Your bid is below the reserve price. If there is no higher bid, the seller will be notified but there is no assurance that your bid will be accepted.',
  place_bid_notes_far_above_reserve_price:
    'Your Bid cannot be accepted because it is too far above the reserve price. ',
  place_bid_notes_far_below_reserve_price:
    'Your Bid cannot be accepted because it is too far below the reserve price.',
  confirm: 'Confirm',
  edit_bid: 'Edit Bid',
  dont_sell: `Don't Sell`,
  my_pending_lots: 'My Pending Lots',
  please_note: 'Please note',
  my_pending_lots_note:
    'While the auction is now over, you may still accept bids below your reserve price within the next 24 hours. If you do not respond, the items will not be sold.',
  incremental_bidding: 'Incremental Bidding',
  from_bid: 'From Bid',
  to_bid: 'To Bid',
  requested: 'Requested',
  starts_in: 'Starts In',
  sym_shot: 'Sym.',
  lot: 'Lot #',
  you_have_not_selected_any_favorites: 'You have not selected any favorites',
  sales_price: 'Sales Price',
  final: 'Final',
  above: 'Above',
  remove_bidder_confirm: 'Are you sure you want to delete this member?',
  approved_bidders_search_by_name: 'Name: Search by company name or RapNet ID.',
  place_bids_notes_not_highest_bid:
    'Your bid cannot be accepted as it is below the current high bid.',
  contact_lattice: 'Contact#',
  rap_authorizer: 'Rap authorizer',
  credit_limit: 'Credit Limit',
  you_were_out_bid_again: 'You Were Outbid! Bid Again!',
  did_not_win: 'Did Not Win',
  register_to_bid_email: 'You must be Registered to Bid. Please send us an email.',
  send_email: 'Send email',
  show_on_rapnet: 'Show on RapNet',
  /* system notifictions settings */
  what_notification_you_receive: 'What Notifications you receive',
  where_you_receive_these_notifications: 'Where you receive these notifications:',
  who_will_receive_these_notifications: 'Who will receive these notifications:',
  select_members: 'Select Members',
  these_members_will_receive_notifications_about_the_event_selected:
    'These members will receive notifications about the event selected',
  search_for_members: 'Search for members…',
  primary_member: 'Primary Member',
  members_selectd: 'Members selected:',
  customize: 'Customize',
  deselect_all: 'Deselect All',
  push: 'Push',
  search_match: 'Search Match',
  print_expanded_view: 'Print Expanded View',
  /* diamonds search */
  parcel_note: 'Specify total size in "Size" field',
  /* login */
  cookies_erroe_message: 'Error: Cookies are blocked by your browser.',
  you_must: 'You must ',
  enable_cookies: 'enable cookies',

  /* login */
  to_use_RapNet: ' and then refresh this page to use RapNet.',
  cookies_generic_message: 'Cookies need to be enabled to use RapNet.',
  unable_to_login: 'If you are unable to login, ',
  and_try_again: ' and try again.',

  /* Search Results */
  select_columns: 'Select Columns',
  current_view: 'Current View',
  layout: 'Layout',
  content: 'Content',
  single_diamond: 'Single diamond',
  show_per_page: 'Show per page',
  export_page: 'Export Page',
  custom_markup_excel_error: 'Custom Markup is not available when exporting to Excel',
  export_print_selected: 'Export/Print Selected',
  you_have_exceeded_the_print_column_limit: 'You have exceeded the print column limits',
  excel_fields_error: 'Phone, Fax and Inscription data is not included in excel report',
  full_diamond_details: 'Full Diamond Details',
  /* All notifications */
  delete_all_notifications: 'Delete All Notifications',
  delete_notifications: (notification: any) =>
    `Delete ${notification > 1 ? 'Notifications' : 'Notification'}`,
  are_you_sure_you_want_to_delete_all_notifications:
    'Are you sure you want to delete all notifications?',
  are_you_sure_you_want_to_delete_notifications: (notification: any) =>
    `Are you sure you want to delete this ${notification > 1 ? 'notifications' : 'notification'}?`,
  use_custom_markup: 'Use Custom Markup',

  /* upload */
  RapNet_listings_are_only_active_for:
    'Please note that RapNet listings are only active for 7 days. Refresh the listings periodically to ensure your stock is displayed on RapNet.',
  RapNet_listing_strictly_prohibits:
    'RapNet strictly prohibits the listing of a) lab-grown diamonds, b) white diamonds with a green tinge/hue/shade and c) any diamonds originating from Zimbabwe.',
  treatments_diamonds_clearly:
    'Please also note: Any/all treatments on diamonds must be clearly disclosed in the treatment fields and misrepresentation is not allowed (laser drilled, color treated, HPHT etc.).',

  /* search results */
  per_page: 'Per page',
  write_note: 'Write a Note',
  write_note_description: 'Only you and the members of your account will see this note',
  show_hide_diamond_duplicates: 'Show / Hide Diamond Duplicates',
  matching_buy_requests: 'Matching Buy Requests',
  unread_messages: 'Unread Messages',
  /* dashboard */
  your_saved_items: 'Your Saved Items',
  favorite_jewelry: 'Favorite Jewelry',
  tracking_groups: (groups: any) => `${groups} Tracking Group${groups === 1 ? '' : 's'}`,
  worth_in_listing: 'worth in listings',
  groups_updated: (groups: any) =>
    `${groups} Group${groups === 1 ? '' : 's'} updated in the last week`,
  jewelry_categories: 'Jewelry Categories',
  item: 'item',
  earrings: 'Earrings',
  rings: 'Rings',
  bracelets: 'Bracelets',
  pendants: 'Pendants',
  necklaces: 'Necklaces',
  new_offer_received: 'New Offer Received',
  offers_in_negotiation: (offers: any) =>
    `${offers} offer${offers === 1 ? '' : 's'} in negotiation`,
  in_negotiation: 'In Negotiation',
  recent_trades: 'Recent Trades',
  add_buy_request: 'Add Buy Request',
  see_all: 'See All',
  Cant_find_what_you_are_looking_for: `Can't find what you are looking for?`,
  add_a: 'Add a ',
  buy_request: 'Buy Request',
  hours: 'hours',
  min: 'min',
  there_are_no_new_updates_available: 'There are no new updates available',
  you_have_no_trading_activity: 'You have no trading activity',
  make_your_trades_secure: 'Make your trades more secure by doing them through the Trade Center.',
  check_out_rapnets_trading_platform: `Check out RapNet's trading Platform`,
  you_have_no_saved_searches: 'You have no saved searches',
  save_time_saved_searches:
    'Save time by creating a ‘Saved Search’ with your pre-filled search parameters.',
  you_are_not_tracking_any_items: 'You are not tracking any items',
  start_tracking_diamonds:
    'Start tracking diamonds to keep track of changes to diamonds you are interested in.',
  you_have_no_recent_interactions: 'You have no recent interactions',
  reach_out_to_other_rapnet_members_to_start_buying_and_Selling:
    'Reach out to other RapNet members to start buying and selling. ',
  you_have_no_recent_intercations: 'You have no recent interactions',
  keep_your_trusted_colleagues_close_and_handy: 'Keep your trusted colleagues close and handy',
  brand_s_designers: 'Brand/Designers',
  text_search: 'Text Search',
  recently_contacted_members: 'Recently Contacted Members',
  monthly: 'Monthly',
  weekly: 'Weekly',
  pricing_indexes: 'Pricing indexes',
  breakdown: 'Breakdown',
  months: 'months',
  default_view: 'Default View',
  last_view: 'Last View',
  seller_company_name: 'Seller Company Name',
  jewelry_category: 'Category',
  metal_type: 'Metal Type',
  metal_karat: 'Metal Karat',
  gemstone: 'Gemstone',
  lab_report_sulamite: 'Lab Report #',
  auctions_jewelry_search_message:
    'There are no lots in the auction that fit the criteria selected',
  final_sale_price: 'Final Sale Price',
  high_bid_price: 'High Bid Price',
  my_bid: 'My Bid',
  estimate: 'Estimate',
  bid_now: 'Bid Now',
  deadline: 'Deadline',
  insurance_value: 'Insurance Value',
  after_commission: 'After Commission',
  bid_amount: 'Bid Amount',
  confirm_bid: 'Confirm Bid',
  preview_bid: 'Preview Bid',
  more_similar_items: 'More similar items',
  rapnet_diamond_statistics: 'RapNet Diamond Statistics',
  notify_bidder: 'NOTIFY BIDDERS',
  change_markup_type: 'Change Markup Type',
  markup_type_will_delete_all_previously_set_markups:
    'Changing the markup type will delete all previously set markups. Continue?',
  select_language: 'Select Language',
  with: 'with',
  set_columns_as_default: 'Set Columns as Default',
  translate_my_chats_to: 'Translate my chats to:',
  jan: 'Jan',
  feb: 'Feb',
  mar: 'Mar',
  apr: 'Apr',
  may: 'May',
  jun: 'Jun',
  jul: 'Jul',
  aug: 'Aug',
  sep: 'Sep',
  oct: 'Oct',
  nov: 'Nov',
  dec: 'Dec',
  worth: 'Worth',
  instant_inventory_notification_explanation:
    'Receive notifications when RapNet retailers ask to add your inventory to their virtual inventory',
  member_notification_explanation:
    'Receive notifications when RapNet members are asking for your endorsement or feedback',
  reports_notification_explanation:
    'Receive notifications when your data reports are ready to download in the report center',
  search_match_notification_explanation:
    'Receive notifications when diamonds match your saved searches',
  upload_notification_explanation:
    'Receive notifications when your inventory is uploaded to RapNet',
  leads_notification_explanation:
    'Receive notification when a potential customer sends you a message regarding an item you shared publicly outside of RapNet',
  instant_inventory_inquiries_notification_explanation:
    'Receive notification when a potential customer sends you an inquiry about an Instant Inventory item',
  price_list_notification_explanation: 'Receive notification when a new price list is published',
  trade_center_notification_explanation:
    "Receive notifications when there's a new trading activity such as new offer",
  lists_notification_explanation:
    "Receive notification when you're added to a list or a new item is added/deleted",
  lotreview_notification_explanation: 'Receive notification when item is under review',
  instant_inventory_inquiries: 'Instant Inventory Inquiries',
  price_list: 'Price List',
  /* Login */
  user_not_exist: 'User does not exist.',
  your_account_has_been_removed: 'Your account has been removed',
  your_account_is_pending_approval: 'Your account is pending approval',
  inactive_account: 'Inactive account',
  /* new */
  reset_columns: 'Reset Columns',
  certif_lattice: 'Certif #',
  take_note: 'Take Note',
  your_diamonds_position: 'Your Diamond’s Position',
  notes: 'Notes',
  add_a_note: 'Add a Note',
  show_number: 'Show Number',
  ratings: 'Ratings',
  pricing_simulator: 'Pricing Simulator',
  simulator_result: 'Simulator Result',
  same_position: 'Same Position',
  history_with_seller: 'History with Seller',
  previous_trades: 'Previous Trades',
  messages_exchanged: 'Messages Exchanged',
  times_you_have_looked: 'Times you have looked at his items',
  times_you_have_shared: 'Times you have shared items from this seller',
  performance: 'Performance',
  supplier_info: 'Supplier information',
  positions_up: 'positions up',
  positions_down: 'positions down',

  do_not_translate: 'Do not translate',
  improved_view: 'Improved View',
  clipping_text: 'Clipping Text',
  wrapping_text: 'Wrapping Text',
  table_view: 'Table View',
  choose_your_table_view: 'Choose your Table View',
  table_view_compact: 'Compact',
  table_view_default: 'Default',
  table_view_large: 'Large Fonts',
  rating_endorsement_request: 'Rating / Endorsement Request',
  saved_search_buy_request: 'Saved Search / Buy Request',
  upload_reports: 'Upload Reports',
  hello_im_your_cs_rep: (csRepName: string): string =>
    `Hello! I'm ${csRepName} and I am your customer service representative`,
  chat: 'Chat',
  primary_supplier: 'Primary Supplier',
  hello: 'Hello',
  your_customer_rep_is: 'Your customer representative is',
  lets_chat: `Let's Chat`,
  new_view_modal_header: 'Try out our Improved Table View!',
  not_now_thanks: 'Not now, thanks',
  try_now: 'Try Now',
  /* ADDONS */
  with_the_power_of_microsoft_excel:
    'RapNet XL is a powerful add-on for Microsoft Excel, combining the power of Microsoft Excel with RapNet and the Rapaport Price List.',
  using_rapnetxl: 'Using RapNet XL you can:',
  rapnetxl_calculate: 'Calculate and compare diamond pricing:',
  rapnetxl_point1_a: 'Synchronize inventory with the latest Rapaport Prices.',
  rapnetxl_point1_b: 'Calculate diamond inventory based on percentages off Rapaport Prices.',
  rapnetxl_point1_c: 'View RapNet best/average prices next to your inventory.',
  rapnetxl_manage: 'Manage your inventory:',
  rapnetxl_point2_a: 'Upload and update inventory easily to RapNet with one click!',
  rapnetxl_point2_b: 'Download your current RapNet inventory directly to Microsoft Excel. ',
  rapnetxl_download_br: 'Download RapNet Buy Requests ',
  rapnetxl_point3: 'from RapNet to Microsoft Excel.',
  free: 'Free',
  download_rapnet_xl: 'Download RapNet XL',
  rapnetxl_note: 'Note: ',
  included_in_primary_supplier:
    'RapNet XL is included in the Primary Supplier, RapNet Dealer, and Buyer Pro plans at no additional cost.',
  minimum_system_requirements:
    'Minimal System Requirements for RapNet XL: Excel 2013, Windows 10 and higher.',
  apple_not_supported: 'Apple Mac and Open Office are not supported.',
  looking_for_specific_diamond_price_data:
    'Looking for specific diamond price data? Send us a suggested sample report and we can create a report for you based on RapNet and Rapaport diamond price information.',
  customreports_point1:
    'See the position of your diamond in RapNet search results within a similar group of diamonds',
  customreports_point2:
    'Price your diamond more competitively. The interactive Price Simulator lets you simulate adjusting your diamond’s price to see where it would rank on RapNet search results, and then change the price on the spot.',
  per_month: 'per month',
  per_year: 'per year',
  add_to_your_account: 'Add to Your Account',
  diamond_insights: 'Diamond Insights',
  a_powerful_tool_that_helps_you_analyze:
    'A powerful tool that helps you analyze, position and price your diamonds better to optimize sales.',
  diamondInsights_point1:
    'See the position of your diamond in RapNet search results within a similar group of diamonds',
  diamondInsights_point2:
    'Price your diamond more competitively. The interactive Price Simulator lets you simulate adjusting your diamond’s price to see where it would rank on RapNet search results, and then change the price on the spot.',
  showcase_more_inventory_on_your_jewelry_website:
    'Showcase more inventory on your jewelry website. Let your customers browse over 1 million certified RapNet diamonds in your online store, as if they were your own inventory.',
  ii_point1: 'Custom Tailored to your website',
  ii_point2: 'Simple set up',
  ii_point3: 'Easy Integration',
  ii_point4: 'Set your own mark-ups',
  ii_point5: 'No commission or transaction fees ',
  ii_subTitle:
    'Showcase a live feed of over 1 million RapNet diamonds on your online store. Customizable to your website.',
  diamondInsights_subTitle:
    'A powerful tool that helps you analyze, position and price your diamonds better to optimize sales.',
  boost_your_skills: `Boost Your Skills & Career with Rapaport's eLearning platform for the diamond and jewelry industry`,
  customReports_subTitle:
    'Looking for specific diamond price data? We can create tailored reports based on RapNet and Rapaport diamond price information.',
  rapnetxl_subTitle:
    'Integrates Rapaport Price List data with your inventory database on Microsoft Excel to help you with modeling, pricing and inventory management.',
  rapaport_research_report: 'Rapaport Research Report',
  rapaport_auctions: 'Rapaport Auctions',
  raplab_grading_services: 'RapLab Grading Services',
  rapaport_academy: 'Rapaport Academy',
  rResearch_subTitle:
    'Give your business the competitive edge with exclusive Rapaport market insight, analysis and pricing data.',
  rAuctions_subTitle:
    'Rapaport Auctions provides diamond dealers and traders with an effective and efficient way to buy and sell diamonds in a secure and easy environment.',
  rMagazine_subTitle:
    'Subscribe to the industry’s most trusted source of business intelligence and pricing information.',
  raplabService_subTitle:
    'Our gemological laboratory efficiently and securely evaluates the quality of your diamonds using the latest technology.',
  rAcademy_subTitle:
    'A suite of online courses to help you master the practical and commercial aspects of the diamond and jewelry industry.',
  learn_more: 'Learn More',
  contact_sales: 'Contact Sales',
  research_report_gives_you_access_to_unique_market_insight:
    'The Rapaport Research Report gives you access to unique market insight, analysis and pricing data.',
  research_report_each_month_highlights:
    'Each month the Rapaport Research Report highlights a key issue affecting the diamond industry, such as finance, synthetics, and rough and polished prices, providing definitive analysis and insight, while assessing the potential impact on your business.',
  researchReport_point1: 'Deep analysis of key issues impacting the diamond and jewelry trade.',
  researchReport_point2: 'Comprehensive monthly overview of rough, polished and retail markets.',
  researchReport_point3: 'Exclusive diamond supply and demand data.',
  researchReport_point4: 'Access to exclusive Rapaport pricing data.',
  rapaportAuctions_point1:
    '– from New York to Israel to Hong Kong – enables us to target even the most specific segments of the diamond markets to give maximum exposure to your diamonds.',
  rapaportAuctions_point1Bold: 'Our extensive, global network ',
  rapaportAuctions_point2:
    ' provides the extra level of customer service, from performing quality control to appraisals, certification, and if required, re-cutting and re-certification of diamonds.',
  rapaportAuctions_point2Bold: 'Our expert staff',
  register_with_rapaport_auctions: 'Register with Rapaport Auctions',
  find_out_nore: 'Find Out More',
  rapaport_magazine_provides_jewelers_diamond_dealer_and:
    'Rapaport Magazine provides jewelers, diamond dealers and manufacturers with the essential information to succeed in the world of diamonds, gems and jewelry. Pricing, news and market trend information will give your business a critical edge in this complex and competitive marketplace.',
  rapaportMagazine_Point1Bold: 'Detailed pricing information',
  rapaportMagazine_Point1:
    ' to help you track price movements in order to better manage your inventory.',
  rapaportMagazine_Point2Bold: 'Analysis of global economic trends ',
  rapaportMagazine_Point2: 'that are impacting the industry from Surat to 47th Street.',
  rapaportMagazine_Point3Bold: 'Reporting on the latest technological innovations ',
  rapaportMagazine_Point3: 'in the industry, from synthetic detection to blockchain.',
  rapaportMagazine_Point4Bold: 'Practical strategic, marketing and management advice ',
  rapaportMagazine_Point4:
    'from best-in-class diamond manufacturers, wholesalers, and business leaders.',
  raplab_offers_our_clients_the_expertise:
    'RAPLAB® offers our clients the expertise, convenience and technological sophistication of our Rapaport diamond grading laboratory. Our gemological laboratory efficiently and securely evaluates the quality of your diamonds using the latest technology. Online access to verify reports and high definition images are provided.',
  raplab_point1: 'RapLab Consultation Card (RCC)',
  raplab_point2: 'RapLab Diamond Grading Report (RGR)',
  raplab_point3: 'Rapaport Diamond Certificate (RDC)',
  raplab_point4: 'Private Label Grading Report',
  raplab_point5: 'Quality Control',
  rapaportAcademy_point1Bold: 'Fundamentals of Diamond Trading ',
  rapaportAcademy_point1: '– Take your diamond trading to the next level.',
  rapaportAcademy_point2Bold: 'Digital Marketing Essentials for Jewelers ',
  rapaportAcademy_point2: '– Boost your online presence to increase trraffic and sales.',
  rapaportAcademy_point3Bold: 'Diamonds & Jewelry Retail Sales Master Class ',
  rapaportAcademy_point3:
    '– Learn techniques and skills to sell more diamonds and jewelry in-store.',
  rapaportAcademy_point4Bold: 'Customized Courses ',
  rapaportAcademy_point4:
    '– Build a tailor-made online course for your company, based on your employees needs.',
  a_rapnet_representative_will_be_in_touch:
    'A RapNet representative will be in touch with you within 1 business day.',
  add_to_subscription: 'Add to Subscription',
  go_back_to_reupload: 'Click Go Back to re-upload',
  csv_file_without_missing_values: 'CSV file without missing values',
  download_errors_csv: 'Download Errors CSV',
  from_to_error: 'Finishes must be from Excellent to Poor',

  new_view_modal_content:
    'With the new table you can choose your preferred custom columns (there is no limit to how many) and adjust the order and the size of them. Plus you can easily view your notes content by hovering on the note icon. The clear design of the table also lets you immediately identify which diamonds you have already viewed.',

  /* Search Results */
  item_shared_succesfully: 'Item shared successfully',
  contact_saved_successfully: 'Contact saved successfully',
  your_recipient_will_receive_the_item_on_the_RapNet_chat:
    'Your recipient will receive the item on the RapNet chat',
  create_new_contact: 'Create New Contact',
  share_item: 'Share Item',
  share_via_rapnet_chat: 'Share via RapNet chat',
  share_with: 'Share with',
  search_contact_or_add_new_email: 'Search contact or add new email...',
  type_message_3_dots: 'Type message...',
  number: 'Number',
  share: 'Share',
  your_recipient_will_recieve_the_item_by_email: 'Your recipient will recieve the item by email',
  /* Upload */
  all_types_of_treatment_must_be_specified:
    'All types of treatments MUST be specified in the Treatment field.',
  check_what_would_be: 'Check what would be your diamond’s position with a different price.',
  make_this_my_price: 'Make this my price',
  or_click: 'or click',
  items_shared: 'Items Shared',
  active_items_shared: 'Active Item(s) Shared',
  item_shared: 'Item Shared',
  date_Shared: 'Date Shared',
  link_expiry_date: 'Link Expiry Date',
  shared_with: 'Shared with',
  deactivate_share_link: 'Deactivate Share Link',
  are_you_sure_deactivate: 'Are you sure you want to deactivate this link?',
  sieve__lattice: 'Sieve#',
  pricint_options: 'Pricing Options',
  pricing_options_1_discount: 'Always keep discount constant, regardless of rap price changes',
  pricing_options_2_perCarat: 'Always keep $/ct price, regardless of rap price changes',
  pricing_options_3_rapPrice:
    'Keep my discount constant if rap price goes up and keep $/ct constant if rap price goes down',
  logged_in_as: 'LOGGED IN AS',
  my_contacts: 'My Contacts',
  new_contact: 'New Contact',
  new_view_toggle_guide:
    'You can switch your view at any time by Clicking on this user profile picture.',
  new_view_more_guide:
    'You can switch your preferred table view by clicking on this button and selecting "Table View".',
  show_listing_seller_details: 'Show Listing seller details',
  contact_information: 'Contact Information',
  edit_contact: 'Edit contact',
  add_a_message_optional: 'Add a message (optional)',
  dont_show_price: "Don't Show Price",
  your_recipient: 'Your recipient',
  same_as_phone: 'Same as Phone',
  whatsapp: 'WhatsApp',
  founded_in: 'Founded in',
  click_here_to_add_company_name: 'Click here to add company name',
  add_log: 'Log Activity',
  new_note: 'New Note',
  describe_your_call: 'Describe your call...',
  start_typing_your_note: 'Start typing your note...',
  describe_your_follow_up: 'Describe your follow up...',
  save_log: 'Save Log',
  save_note: 'Save Note',
  save_reminder: 'Save Task',
  create_a_follow_up: 'Create a new task to follow up',
  set_up_reminder_to: 'Set up task to',
  log_a_call: 'Log a Call',
  log_an_email: 'Log an Email',
  log_a_meeting: 'Log a Meeting',
  upcoming: 'Upcoming',
  logged_calls: 'Logged Calls',
  logged_emails: 'Logged Emails',
  logged_meetings: 'Logged Meetings',
  follow_ups: 'Follow Ups',
  dates: 'Date',
  today: 'Today',
  this_week: 'This Week',
  this_month: 'This Month',
  place_bid_notes_same_as_current_bid:
    'Your bid cannot be placed as it the same as the current high bid.',
  place_bid_reject_below_reserve_price:
    'Your bid cannot be placed as it has not met the reserve price.',
  place_bid_reject_below_minimum_price:
    'Your bid cannot be placed as it has not met the minimum bid price.',
  place_bid_reject_below_acceptable_bid_increment:
    'Your bid cannot be placed as it is below the next acceptable bid increment.',
  // new ////////////////////////////////////////////////////////////////////////////////

  shared_items_with_your_contacts: 'Shared items with your contacts',
  this_screen_gives_you_view:
    'This screen gives you a view of all of your contacts that you have added and information about them',
  you_can_share_an_item:
    'You can share an item from the item page by clicking on the "Share" button.',
  shared_link_expires_in: 'A shared link expires in 48 hours.',
  new_contact_saved: 'New Contact Saved',
  a_list_of_all_your: 'A list of all your business contacts',
  this_is_your_private_contacts:
    'This is your private contacts list and only members from you company are able to see and access it.',
  this_screen_gives_you:
    'This screen gives you a summarized view of all of your contacts you have added.',
  add_new_contact_by_clicking:
    'Add a new contact by clicking on the "Add Contact" button or by sharing an item and adding a new contact as part of the sharing process.',
  an: 'An',
  icon_next_to_company: " icon next to a company's name means that this company or ",
  person_is_rapnet_member: 'person is a RapNet member.',
  next_Follow_Up_shows_you:
    "Next Follow Up shows you the closest follow up task date that you've set with this contact.",
  you_can_add_follow_ups_by:
    "You can add follow ups by clicking on the the contact's name, clicking on 'Add Log', checking the 'Follow up' checkbox and choosing a date and time. You will get a follow up task via email and a RapNet notification.",
  delete_contact: 'Delete Contact',
  are_you_sure_want_to: 'Are you sure you want to delete this Contact?',
  search_contact_name: "Search a contact's name...",
  total_depth: 'Total Depth',
  additional_information: 'Additional Information',
  diamond_page: 'Diamond Page',
  saved: 'Saved',
  no_plot: 'No Plot',
  no_diagram: 'No Diagram',
  plot: 'Plot',
  connections: 'Connections',
  occurred_on: 'Occurred On',
  contact_not_exist: 'Contact does not exist.',
  regarding_logged_by_type: (date: { fullDate: any; hour: any }, type: any) =>
    `Regarding ${type} logged ${date.fullDate} at ${date.hour}`,
  check_out_this_item: 'Check out this item:',
  shared_item: 'Shared Item',
  will_receive_the_message_by_email: 'will receive the message by email',
  you_create_a_follow_up_for: (name: any, date: { fullDate: any; hour: any }) =>
    `${name || 'You'} created a follow up for ${date.fullDate} at ${date.hour}`,
  you_wrote_a_note_on_this_contact: (name: any) => `${name || 'You'} wrote a note on this contact`,
  you_create_a_remadiner_for: (name: any, date: { fullDate: any; hour: any }) =>
    `${name || 'You'} created a task for ${date.fullDate} at ${date.hour}`,
  you_logged: (name: any, type: any, date: { fullDate: any; hour: any }) =>
    `${name || 'You'} logged a ${type} on ${date.fullDate} at ${date.hour}`,
  widgets_rules: 'Widgets & Rules',
  new_rule: 'New Rule',
  hide: 'Hide',
  get_started: 'Get Started',
  countries: 'Countries',
  show_only_suppliers_whith: 'Show only suppliers with Listing Permission allowed',
  allowed: 'Allowed',
  not_allowed: 'Not Allowed',
  edit_task: 'Edit Task',
  delete_task: 'Delete Task',
  todo: 'to-do',
  canceled: 'canceled',
  markup_price_should_be_between: (range: any) => `Should be between ${range}`,
  share_beta_modal_message: 'I\'d like to be notified via email once "Share" feature is available',
  copy_to_clipboard_success: 'Copied to clipboard!',
  message_sent_successfully: 'Message sent successfully',
  no_thanks: 'No thanks',
  preview: 'Preview',
  type_item_number: 'Type the Item #…',
  insert_item_number: 'Insert Item #',
  invalid_item_number: 'Invalid item #',
  diamonds_first_letter_upper_case: 'Diamonds',
  delete_all_markups: 'Are you sure you want to delete all price mark-ups?',
  describe_your_meeting: 'Describe your meeting...',
  describe_your_email: 'Describe your email...',
  describe_your_task: 'Describe your task...',
  will_receive_the_message_by_chat:
    'will receive the message on RapNet Chat. All members of the account will be able to read your message.',
  diamond_item_page: 'Diamond Item Page',
  tasks: 'Tasks',
  newTask: 'New Task',
  upcomingTasks: 'Upcoming Tasks',
  new_widget: 'New Widget',
  widget_type: 'Widget Type',
  design: 'Design',
  create_your_rule: 'Create Your Rule',
  select_and_customize: 'Select and Customize',
  continue_without_design: 'Continue without design',
  ideal_for_eCommerce: 'Ideal for eCommerce',
  choose_this_options_if_you:
    'Choose this options if you want your web developer to customize your design via our API. After you set up your widget you will be provided with detailed instructions for your web developer.',
  reset_to_default: 'Reset to Default',
  result_per_page: '# of Results per Page',
  raplab_point6: 'Image Services',
  widget_name: 'Widget Name',
  widget_setting_warning:
    'This Email address will be used to enable widget buyers to click on a button and send direct questions and inquiries to this email. Email address will not be visible to customers.',
  script: 'Script',
  techNet: 'TechNet',
  copyScript: 'Copy Script',
  rough_origin: 'Rough Origin',
  light_perfom: 'Light perfom',
  open_chat_to_share_the_lot: 'Open a chat to share the lot #',
  all_dates: 'All Dates',
  more_fields: 'More Fields',
  this_diamond_is_not_listed_anymore: 'This diamond is not listed anymore',
  save_rule: 'Save Rule',
  rule_name: 'Rule Name',
  rule_description: 'Rule Description',
  optional: 'optional',
  rule_description_placeholder: 'Add a description to identify better your rules in the future',
  people: 'People',
  deactivate: 'Deactivate',
  well_done: 'Well done!',
  you_create_new_rule: 'You have created your Rule.',
  you_can_view_rule_in_dashboard: 'You can view and edit all your Rules in the dashboard.',
  go_to_dashboard: 'Go to Dashboard',
  activate_first_letter_uppercase: 'Activate',
  calls: 'Calls',
  emails: 'Emails',
  meetings: 'Meetings',
  my_instant_inventories: 'My Instant Inventories',
  view_edit: 'View & Edit',
  performance_reports: 'Performance & Reports',
  rules: 'Rules',
  inventory: 'Inventory',
  instant_inventory_feed_name: 'Instant Inventory Feed Name',
  shared: 'Shared',
  with_this_contact: 'with this contact',
  shared_items: 'Shared Items',
  // user Settings:
  manage_rapnet_listings: 'Manage RapNet Listings',
  manage_image_files: 'Manage Image Files',
  contacts_and_member_directory: 'Contacts & Member Directory',
  contacts: 'Contacts',
  add_buy_requests: 'Add Buy Requests',
  view_buy_requests: 'View Buy Requests',
  search_for_diamonds: 'Search For Diamonds',
  diamond_inventory: 'Diamond Inventory',
  member_info: 'Member Info',
  get_code: 'Get Code',
  general_inf_on_product_page: 'General Information on product page',
  type_here_information: 'Type here information related to shipping, return policy, etc.',
  cut_polish_symm: 'Cut/Polish/Symm.',
  measurements_1: 'Measurements (1)',
  measurements_2: 'Measurements (2)',
  welcome_to_the_instant_inventory: 'Welcome to the Instant Inventory Setup Wizard',
  we_take_you_through_the_steps:
    'We’ll take you through the steps to set up your diamond or jewelry Instant Inventory which you’ll be able to add to your website later. To get started, let’s choose which type of Instant Inventory you want to create.',
  choose_instant_inventory_type: 'Choose an Instant Inventory feed',
  widget_settings_description_1:
    "Once you've selected a feed type, we will define which items will appear in the Instant Inventory feed.",
  widget_settings_description_2:
    'You must have different Instant Inventory feeds for diamonds and jewelry. You will be able to create another Instant Inventory feed later.',
  choose_design_theme_for_your_instant_inventory_feed:
    'Choose a design theme for your Instant Inventory Feed',
  customize_the_widget_theme: 'Customize the widget theme',
  create_jewelry_widget_rule:
    'Which jewelry would you like to include in this jewelry instant inventory feed?',
  create_diamonds_widget_rule:
    'Which diamonds would you like to include in this diamond instant inventory feed?',
  diamond_criteria: 'Diamond Criteria',
  numOfSuppliers: '# Suppliers',
  click_here_to_view_item_page: 'Click here to view item page',
  send_me_notifications: 'Send me Notifications',
  load_saved_search: 'Load saved search',
  // Search:
  intens: 'Intens',
  stock_lattice_s: 'Stock #(s)',
  RNXL_is_available_for_certain_subscriptions: 'RapNet XL is available for certain subscriptions.',
  to_upgrade: 'to upgrade',
  choose_your_form_view: 'Choose your Form View',
  form_view: 'Form View',
  how_would_you_like_to_proceed: 'How would you like to proceed?',
  keep_both: 'Keep Both',
  delete_both: 'Delete Both',
  delete_only_this: 'Delete only this',
  this_task_has_another_log_related_to_it: (type1: any, type2: any) =>
    `This ${type1 || 'task'} has another ${type2 || 'log'} related to it`,
  are_you_sure_you_want_to_duplicate_rule: 'Are you sure you want to delete this rule?',
  not_published: 'Not Published',
  published: 'Published',
  incomplete: 'Incomplete',
  import_own_stock_download_template: 'If needed, please first download our',
  import_own_stock_note: 'All rules and own stock filter into one instant inventory feed.',
  own_stock_csv_note: 'to see the inventory uploaded through this CSV File',
  jewelry_criteria: 'Jewelry Criteria',
  widget_setting_url_warning:
    'The Website URL the Instant Inventory will be implemented in. The website URL has to be correct in order for Instant Inventory to work properly',
  add_your_search_widget: 'Add your Instant Inventory Feed to your Website',
  script_copy_the_script_below:
    'Script: if you are using the pre-designed widget, copy this script and send it to your web programmers in order to integrate the code into your website.',
  copy_the_script_below:
    'Copy this script and send it to your web programmers in order to integrate the code into your website.',
  if_you_are_building_your_own_search_widget:
    'TechNet: If you are building your own search widget, copy and send this link to your web programmer so he can access our web services.',
  technet_info_tooltip:
    "Technet is Rapnet's API documentation, which includes instructions for your developer on how to create a customized Instant Inventory experience for you website.",
  edit_rule_name: 'Edit Rule Name',
  edit_diamonds: 'Edit Diamonds',
  edit_suppliers: 'Edit Suppliers',
  edit_price_mark_ups: 'Edit Price Mark-Ups',
  edit_jewelry: 'Edit Jewelry',
  search_for_a_shape: 'Search for a Shape',
  type_slash_select: 'Type / Select',
  type_in_shape: 'Type in shape...',
  preset_ratio: 'Preset Ratio',
  crown_height_percent: 'Crown Height%',
  crown_angle: 'Crown Angle',
  pavilion_depth_percent: 'Pavilion Depth%',
  pavilion_angle: 'Pavilion Angle',
  culet_cond: 'Culet Cond.',
  no_upcoming_tasks: 'You have no upcoming tasks',
  no_upcoming_tasks_message: 'Manage your business by tracking your tasks',
  create_a_new_task: 'Create a new task',
  oh_no_its_gone: 'Oh no. It’s gone.',
  no_longer_on_rapnet: 'The item you are looking for is no longer on RapNet.',
  dont_give_up: 'Don’t give up, the item you want is a few clicks away.',
  click_preview_share: 'Click here to preview the page',
  copy_link: 'Copy Link',
  anyone_with_link_can_view: 'Anyone with the link can view this page',
  generate_public_link: 'Generate Public Link',
  generate_link: 'Generate Link',
  share_link_available: 'Share Link will be available for the next 7 days',
  share_on_facebook: 'Share on Facebook',
  generate_page_and_continue: 'Generate Page & Continue',
  share_via_link: 'Share via Link',
  supplier: 'Supplier',
  all_contacts: 'All Contacts',
  your_tags: 'Your Tags',
  look_for_create_label: 'Look for / Create new tag',
  edit_your_tags: 'Edit your tags',
  inquiries: 'inquiries',
  customer_name_email: 'Customer Name & Email',
  item_source: 'Item & Source',
  prices_total: 'Prices (Total$)',
  date_status: 'Date & Status',
  item_page: 'Item Page',
  add_to_contact: 'Add to Contact',
  customer_details_inquiry: 'Customer Details & Inquiry',
  date_dash_ime: 'Date / Time',
  open_contact_page: 'Open Contact Page',
  add_to_my_contacts: 'Add to My Contacts',
  lead_source: 'Lead Source',
  item_details_and_price: 'Item Details & Price',
  item_id: 'Item ID',
  certificatelattice: 'Certificate #',
  inquiry_from: (label: any, date: { fullDate: any; hour: any }) =>
    `Inquiry from ${label} on ${date.fullDate} at ${date.hour}`,
  the_item_not_listed_on_rapnet:
    "The item is no longer listed on RapNet and you can't contact the seller about it",
  coming_soon: 'Coming Soon',
  click_activate_to_add_items_to_your_website: (type: any) =>
    `Click on "Activate" to start adding your Instant Inventory Feed ${type} on your website.`,
  we_will_now_create_rules_for: (type: any) => `
    We now need to create some Rules to define which ${type} you want to include in this specific instant inventory. To create a set of Rules, you choose the following:`,
  each_instant_inventory_must_have_at_least_one_rule_that: (
    type: any
  ) => `Each Instant Inventory must have at least one rule to determine which ${type} it contains.
    Once you’ve created your rules, you can edit them or add new rules anytime to include more ${type}, change price markups or suppliers in this Instant Inventory.`,
  supplier_rule_description: (type: any) =>
    `Suppliers who’s ${type} you want to use in your Instant Inventory`,
  price_markups_rule_description: (type: any) => `Price mark ups you want to apply to the ${type}`,
  tip_make_sure_the_design:
    'TIP: Pick a theme color to blend into the feel of your website and select information that you want to display on your website',
  note_that_design_is_example: (type: any) =>
    `Note that the ${type} below are an example. Your selected ${type} will appear once you finish your Instant Inventory setup.`,
  predesigned_widget: 'Pre-Designed Widget',
  without_design: 'Without Design',
  widget_themes_description: (type: any) =>
    `Pre-Designed Widget: This is an easy and quick way of integrating Instant Inventory Feed ${type} into your retail website. Customize your widget theme color, Pick the theme color and choose which information to display on the ${type} search page.`,
  own_search_widget_themes_description:
    'Fully customize and build your own search widget. Choose this option if you want your own web developer to customize your design using our API. After you have set up your widget, we will provide you with details instructions for your web developer',
  choosing_parameters_such_as_eye_clean:
    'Selecting parameters like Eye Clean, Guaranteed Availability, Greenstar, Source, or Depth % may limit the number of diamonds appearing in your Instant Inventory feed.',
  supplier_rule: 'Which suppliers would you like to include in this instant inventory feed?',
  set_price_mark_ups: 'Set the retail prices for your customers',
  additional_markup: '$ Markup',
  type_of_markup: 'Markup Type',
  diamond_markup_tooltip: 'Set your retail prices based on price or carat for your customers.',
  markups_alert_note_part_1:
    'All price mark-ups within one rule must be based on the same criteria: either depending on the price range of the diamonds or the weight.',
  markups_alert_note_part_2:
    'To change your chosen mark-up settings, you must first delete all your current markups.',
  lattice_of_items: '# of Items',
  media_library: 'Media Library',
  add_to_item: 'Add to item',
  connected_disconnected: 'Connected / Disconnected',
  disconnect_from_item: 'Disconnect from item',
  media_name_type: 'Media Name & Type',
  id_num: 'ID #',
  select_from_media_library: 'Select from Media Library',
  upload_images_from_local_file: 'Upload Image/s from Local File',
  import_images_from_cloud: 'Import Image/s from Cloud',
  add_video_from_website: 'Add Video from Website',
  all_media: 'All Media',
  new_email_campaign: 'New Email Campaign',
  create_campaign: 'Create Campaign',
  create_new_email_campaign: 'Create a New Email Campaign',
  email_content: 'Email Content',
  test_and_send: 'Test & Send',
  choose_design_for_your_campaign: 'Choose a design for your campaign',
  personalize_your_design: 'Personalize your Design',
  my_contacts_theme_name: 'Theme: Lockdown',
  view_example: 'View Example',
  define_subject_content_your_email: 'Define the subject and the content for your email',
  subject_placeholder: 'Type here a subject for your email…',
  button: 'Button',
  picture: 'Picture',
  email_from_placeholder: 'Type here your name…',
  button_placeholder: 'Type here your button text…',
  button_url_placeholder: 'http:// Paste here your button link…',
  email_title_placeholder: 'Type here a title for your email…',
  do_not_include_picture: 'Do not include a picture',
  do_not_include_button: 'Do not include a button',
  do_not_include_logo: 'Do not include a logo',
  add_subject_for_your_email: 'Add the subject for your email',
  add_content_for_your_email: 'Add the content for your email',
  add_button_text: "Add the button's text",
  add_button_url: "Add the button's URL address (include http:// or https://)",
  logo: 'Logo',
  send_to_contacts: 'Send to Contacts',
  you_are_ready: 'You are ready!',
  optional_first_letter_uppercase: 'Optional',
  send_test: 'Send test',
  email_placeholder: 'Type here the email…',
  send_test_email: 'Send test email to (optional)',
  select_all_my_contacts: 'Select All My Contacts',
  email_testing_suggesting:
    'We suggest to send a test email to yourself or somebody else to check what your contacts will receive.',
  create_new_email_campaign_note:
    'Keep your Contacts up to date by sharing your latest news, promoting an item, or announcing an event.',
  you_about_to_send_emails: (amount: any) =>
    `You are about to send an email to ${amount} contacts.`,
  email_campaign_warning: (amount: any) =>
    `Email campaign can be sent to ${amount} contacts maximum per email campaign. Please select up to ${amount} contacts.`,
  email_campaign_selected_more_than_limit: (amount: any) =>
    `Wow, that's a lot! You can send up to ${amount} emails per campaign. Please go back and remove some of the contacts from this campaign`,
  emails_left: 'emails left',
  emails_quota_tooltip:
    'Number of emails available for sending according to your current email credit',
  connected_media: 'Connected Media',
  not_connected_media: 'Not Connected Media',
  upload_new_media: 'Upload New Media',
  upload_date: 'Upload Date',
  connected_to_item: 'Connected to Item',
  not_connected_to_any_file: 'Not connected to any file',
  disconnect_media: 'Disconnect Media',
  connect_to_item: 'Connect to item',
  delete_this_media_also_from_my_media_library: 'Delete this media also from my media library',
  disconnected: 'Disconnected',
  add_media: 'Add Media',
  sure_you_want_to_disconnect_this_media:
    'Are you sure you want to disconnect this media from this item?',
  video_link: 'Video Link',
  are_you_sure_delete_video: 'Are you sure you want to delete this video from this item?',
  uplosd_image_s: 'Upload Image/s',
  media_connected_to_this_item: 'Media Connected to this Item',
  connect_media_to_item: 'Connect Media to Item',
  connect_modal_subheader:
    'Look for the item you would like to connect the media by typing its Lot# or Stock#',
  connect_media: 'Connect Media',
  load_item: 'Load Item',
  invalid_video_url: 'Invalid video url.',
  video_is_not_part_of_arpnet_approved_providers:
    'Your video is not part of RapNet approved providers. Please contact your video provider for details.',
  manage_media: 'Manage Media',
  load_more: 'Load More',
  only_media_uploaded:
    'Only media uploaded as a file that contains an image will be displayed on this item page. To view additional media items, use the diamond media pop up from search results.',
  raplab_video: 'RapLab Video',
  date_uploaded: 'Date Uploaded',
  lattice_of_jewelry: '# of Jewelry',
  supplier_permission_tooltip:
    'These are suppliers who’ve given you permission to use their listings on your e-commerce website',
  treatments: 'Treatments',
  copied: 'Copied!',
  boost_your_diamond: 'Boost your diamond',
  get_a_high_quality_video: 'Get a high quality 360° video with RapLab video services.',
  see_sample: 'See Sample',
  back: 'Back',
  publish_to_my_website: 'Publish to My Website',
  inactive: 'Inactive',
  customize_design_build_search_widget_tooltip:
    'Fully customize and build your own search widget. choose this option if you want your own web developer to customize your design using our API. After you have set up your widget, we will provide you with details instructions for your web developer.',
  instant_inventory_pricing_note: (type: any) =>
    `To ensure maximum amount of ${type} on your Instant Inventory, you markup should fully cover the selected price/carat range.`,
  your_price_range_is: (price: { from: any; to: any }) =>
    `Your price range is $${price.from} - $${price.to}`,
  see_above_some_price_ranges: 'See above, some price ranges are missing mark ups.',
  select_eye_clean_will_reduce_number_of_diamonds:
    'Selecting Eye Clean will reduce the number of diamonds in your feed.',
  select_fluorescence_will_reduce_number_of_diamonds:
    'Selecting Fluorescence Intensity will reduce the number of diamonds in your feed.',
  prices_are_required: 'Prices are required',
  jewelry_types_are_required: 'Jewelry types are required',
  no_media: 'No Media',
  reserveMet: 'Reserve Met',
  no_media_to_display: 'No media to display',
  not_media_connected_to_this_item: 'Not media connected to this item',
  widget_themes_description_v2: (type: any) =>
    `Pre-Designed Widget: This is an easy and quick way of integrating Instant Inventory ${type} into your retail website. You can later customize your widget theme color, Pick the theme color and choose which information to display on the ${type} search page.`,
  thank_you_for_your_interest_in_the_LA: 'Thank you for your interest in the Live Auctions!',
  lot_stock_not_exist: 'Lot# / Stock# does not exist',
  rapaport_tradesheet: 'Rapaport TradeSheet',
  the: 'The',
  the_rapaport_tradesheet_provides:
    'provides Rapaport Discount Prices with percentage discounts in relation to the Rapaport Price List. The discount prices reflect our opinion of prices at which natural diamonds meeting',
  are_available_for_sale: 'are available for sale.',
  caution_the_rapaport_pricelist_and_tradsheet:
    'CAUTION: THE RAPAPORT PRICE LIST AND TRADESHEET SHOULD ONLY BE USED AS A GENERAL GUIDELINE. TRANSACTION AND ASKING PRICES MAY VARY SIGNIFICANTLY. CONSULT EXPERTS BEFORE BUYING, SELLING OR VALUING DIAMONDS.',
  the_rapaport_group_invites:
    'The Rapaport Group invites suggestions and comments about our diamond price information services. We are particularly interested in data about prices and your views regarding our new TradeSheet.',
  please_email: 'Please email',
  download_tradesheet: 'Download TradeSheet',
  guide_to_tradesheet: 'Guide to TradeSheet',
  download_the_rapaport_tradesheet: 'Download the Rapaport TradeSheet',
  maximum_file_size_only_jpeg_png_accepted:
    'Maximum Single File Size is 10MB. Only JPEG, PNG, GIF, ZIP are accepted. ZIP file containing invalid formats will upload only accepted formats of images.',
  uploading_a_file_with_existing_file_name_will_over_write_the_media_file_in_your_media_library:
    'Uploading a file with existing file name, will over write the media file in your media library.',
  contact_me: 'Contact Me',
  i_like_to_be_notified_via_email_about_raplab_video_services: `I'd like to be notified via email for additional information about RapLab video services.`,
  NV: 'NV',
  you_have_set_up_your_search_instant_inventory: (type: any) =>
    `Congrats! Your Instant Inventory ${type} feed is set up!`,
  there_are_two_methods_of_integrating:
    'There are two methods of integrating your Instant Inventory Feed to your website',
  method_quick_and_easy_using_rapnet: 'Quick and Easy using RapNet’s Instant Inventory Widget',
  customize_and_embed_rapnet_instant_inventory_widget:
    'Customize and embed RapNet’s Instant Inventory widget into your website. The widget includes a built in search engine and contact form, and you can personalize the widget’s design to blend into the theme of your website. All you need to do is provide the script below to your web designer. The script must be added to a blank page in your website for best integration.',
  please_note_that_this_widget_cannot:
    'Please note that this widget cannot be connected to a shopping cart and has limited customization features.',
  method_powerful_customization_opportunity: 'Method 2 – Powerful customization opportunity',
  build_your_own_search_engine_using_your_developers:
    'Build your own search engine using your developers and web designer. Instant Inventory API access allows you freedom to design your own unique search engine and customer flow while we take care of providing and maintaining up to date diamond inventory for you. All you need to copy the "Technet" link and send it to your web designer. This method of integration is ideal if you have existing e-commerce and shopping cart applications.',
  method: 'Method',
  instant_inventory_set_up: (type: any) =>
    `Congratulations! Your Instant Inventory ${type} feed is set up!`,
  are_you_sure_you_want_delete_tag: 'Are you sure you want to delete this tag?',
  tag_with_this_name: 'A tag with this name already exists',
  seller_commision: 'Seller Commission',
  add_video_approved_providers_message:
    "RapNet approved video providers will be displayed on the Item Page. Your video will be displayed in RapNet's diamond media section.",
  item_page_media_delete_tooltip:
    'Images uploaded as links cannot be deleted from item page. Update your diamond and remove the link via diamond upload option',
  // user Settings:
  manage_instant_inventory: 'Manage Instant Inventory',
  instant_inventory_setup: 'Instant Inventory Setup',
  view_rapnet_member_directory: 'View RapNet Member Directory',
  oh_oh: 'Oh-oh.',
  cookies_are_blocked: 'Cookies are blocked by your browser.',
  you_must_enable: 'You must enable cookies and then refresh this page to use RapNet.',
  access_trade_center: 'Full Access To Trade Center',
  view_manage_contacts: 'View / Manage Contacts',
  view_manage_shared_items: 'View / Manage Shared Items',
  exceeded_character_limit: "You've exceeded the character limit",
  prmission_contact_me_message:
    "I'd like to be contacted by RapNet Customer Service for additional information",
  high_bid_with_sign: 'HIGH $US BID',
  highest_bid_ct_with_sign: 'HIGH $US/CT',
  us_dollar_slash_ct_upper_case: '$US/CT',
  us_dollar_total_first_sigh_dollar: '$US Total',
  my_instant_inventory: 'My Instant Inventory',
  bit_modal_text_for_below_price:
    'Your bid is below the reserve price and there is no assurance that your bid will be accepted at the close of the auction.',
  your_request_was_sent_successfully: 'Your request was sent successfully',
  search_filters: 'search filters',
  results_with_gallery: 'Search results with gallery view',
  customized_diamond_info: 'Customized diamond page information',
  upgrading_to_the_new_widget_design:
    'Upgrading to the new widget design will change the old widget design on your website permanently and requires updating the widget code on your website. Click "Yes" to continue',
  edit_email_tooltip: 'Email details can be edited by Primary Member of account',
  i_like_to_be_notified_via_email_once_share_is_available: `I'd like to be notified via email once "Share" feature is available`,
  leads: 'Leads',
  rapnet: 'RapNet',
  i_invent: 'I. Invent',
  create_new_tag: 'Create New Tag',
  shared_markup_price: 'Shared Markup Price ($)',
  no_options: 'No Options',
  search_diamonds_d_lower: 'Search diamonds...',
  search_jewelry_j_lower: 'Search jewelry...',
  shared_price: 'Shared Price',
  upload_csv_with_image_links: 'Upload CSV with Image Links',
  only_csv_format_is_accepted: 'Only CSV format is accepted',
  the_csv_file_should_contain_one_column_with_image_links:
    'The CSV file should contain one column with image links',
  your_file_is_processing: 'Your file is processing.',
  you_will_receive_an_upload_report_to_your_email_shortly:
    'You will receive an upload report to your email shortly.',
  add_video_additional_whitelisted_video_message:
    "RapNet approved video providers will be displayed on the Item Page. Your video will be displayed in RapNet's diamond media section.",
  account_details: 'Account Details',
  wrong_format_use_csv: 'Wrong format. Please use CSV format',
  apply_now: 'Apply Now',
  ii_free_trial_description_part1:
    'Click "Apply Now" for a RapNet representative to activate your 30-day free trial where you can test drive Instant Inventory on your website for free!',
  ii_free_trial_description_part2:
    "Don't have a website yet? RapNet is partnered with Thinkspace, a web technology company, to help our members build their own diamond and/or jewelry online store.",
  ii_widget_private_policy:
    'By supplying your contact information, you authorize us to contact and promote our services to you on and across different services, websites and apps in accordance with our',
  congratulations: 'Congratulations!',
  instant_inventory_set_up_v2: (type: any) => `Your Instant Inventory ${type} feed is set up!`,
  click_here_to_preview: 'Click here to preview',
  still_using_the_old_widget: "I'm still using the old widget",
  new_widget_available_click: 'New widget design available, click',
  to_check_it_out: 'to check it out!',
  upgrade_to_the_new_diamond_widget: 'Upgrade to the new diamond widget',
  the_new_diamond_widget_includes_advanced_search_filters:
    'The new diamond widget includes advanced search filters, search results with gallery view, customized diamond page information, responsive design (mobile & tablet support) and is ideal for eCommerce.',
  thanks: 'thanks',
  upgrade_my_design: 'Upgrade my design!',
  upgrading_to_the_new_widget_design_will_change_the_old:
    'Upgrading to the new widget design will change the old widget design on your website permanently and requires updating the widget code on your website.',
  update_the_script_on_your_website: 'Update the script on your website',
  in_order_to_update_the_widget_design:
    'In order to update the widget design, all you need to do is replacing your current script with the script below.',
  with_media: 'with media',
  with_media_means_that_only_diamonds:
    'Note: With Media means that only diamonds with images and/or videos will appear in your feed. Selecting this option will reduce the amount of diamonds in your feed',
  protect_contact_information: 'Protecting Contact Information',
  protect_contact_information_note_1:
    'Your contacts trust you to act responsibly with their information.',
  match_price: 'Match Price',
  add_new_term: '+ Add New Term',
  update_price_and_terms: 'Update Price & Terms',
  mark_as_completed: 'Mark as Completed',
  both_agreed_and_signed: 'Both Agreed & Signed',
  view_invoice: 'View Invoice',
  send_invoice: 'Send Invoice',
  invoice_number: 'Invoice Number',
  account_rating: 'Account Rating',
  group_details: 'Group Details',
  sale_conditions: 'Sale Conditions',
  see_negotiation_terms: 'See Negotiation Terms',
  negotiation_terms: 'Negotiation Terms',
  me: 'Me',
  contacts_and_communications: 'Contacts & Communications',
  item_conversations: 'Item Conversations',
  is: 'is',
  view_purchase_order: 'View Purchase Order',
  preview_purchase_order: 'Preview Purchase Order',
  purchase_number: 'Purchase Number',
  click_yes_to_continue: 'Click “Yes” to continue.',
  thank_you_for_applying: 'Thank you for applying!',
  rapnet_will_contact_you: 'A RapNet representative will contact you within 2 business days.',
  test_email_sent_successfully: 'Test email sent successfully',
  marketing_email_campaign_tooltip:
    'To create an email campaign, first mark the contacts you would like to send the email to, and click on this button.',
  email_campaign: 'Email Campaign',
  promoted_diamonds: 'Promoted Diamonds',
  sell_with_auctions: 'Sell With Auctions',
  get_more_info: 'Get more Info',
  promoted_modal_first_text: 'NEW PROMOTIONAL OPPORTUNITY FOR DIAMOND SUPPLIERS',
  promoted_modal_second_text:
    'Increase your diamonds’ visibility on RapNet! You can now promote your diamonds on RapNet so they appear at the top of the search results.  Want to find out more about this service?',
  yes_please_contact_me: 'Yes, please contact me!',
  lists: 'Lists',
  your_lists: 'My Lists',
  lists_shared_with_you: 'Lists Shared With Me',
  created_on: 'Created on',
  last_modified_on: 'Last modified on',
  you_created_this_list: 'You created this list',
  rename_list: 'Rename List',
  print_or_email_inventory: 'Print / Email Inventory',
  export_inventory_to_excel: 'Export Inventory to Excel',
  list: 'List',
  created_by: 'Created by',
  shered_with_you: 'shered with you',
  last_modified: 'Last modified',
  email_sent_successfully: 'Email Sent Successfully',
  have_permission_to_store_and_use_their_information:
    '- You have permission to store and use their information to send transactional and promotional messages',
  contacts_have_opted_out_of_sharing:
    '- Your contacts haven’t opted out of sharing with you any of this information',
  contact_opts_out_of_sharing_their_information:
    '- If a contact opts out of sharing their information at any point, you’ll remove that information immediately',
  by_clicking_ok_you_agree: 'By clicking OK, you agree to the following:',
  all_you_need_to_do_is: ' All you need to do is clicking on “Send”.',
  buyer_no_offer_message: 'The buyer has not made an offer yet',
  seller_no_offer_message:
    'The seller has not published an asking price. Initiate the trade by making an offer',
  you_no_offer_message: 'You have not made an offer yet',
  rapnet_admin_message: 'This is a RapNet Admin message',
  remove_item: 'Remove Item',
  remove_pair: 'Remove Pair',
  day: 'day',
  creator_and_ollaborators: 'Creator & Collaborators',
  only_you_can_see_this_list: 'Only you can see this list',
  collaborators: 'collaborators',
  size_range_should_be_valid: 'Please specify size range from low to high',
  did_you_know: 'Did you know...?',
  upload_profile_picture: 'Upload profile picture',
  image_dropzone_acceptance: 'Maximum File Size is 4 MB. Only JPEG, PNG and GIF are accepted.',
  to_remove_member: 'to remove this member from the account.',
  remove_member_title: 'Remove member from account',
  remove_member_message: 'Are you sure you want to remove this member from the account?',
  marketing_emails_logo_note:
    'You haven’t uploaded a logo yet, so this section will be empty in your email. If you want to upload one now please',
  view_manage_leads: 'View / Manage Leads',
  promotion: 'Promotion',
  reengagement: 'Re-engagement',
  upload_items_as_own_stock: 'Upload items as "Own Stock" items for your Instant Inventory',
  jewelry_ownstock_note1: 'To upload jewelry items as your own stock, please click go to the page',
  jewelry_ownstock_note1_end: 'in the jewelry page',
  jewelry_ownstock_note2:
    'Please mind that the option “Upload items as your own stock” will be marked.',
  in_a_new_tab: 'in a new tab',
  delete_ownstock_jewelry_from_ii:
    'Are you sure you want to delete all your jewelry own stock items?',
  to_include_your_own_stock:
    'To include your own jewelry in your Instant Inventory jewelry feed but not show them on RapNet, you will need to upload a jewelry CSV file and jewelry images. Click the ',
  to_include_your_own_stock_end: ' button below to start uploading now.',
  upload_own_stock: 'Upload Own Stock',
  not_sure_how_to: 'Not sure how to create your own CSV file? Read this ',
  not_sure_how_to_end: ' and download the CSV file ',
  user_permissions_note:
    '*Permissions per user will be updated once user logs out and logs back in',
  notification_sent_to: 'Notifications will be sent to',
  ii_free_trial_description_new:
    'In order to publish your feed on your website, you must activate the Instant Inventory add-on.',
  activate_free_trial: 'Activate Free Trial',
  ii_free_trial_description_new_2:
    'To test drive Instant Inventory on your website for free, click the button below',
  ii_free_trial_description_new_3:
    'and a RapNet representative will activate your 30-day free trial.',
  ii_free_trial_upgrade: 'To upgrade to Instant Inventory now, ',
  instant_inventory_set_up_v2_new: (type: any) => `Your Instant Inventory ${type} Feed is Set Up!`,
  this_is_promoted: 'This is a Promoted Diamond!',
  to_get_more_details: 'to get more details.',
  shares: 'Shares',
  inventory_insights: 'Inventory Insights',
  to_date_total_views: 'To-Date total views and share of your Inventory',
  upgrade_to_premium: 'Upgrade to premium to get more statistics',
  breakdown_by_source: 'Breakdown by source',
  thanks_for_your_interest: 'Thanks for your interest.',
  you_will_be_contacted: 'You will be contacted by customer service for further details.',
  upgrade: 'Upgrade',
  add_selected_items_to_list: 'Add selected items to list',
  are_you_sure_you_want_to_remove_from_list:
    'Are you sure you want to remove this item from the list?',
  add_a_comment: 'Add a Comment',
  type_here_your_comment: 'Type here your comment...',
  add_comment: 'Add Comment',
  item_first_letter_uppercase: 'Item',
  add_item_to_list: 'Add Item to List',
  add_items_to_a_list: 'Add Items to a List',
  look_for_create_list: 'Look for / Create new list',
  create_new_list: 'Create New List',
  created_by_you: 'Created by you',
  modified_on: 'modified on',
  list_not_found_item_note: 'Please type a different Lot #',
  items_added_successfully: 'Items added successfully',
  item_added_successfully: 'Item added successfully',
  you_can_now_manage_your_list_1: 'You can now manage your list and add collaborators',
  you_can_now_manage_your_list_2: 'from your Lists page',
  click_here_to_manage: 'Click here to manage your List now',
  collaborators_first_letter_uppercase: 'Collaborators',
  collaborator: 'Collaborator',
  leave_list: 'Leave List',
  leave_list_note: 'Are you sure you want to leave this list?',
  collaborator_added_1: 'Collaborator added successfully',
  collaborator_added_2: 'The new collaborator will receive an invite through RapNet notification',
  delete_collaborator_note:
    'Are you sure you want to remove this collaborator from the list? Please mind the collaborator’s comments will remain.',
  add_member_as_collaborator: 'Add Member as Collaborator',
  add_selected_items_to_list_uppercase: 'Add Selected Items to List',
  lists_created: 'List(s) Created',
  lists_shared: 'List(s) Shared',
  added_an_item: 'added an item',
  added_items: 'added items',
  removed_an_item: 'removed an item',
  added_collaborator: 'added a collaborator',
  removed_collaborator: 'removed a collaborator',
  the_list: 'the list',
  export_list_to_excel: 'Export List to Excel',
  left: 'left',
  renamed_list_as: 'renamed list as',
  quote: 'Quote',
  remove_collaborator: 'Remove Collaborator',
  select_member: 'Select Member',
  type_a_member_name: 'Type a member name...',
  companies: 'companies',
  get_more_data_insigts:
    'Get more data insights per item page by upgrading to premium item analytics service.',
  collaborator_first_letter_lowercase: 'collaborator',
  rename_chat: 'Rename Chat',
  see_all_chats_discussions: 'See All Chats & Discussions',
  no_messages_found: 'No messages found',
  group_modal_select_member: 'Select Member to Start Chat',
  group_modal_select_members: 'Select Members for your Group Chat',
  group_modal_add_members: 'Add Members to Chat',
  archive_chat: 'Archive Chat',
  unarchive: 'Unarchive',
  leave_chat: 'Leave Chat',
  are_you_sure_you_want_to_leave_this_chat: 'Are you sure you want to leave this chat?',
  you_are_currently_the_admin:
    'You are currently the admin, please choose among the options below:',
  leave_and_close_the_group: 'Leave and close the group - the participants will be notified',
  leave_and_keep_the_group: (name: any) =>
    `Leave and keep the group - ${name} will be the admin now`,
  chat_frozen_message: 'This group is closed. You can’t send messages',
  archived_chats: 'Archived Chats',
  are_you_sure_you_want_to_archive_this_chat: 'Are you sure you want to archive this chat?',
  archived: 'Archived',
  import_from_csv_file: 'Import from CSV File',
  import_contacts_from_csv_file: 'Import Contacts from CSV File',
  import_your_contact_list_from_an_existing_file: 'Import your contact list from an existing file',
  update_an_existing_contacts:
    'Update an existing contact’s information based on their email address',
  import: 'Import',
  check_back_shortly_to_view_your_contacts_upload_report:
    'Check back shortly to view your contacts upload report in ',
  delete_file: 'Delete File',
  ok_first_letter_upper_case: 'Ok',
  ring_builder: 'Ring Builder',
  choose_a_design_theme_for_your_ring_builder: 'Choose a design theme for your Ring Builder',
  select_our_pre_designed_widget_theme_or_continue_without_design:
    'Select our pre-designed widget theme or continue without design',
  see_ring_builder_demo: 'See Ring Builder Demo',
  congrats_you_have_set_up_your_ring_builder: 'Congrats! You have set up your Ring Builder',
  settings_will_you_offer_in_our_ring_builder_widget:
    'Now select the ring style collection you want to offer in your ring builder widget.',
  add_your_ring_settings: 'Choose your Ring Style Collection',
  choose_your_catalogs_source: 'Choose your Ring Style Collection',
  choose_your_catalogs_source_note:
    'This is the ring style collection you want to offer your customers',
  predefined_catalog: 'RapNet’s Ring Style Collection',
  source_automatically_supplier: 'Build and create ring style’s from RapNet Ring Style Catalog',
  use_my_own_ring_settings: 'Choose your Ring Style Collection',
  upload_your_own_catalog_of_rings:
    'This is the ring style collection you want to offer your customers',
  ring_settings: 'Ring Settings',
  general_info: 'General Info',
  setting_style: 'Setting Style',
  variants_details: 'Variants Details',
  general_info_about_your_setting: 'Information about your Ring Style',
  save_and_next: 'Save & Next',
  type_here_brand_name: 'Type here a brand name...',
  type_here_brand_description: 'Type here a brand description...',
  type_here_shipping_details: 'Type here the shipping details...',
  type_here_payment_details: 'Type here your payment details...',
  save_this_information_as_default:
    'Save this information as my default for settings uploaded in the future',
  mark_up_uppercase: 'Mark-Up',
  additional: 'Additional',
  add_price_mark_up: 'Add price mark-up:',
  you_have_introduced_your_ring_settings: 'You have set up your Ring Style Collection!',
  its_time_for_you_to_select_which_diamonds:
    'Now select the diamonds you want to offer in your ring builder widget.',
  set_up_your_diamond_feed: 'Set Up your Diamond Feed',
  settings_catalog: 'Ring Style',
  my_settings: 'my settings',
  congratulations_ring_builder_set_up: 'Congratulations. Your Ring Builder is set up!',
  specify_the_details_for_your_settings_variants: 'Specify the details for your settings variants',
  introduce_your_setting_style_info: 'Ring Configuration',
  in_which_metals_is_this_setting_produced: 'In which metals is this setting produced?',
  which_diamond_shape_can_be_mounted: 'Which diamond shapes can be mounted with this setting?',
  which_diamond_carats_can_be_mounted: 'Which diamond carats can be mounted with this setting?',
  in_which_sizes_are_setting_avaiable: 'In which sizes are this setting available?',
  company_lower_case: 'company',
  variants: 'Variants',
  define_this_ring_style: 'Define each ring variation of this style',
  your_ring_builder_set_up: 'Your Ring Builder Set Up!',
  ii_free_trial_ringbuilder_description:
    'In order to publish your Ring Builder on your website, you must activate the Instant Inventory add-on.',
  create_your_fist_ring_style: 'Create your first ring style',
  semi_mount: 'Semi Mount',
  stone_weight: 'Stone Weight',
  side_stone: 'Side Stone',
  diamond_quantity: 'Diamond Quantity',
  this_ring_setting_has_semi_mounted_stones: 'This ring setting has side-stones/ melee',
  size_of_melee: 'Size (mm) of Melee',
  point_size_of_elee: 'Point Size of Melee',
  my_default_for_this_setting_style: 'Save this information as my default for this setting style',
  your_promoted_diamonds_got: 'Your Promoted Diamonds Received',
  impressions: 'Impressions',
  you_are_running_out_of_credits: 'You are running out of impressions.',
  you_ran_out_of_credits: 'You ran out of impressions',
  get_additional_impressions_here: 'Purchase additional credits here:',
  buy_credits: 'Buy Credits',
  data_displayed_from_the: 'Data displayed from the ',
  you_will_be_contacted_shortly_by_customer_service:
    'You will be contacted shortly by customer Service.',
  promoted_from: 'Promoted From',
  promoted_last: 'Last Promoted',
  impression_count: '# Impressions',
  diamonds_promoted: 'Diamonds Promoted',
  choose_package: 'Choose Package',
  preview_and_purchase: 'Preview & Purchase',
  confirmation: 'Confirmation',
  purchase_impressions_and_promote_your_diamonds: 'Purchase Impressions and Promote your Diamonds',
  check_out_the: 'Check out the ',
  page_to_find_out_more_about_promoted_diamonds: ' page to find out more about Promoted Diamonds',
  impressions_lower_case: 'impressions',
  most_popular: 'Most Popular!',
  selected: 'Selected',
  continue_with_payment: 'Continue with Payment',
  promoted_diamonds_is_a_new_service:
    "Promoted Diamonds is a new service to increase your inventory's",
  visibility_among_your_target_audience: 'visibility among your target audience.',
  do_you_want_to_learn_more: 'Do you want to learn more about this service?',
  yes_send_me_info_by_email: 'Yes! Send me information by email',
  make_payment: 'Make Payment',
  metals_and_diamond_shapes: 'Metals & Diamond Shapes',
  diamond_carats: 'Diamond Carats',
  available_sizes: 'Available Sizes',
  add_new_ring_style: 'Add New Ring Style',
  ring_settings_image_tooltip: 'This image will appear on the main ring settings search',
  acceptable_image_types: 'Acceptable file types: JPEG, JPG, PNG',
  have_you_removed_this_item: 'Have you removed this item?',
  keep_your_contacts_always_handy: 'Keep your contacts always handy!',
  Click_on_the_cell_above_to_save_your_first_contact:
    'Click on the cell above to save your first contact',
  pin_first_letter_uppercase: 'Pin',
  your_pinned_contacts: 'Your Pinned Contacts',
  pin_contact_into_your_dashboard: 'Pin a contact into your dashboard',
  choose_a_contact: 'Choose a contact',
  have_you_removed_this_page: 'Have you removed this page?',
  impressions_for_your_listings: 'impressions for your listings',
  date_of_activation: 'Date of activation:',
  to_pay: 'To pay:',
  choose_a_different_package: 'Choose a different package',
  package: 'Package',
  payment_processed_successfully: 'Payment processed successfully',
  your_payment_couldnt_be_processed: 'Your payment couldn’t be processed successfully',
  need_some_assistance: 'Need some assistance? Contact your customer service representative ',
  you_can_view_your_purchase_history: 'You can view your purchase history ',
  pictures: 'Pictures',
  ring_style_information: 'Ring Style Information',
  ring_setting: 'Ring Setting',
  data: 'Data',
  delete_this_setting: 'Are you sure you want to delete this setting?',
  front: 'Front',
  side: 'Side',
  standing: 'Standing',
  cvv_is_the_last_three_digits: 'CVV is the last three digits on the back of your credit card.',
  secured_transaction: 'Secured Transaction',
  product: 'Product',
  purchase_history: 'Purchase History',
  reorder: 'Reorder',
  download_invoice: 'Download invoice',
  credits: 'credits',
  number_of_credits_used: '# of Credits Used',
  information_about_shipping_and_return: 'Information about Shipping and Return',
  information_about_payment_policy: 'Information about Payment Policy',
  type_here_information_related_to_payment: 'Type here information related to payment policy, etc.',
  ringbuilder_template_tooltip: 'This information will be shown in "Step 3 - Review"',
  discover: 'Discover',
  enhance_you_presence_on_rapnet:
    'Enhance your presence on RapNet by boosting your diamond listings',
  purchase_the: 'Purchase the ',
  amount_of_credits: 'amount of credits ',
  you_need: 'you need',
  get: 'Get ',
  real_time_performance_data: 'real time performance data',
  click_for_more_info: 'Click for more information',
  promote_your_diamonds_now: 'Promote your Diamonds Now!',
  add_item_to_a_list: 'Add Item to a List',
  current_collaborators: 'Current collaborators',
  look_for_member: 'Look for a member',
  add_new_collaborators: 'Add new collaborators',
  will_receive_an_invite_through_rapnet_notifications:
    'Will receive an invite through RapNet notifications ',
  galery_view_tooltip: 'This view displays items with images only',
  maximum_number_of_characters_reached: 'Maximum number of characters reached',
  manage_your_ring_settings_mountings: 'Manage your ring settings/mountings',
  publish_tooltip_text: 'To publish this item upload at least 1 image',
  publish_first_letter_uppercase: 'Publish',
  diamond_sizes: 'Diamond Sizes',
  please_input_the_brand_designer: 'Please input the brand/designer…',
  please_enter_a_brand_description: 'Please enter a brand description…',
  choose_available_metals: 'Choose available metals',
  set_diamond_size_range_that_can_be_mounted_in_this_setting_carats:
    'Set diamond size range that can be mounted in this setting (carats)',
  set_ring_size_range_for_this_setting: 'Set ring size range for this setting.',
  quantity_of_side_stone_diamonds: 'Quantity of side stone diamonds?',
  selected_ring_settings_from_leo_ingwer: 'Selected ring settings from Leo Ingwer',
  use_your_own_ring_settings: 'Use your own ring settings',
  already_set_up_an: 'You’ve already set up an',
  already_set_up_an_diamond_feed_note_1:
    'Would you like to use it for your Ring Builder or create a new one?',
  already_set_up_an_diamond_feed_note_2:
    'to review your current diamond feed and update any changes.',
  diamond_feed: 'diamond feed',
  use_the_same_diamond_feed: 'Use the Same Diamond Feed',
  create_a_new_one: 'Create a New One',
  group_limit_message: 'You have reached the limit of 10 members in a chat group',
  chat_search_member_placeholder: 'Search by member name, company name or account ID',
  designers: 'Designers',
  brands: 'Brands',
  learn: 'Learn',
  how_would_you_like_to_contact_us: 'How would you like to contact us?',
  call_us: 'Call us',
  start_chat_now: 'Start a live chat now',
  chat_live: 'Chat live',
  new_group: 'New Group',
  group_description: 'Group Description (optional)',
  publish_selected: 'Publish Selected',
  unpublish_selected: 'Unpublish Selected',
  add_title_for_your_group: 'Add a title for your group',
  add_description_for_your_group: 'Add a description to identify better your groups in the future',
  add_members: 'Add Members',
  group: 'Group',
  group_members: 'Group Members',
  add_new_members: 'Add new members',
  create_your_first_group: 'Create your first group',
  current_members: 'Current members',
  no_members_yet: 'No members yet',
  are_you_sure_you_want_to_delete_this_group: 'Are you sure you want to delete this group?',
  remove_member: 'Remove Member',
  remove_member_from_group_message: 'Are you sure you want to remove this member from the group?',
  promote_your_inventory:
    'Promote your inventory at the top of RapNet Search Results. Stand out from other sellers.',
  rapnet_is_partnering_with_thinkspace:
    'RapNet is partnering with Thinkspace to provide members who have Instant Inventory with discounted packages to create elegant affordable retail websites.',
  discount_website_packages: 'Discount Website Packages',
  create_an_elegant_retail_website:
    'Create an elegant, affordable retail website that displays thousands of RapNet diamonds for your customers to browse, with Thinkspace. Add RapNet Instant Inventory to your plan (additional fee applies) and take advantage of the discount website package.',
  bring_your_store_online: 'Bring your store online and meet your customers where they are',
  affordable_and_elegant_wesite_solution: 'Affordable and elegant website solution from Thinkspace',
  customized_website_featuring: 'Customized website featuring RapNet’s vast inventory of diamonds',
  jewelry_photography_solution: 'Jewelry Photography Solution',
  sell_more_on_rapnet_by_adding_quality_images:
    'Sell more on RapNet by adding quality images and videos to your jewelry. RapNet members enjoy free shipping ($200 value) and a complimentary Sparkles Light ($100 value) when purchasing the GemLightbox Pro jewelry photography solution.',
  take_high_quality_images_and_360_videos:
    'Take high quality images and 360 videos of your jewelry with your phone, with the GemLightbox. RapNet members enjoy free shipping ($200 value).',
  sell_more_jewelry_on_rapnet: 'Sell more jewelry on RapNet',
  high_quality_images_and_videos: 'High quality images and videos',
  simple_affordable_photography_solution: 'Simple affordable photography solution',
  exclusive_free_shipping_for_rapnet_members: 'Exclusive free shipping for RapNet members',
  get_free_shipping: 'Get Free Shipping',
  contact_thinkspace: 'Contact Thinkspace',
  member_benefits: 'Member Benefits',
  open_in_chat_screen: 'Open in Chat Screen',
  type_message: 'Type a message',
  rule: 'Rule',
  chat_inactive_message: "Member is not active. You can't send messages",
  chat_with_members: 'Chat with Members',
  member_rating: 'Member Rating',
  help_and_support: 'Help and Support',
  chat_name_placeholder: 'Choose a Name for this group chat...',
  item_found_but_not_visible: 'Item found but not visible',
  open_item_page: 'Open Item Page',
  item_capital: 'ITEM',
  learn_and_grow: 'LEARN & GROW',
  become_a_rapnet: 'Become a RapNet',
  savy: 'savy',
  with_our: 'with our',
  help_articles_faqs: 'Help Articles, FAQs',
  get_assistance: 'GET ASSISTANCE',
  how_would_you_like_to: 'How would you like to ',
  contact_us_lower_case: 'contact us?',
  go_to_help_articles: 'Go to Help Articles',
  live_chat: 'Live Chat',
  send_a_message_now: 'Send a message now',
  wechat: 'WeChat',
  or_send_us_an: 'Or send us an',
  email_lowercase: 'email',
  tech: 'Tech',
  apis: `APIs`,
  get_tech_support_for_your_tools: 'Get technical support for your tools',
  open_now: 'Open Now',
  idea: 'Idea',
  portal: 'Portal',
  your_opinion_is_supper_valubale_to_us: 'Your opinion is super valuable to us',
  visit_our_idea_portal: 'Visit our idea portal',
  check_rapnet_updates: 'Check RapNet updates',
  refer: 'Refer',
  to_a_friend: 'to a Friend',
  refer_to_a_friend: 'Refer to a Friend',
  call_us_capital_us: 'Call Us',
  how_can_we_help: 'How can we help?',
  chat_with_us: 'Chat with us',
  send_us_an_email: 'Send us an email',
  articles_and_guides: 'Articles and guides for all RapNet features',
  read_documentation_for_api_development: 'Read documentation for API development',
  your_ideas_help_us_improve_rapnet: 'Your ideas help us improve RapNet',
  all_the_latest_rapnet_updates_and_new_features: 'All the latest RapNet updates and new features',
  developer_documentation: 'Developer Documentation',
  post_your_idea: 'Post your Idea',
  whats_new_on_rapnet: `What’s new on RapNet`,
  wechat_user: 'WeChat User',
  default_view_for_search_results: 'Default View for Search Results',
  default_view_for_diamond_filters: 'Default View for Diamond Filters',
  advanced_filters: 'Advanced Filters',
  gallery: 'Gallery',
  choose_between_gallery_view:
    'Choose between a gallery view showing pictures of your items, or a table containing item information only, arranged in rows',
  choose_between_an_opened_or_closed: 'Choose between an opened or a closed diamond filter menu',
  choose_between_showing_or_hiding:
    'Choose between showing or hiding the advanced diamond filters when selecting diamonds',
  load_from_gia_header: 'Upload Gemological Data from GIA',
  how_does_it_work: 'How does it work',
  load_data: 'Load Data',
  data_loaded: 'Data Loaded',
  gia_modal_step_one: 'Enter your diamond GIA report number',
  gia_modal_step_two: 'Click "Load Data"',
  gia_modal_step_three: 'All available information will be automatically filled',
  gia_modal_note:
    'Not all details will be filled out automatically. Please review the diamond details before uploading it',
  gia_error_one: 'Value fetched from GIA for',
  gia_error_two: 'Please pick the closest value from below',
  show_sale_conditions: 'Show Sale Conditions',
  gia_not_found_error: 'No results were found. Please check your GIA report number and try again',
  gia_report_error:
    'Error retrieving report details. Please be sure the GIA number entered is correct. If problem persists, contact customer service.',
  gia_report_file: 'The report details were automatically loaded.',
  rapaport_auctions_held_monthly_in_diiamond_trading: `Rapaport Auctions, held monthly in diamond trading centers worldwide, are an efficient, cost-effective way to buy and sell melee and certified and uncertified polished diamonds. Motivated buyers and sellers can trades a large variety of diamond assortments in our highly respected competitive cash market`,
  ownstock_publish_tooltip_text: 'This is OwnStock item and cant be published',
  ring_variant_msrp_tooltip:
    'The suggested retail price to be used as a reference price by other suppliers. The MSRP will not appear in your Ring Builder widget.',
  gia_round_message: 'Choose a shape. GIA reports this shape as',
  gia_note_message:
    'Not all details will be filled out automatically. Please review the diamond details before uploading it',
  unpublish_first_letter_uppercase: 'Unpublish',
  media_urls: 'Media (URLs)',
  open_link: 'Open Link',
  view_media: 'view media',
  image_slash_video: 'Image/Video',
  tracked_jewelry: 'Tracked Jewelry',
  show_only_selected: 'Show only Selected',
  add_selected_to_a_list: 'Add Selected to a List',
  add_selected_to_tracked_jewelry: 'Add Selected to Tracked Jewelry',
  share_link_to_items: 'Share Link to Selected Item(s)',
  email_selected_pdf: 'Email Selected (PDF / Excel)',
  export_selected_pdf: 'Export Selected (PDF / Excel)',
  print_selected_pdf: 'Print Selected (PDF / Excel)',
  contact_seller_of_selected: 'Contact Seller(s) of Selected',
  lattice_items: '# Items',
  create_or_choose_list_to_add_items: 'Create or choose a list to add these items',
  lists_saved: 'lists saved',
  create_a_list: 'Create a List',
  create_list: 'Create List',
  type_name_for_your_list: 'Type a name for your list',
  name_already_in_use: (name: any) =>
    `The name “${name}” is already used, please choose a different one.`,
  items_from_sellers: (items: number, sellers: number) =>
    `${items} ${items > 1 ? 'items' : 'item'} from ${sellers} ${
      sellers > 1 ? 'sellers' : 'seller'
    }`,
  list_created_successfully: 'List created successfully',
  back_to_lists: 'Back to Lists',
  your_message_were_sent_successfully: 'Your message(s) were sent successfully',
  export: 'Export',
  selected_items: 'Selected Items',
  set_markup_for_all_items: 'Set Markup for all items',
  set_markup_price_for_individual_items: 'Set Markup/Price for Individual Items',
  back_to_show_all_results: 'Back to show all results',
  showing_only_item_selected: (count: number) =>
    `Showing only ${count} ${count > 1 ? 'items' : 'item'} selected`,
  back_to_main_page: 'Back to main page',
  personalize_price_per_item: 'Personalize Price per Item:',
  share_by_email_note: (yourEmail: any, recipient: any) =>
    `${recipient} will receive the message by email from ${yourEmail}`,
  share_by_chat: 'Your recipient will receive the message on the RapNet chat',
  type_a_subject: 'Type a subject...',
  share_link_options: 'Share link options',
  share_link_via_email: 'Share link via email',
  share_link_via_facebook: 'Share link via Facebook',
  are_you_sure_you_want_to_delete_this_list: 'Are you sure you want to delete this list?',
  delete_list: 'Delete List',
  item_removed_successfully: 'Item(s) removed successfully',
  are_you_sure_you_want_to_delete_this_tracked_jewelry:
    'Are you sure you want to delete this tracked jewelry list?',
  personalized_prices_per_item: 'Personalized Prices per Item',
  contact_seller_of_list: 'Contact Seller(s) of List',
  items_emailed_successfully: 'Item(s) emailed successfully',
  remove_selected_items_from_list: 'Remove Selected Items from List',
  are_you_sure_you_want_to_remove_the_selected_items_from_this_list:
    'Are you sure you want to remove the selected items from this list?',
  from_list: 'from List',
  rough_diamond: 'Rough diamond',
  polished_diamond: 'Polished diamond',
  certificate_lattice: 'Certificate#',
  no_key_to_symbols: 'No Key to Symbols to show',
  gia_plus_rough_origin: 'GIA Rough Diamond Origin',
  social_responsibility: 'Social Responsibility',
  gia_plus_tooltip: 'Search for GIA Diamond Origin Reports',
  search_seller_tooltip: 'For multiple sellers use "," to separate',
  help_article: 'Help Article',
  rapaport_rsr_report: 'Rapaport RSR Report',
  rapaport_rsr_grade: 'Rapaport RSR Grade',
  mined_by: 'Mined By',
  mined_location: 'Mined Location',
  manuf_by: 'Manuf. By',
  manuf_loc: 'Manuf. Loc',
  this_action_is_limited_to: 'This action is limited to',
  maximum: 'maximum',
  share_link_to_list: 'Share Link to List',
  share_link_to_selected_items: 'Share Link to Selected Item(s)',
  items_shared_succesfully: 'Item(s) shared successfully',
  view_items: 'View Items',
  jewelry_items: 'Jewelry Items',
  all_items: 'All Items',
  view_lead: 'View Lead',
  send_me_a_copy: 'Send me a copy',
  open_trade: 'Open Trade',
  show_only_sr_diamonds: 'Show diamonds with Social Responsibility',
  attributes: 'Attributes',
  sr_tooltip:
    'Diamonds with social responsibility proof and attributes such as fair trade, fair mine etc.',
  export_to_pdf: 'Export to PDF',
  share_list: 'Share List',
  copy_link_first_letter_upper: 'Copy link',
  share_via_facebook: 'Share via Facebook',
  share_via_email: 'Share via email',
  share_selected_items: 'Share Selected Item(s)',
  you_are_seller_of_this_item: 'You are seller of this item',
  print_to_excel: 'Print to Excel',
  email_to_excel: 'Email Excel',
  print_to_pdf: 'Print to PDF',
  email_to_pdf: 'Email PDF',
  file_type: 'File Type',
  type_company_acount_id: 'Type Company, Account ID',
  upload_single_item: 'Upload Single Item',
  edit_title_and_type: 'Edit  Title & Type',
  image_type: 'Image Type',
  image_title: 'Image Title',
  connected_to_rj: 'Connected to RJ',
  delete_media: 'Delete Media',
  are_you_sure_you_want_to_delete_media: 'Are you sure you want to delete the selected media?',
  connect_selected_to_item: 'Connect Selected to Item…',
  rj_lattice: 'RJ #',
  jewelry_connect_modal_subheader:
    'Look for the item you would like to connect the media by typing its RJ# or Stock#',
  type_here_the_item_value: (value: any) => `Type here the Item ${value}`,
  rj_stock_not_exist: 'RJ# / Stock# does not exist',
  upload_media_acceptable_file_types:
    'Acceptable file types: JPEG, JPG, PNG or ZIP files. Make sure that the images are at least 1280px wide. The maximum supported ZIP archive size is 500MB. The best photos use natural or diffused lighting, and don’t use a flash. Note: Make sure that the images titles are similar to the titles in the uploaded listings file.',
  images_first_letter_lowercase: 'images',
  number_of_successful_uploads: (current: any, total: any) =>
    `${current}/${total} uploaded successfully`,
  unable_upload_images_below: 'Unable to upload the image(s) below:',
  images_dimensions_are_smaller: 'the image(s) dimensions are smaller than the requirements.',
  export_failed_images_list: 'Export failed Images List',
  others: 'others',
  create_lot: 'Create lot',
  export_filtered: 'Export Filtered',
  connect_to_lot: 'Connect to Lot',
  disconnect_from_lot: 'Disconnect from Lot',
  upload_images: 'Upload Images',
  member_badge: 'Member Badge',
  leverage_your_rapnet_membership:
    'Leverage your RapNet membership to earn you trust! Show your RapNet Member Badge on your website.',
  highlight_your_rapnet_membership: 'Highlight Your RapNet Membership to Earn You Trust!',
  show_your_rapnet_member_badge: `Show your RapNet Member Badge on your website and let your customers know that you are a trusted member of the world's largest diamond & jewelry trading network.`,
  fill_out_the_form_to_download_the_badge: 'Fill out the form to download the badge',
  in_the_downloaded_zip_folder:
    'In the downloaded zip folder, select the badge image format you prefer (SVG or PNG)',
  add_the_badge_to_your_website:
    'Add the badge to your website and link the image to: www.rapnet.com/member-badge so your customers can learn why your RapNet membership means that you can be trusted',
  download_your_badge: 'Download Your Badge',
  primary_supplier_badge: 'Primary Supplier Badge',
  leverage_the_prestige_of_your_primary_supplier_status:
    'Leverage the prestige of your Primary Supplier status to earn you trust! Show your RapNet Primary Supplier Badge on your website.',
  highlight_the_prestige_of_your_primary_supplier_status:
    'Highlight The Prestige of Your Primary Supplier Status to Earn You Trust!',
  show_your_rapnet_member_badge2: `Show your RapNet Member Badge on your website and let your customers know that you are a trusted member of the world's largest diamond & jewelry trading network.`,
  add_the_badge_to_your_website2:
    'Add the badge to your website and link the image to: www.rapnet.com/member-badge so your customers can learn why your RapNet Primary Supplier membership means that you can be trusted',
  name_a_z: 'Name: A-Z',
  name_z_a: 'Name: Z-A',
  the_upload_is_being_processed: 'The upload is being processed',
  check_your_upload_status_in:
    'Check your upload status in the "Upload History" screen or upload another diamond',
  new_diamond: 'New Diamond',
  are_you_sure_you_want_to_delete_these_tracked_groups:
    'Are you sure you want to delete the tracked group(s)?',
  items_selected: 'items selected',
  item_selected: 'item selected',
  are_you_sure_you_want_to_delete_these_saved_searches:
    'Are you sure you want to delete the saved search(es)?',
  excel_name: 'Excel Name',
  report_name: 'Report Name',
  not_active: 'Not Active',
  create_new_access_code: 'Create New Access Code',
  rap_code: 'Rap Code',
  include_treated_diamonds: 'Include treated diamonds',
  diamater_slash_length: 'Diamater /Length',
  any: 'Any',
  specify_the_details_for_your_buy_request: 'Specify the details for your Buy Request',
  everybody_will_see_this: '(Everybody will see this)',
  select_a_type: 'Select a type',
  get_notifications: 'Get Notifications',
  public_tooltip_text: 'Public - Everyone can view and respond to the Buy Request.',
  anonymous_tooltip_text: `Anonymous - The buyer company name is hidden, only location and details of BR are displayed.`,
  private_tooltip_text: 'Private  - Only the buyer can see the BR and get notifications.',
  expiration_date2: 'Expiration Date',
  max_2_weeks_from_now: '(Max: 2 weeks from now)',
  expand_selected: 'Expand Selected',
  active_access_code_message: '*Active Access Code will show in your Diamonds Search Results',
  delete_access_ceode_message: 'Are you sure you want to delete the Access Code',
  delete_all_access_ceodes_message: 'Are you sure you want to delete all Access Codes',
  product_description: 'Product Description',
  product_info: 'Product Information',
  multiple_selection: 'multiple selection',
  designer_maker: 'Designer / Maker',
  jewelry_keyword_description: 'Keyword Descriptions',
  comma_separated: 'comma separated',
  price_and_location: 'Price & Location',
  available_for_memo_upper_case: 'Available for MEMO',
  price_slash_piece: 'Price / piece',
  shipping_from: 'Shipping from',
  items_in_stock: '# Items in Stock',
  delivery_location: 'Delivery Location',
  free_worldwide_shipping: 'Free Worldwide Shipping',
  delivery_time: 'Delivery Time',
  ship_cost: 'Ship Cost',
  another_currency: '+ Add another Currency',
  another_delivery_location: '+ Add another Delivery Location',
  metal_gemstones: 'Metal & Gemstones',
  add_another_gemstone: 'Add another Gemstone',
  carat_weight: 'Carat Weight',
  lat_stones: '# Stones',
  upload_media: 'Upload Media',
  lot_information: 'Lot Information',
  create_new_lot: 'Create New Lot',
  type_file_name: 'Type file name',
  make_primary_image: 'Make Primary Image',
  document_type: 'Document Type',
  document_title: 'Document Title',
  upload_docs_from_local_file: 'Upload docs from local file',
  show_my_favorites: 'Show My Favorites',
  add_to_my_favorites: 'Add to My Favorites',
  available: 'Available',
  lab_lat: 'Lab #',
  basic_info: 'Basic Info',
  are_you_sure_you_want_to_exit_this_page:
    "Are you sure you want to exit this page? Your changes won't be saved",
  documents: 'Documents',
  add_new_piece: 'Add New Piece',
  unpublished: 'Unpublished',
  email_pdf_excel: 'Email (PDF / Excel)',
  export_pdf_excel: 'Export (PDF / Excel)',
  print_pdf_excel: 'Print (PDF / Excel)',
  add_to_a_list: 'Add to a List',
  ships_from: 'Ships from',
  documents_and_links: 'Documents & Links',
  open_document: 'Open document',
  recycled: 'Recycled',
  artisanal_sourced: 'Artisanal Sourced',
  fair_made: 'Fair Made',
  memo: 'Memo',
  in_stock: 'In Stock',
  min_order: 'Min. Order',
  add_to_tracked_jewelry: 'Add to Tracked Jewelry',
  type_keywords: 'Type keywords',
  worldwide_dollars: 'Worldwide (US Dollars $)',
  any_price: 'Any Price',
  under_the_price: (price: any) => `Under ${price}`,
  up_to_the_price: (price: any) => `${price} and up`,
  see_only: 'See Only',
  less_no_dots: 'Less',
  gemstone_type: 'Gemstone Type',
  Gemstone_quality: 'Gemstone Quality',
  maker_slesh_designer: 'Maker/Designer',
  gemstone_size: 'Gemstone Size',
  gemstone_shape: 'Gemstone Shape',
  metal: 'Metal',
  meas_dot: 'Meas.',
  setting: 'Setting',
  gem_quality: 'Gem Quality',
  meas: 'Meas',
  gem_color: 'Gem Color',
  gem_lab: 'Gem Lab',
  sinthetic: 'Sinthetic',
  gem_category: 'Gem Category',
  image_alredy_connected_to_another_lot: 'The selected image is already connected to another lot.',
  image_alredy_connected_to_another_lot_v2:
    'By continuing, the image will get disconnected from that lot.',
  would_you_like_to_proceed: 'Would you like to proceed?',
  connect_selected_to_lot: 'Connect Selected to Lot',
  max_250: '(Max. 250)',
  add_and_manage_diamonds_in_list: 'Add and manage diamonds in a list',
  sort_the_diamond_results_to_your_preferred_view:
    'Sort the diamond results to your preferred view',
  switch_to_table_view_of_diamond_results: 'Switch to table view of diamond results',
  g_guaranteed: 'G - Guaranteed',
  m_out_of_memo: 'M - Out On Memo',
  stps_subject_to_prior_sale: 'STPS - Subject to Prior Sale',
  price_markups: 'Price Markups',
  access_codes_description:
    "Create up to 5 markup rules that can be applied when searching RapNet with a customer. A markup rule can have a percentage and/or a fixed US$ markup. Prices on RapNet diamond search will be marked up according to the active rule and the seller's name will be hidden from the search results screen.",
  create_new_price_markup: 'Create New Price Markup',
  price_markup_name: 'Price Markup Name',
  percent_mark_up: '% Mark-Up',
  additional_mark_up: 'Additional Mark-Up',
  edit_price_markup: 'Edit Price Markup',
  delete_price_markup: 'Delete Price Markup',
  all_buy_requests: 'All Buy Requests',
  my_buy_requests: 'My Buy Requests',
  read_less: 'Read Less',
  add_additional_location: 'Add additional Location',
  documents_library: 'Documents Library',
  connected_docs: 'Connected Docs',
  not_connected_docs: 'Not Connected Docs',
  upload_new_documents: 'Upload New Documents',
  file_name_type: 'File Name & Type',
  no_documents_to_display: 'No documents to display',
  visibility: 'Visibility',
  private: 'Private',
  shareable: 'Shareable',
  own_stock_for_instant_inventory: 'Own Stock for Instant Inventory',
  are_you_sure_you_want_to_delete_lot: 'Are you sure you want to delete this lot?',
  cost: 'Cost',
  delivers_to: 'Delivers to',
  add_to_buy_request: 'Add to Buy Request',
  add_item_to_br: 'Confirm you want to add selected item/s to your Buy Request # ',
  manuf_dot: 'Manuf.',
  jewelry_quality: 'Jewelry Quality',
  rapnet_video_tutorials: 'RapNet Video Tutorials',
  watch_how_to_use_rapnets_powerful_tools_and_features: `Watch how to use RapNet's powerful tools and features`,
  get_to_know_rapnets_powerful_tools: `Get to know RapNet's powerful tools and features with short informative video clips`,
  watch_videos: 'Watch videos',
  metal_kt: 'Metal KT',
  gemstone_treatment: 'Gemstone Treatment',
  image_quality: 'Image Quality',
  karat: 'Karat',
  we_are_creating_something_great: 'We are creating something great.',
  stay_tuned_we_will_be_back_soon: 'Stay tuned! We will be back soon.',
  success_your_data_has_been_recieved:
    'Success!  Your data has been received and is queued for processing.',
  once_processed:
    'Once processed, it will be available on RapNet.  To check processing status go to "Upload History".  Click "New Diamond" to upload another diamond.',
  buy_request_sellers_notification_explanation:
    'Receive notifications when your inventory matches posted buy requests',
  buy_request_sellers: 'Buy request- Sellers',
  buy_request_buyers_notification_explanation:
    'Receive notifications when new diamonds are added to your buy request by seller',
  buy_request_buyers_auto_matching_suggestions: 'Buy request- Buyers auto matching suggestions',
  buy_request_buyers_auto_notification_explanation:
    'Receive notifications when new diamonds are added to your buy request by auto match system',
  buy_request_buyers_sellers_suggestions: `Buy request- Buyers seller's suggestions`,
  rapapory_rsr_url: 'Rapapory RSR URL',
  as_of: 'As of',
  additional_markup_comment: '*Add additional markup by specific amount',
  are_you_sure_you_want_to_publish_all_items: 'Are you sure you want to publish all items?',
  publish_all_items: 'Publish All Item(s)',
  unpublish_all_items: 'Unpublish All Item(s)',
  are_you_sure_you_want_to_unpublish_all_items: 'Are you sure you want to unpublish all items?',
  items_unpublished_successfully: 'Item(s) unpublished successfully',
  items_published_successfully: 'Item(s) published successfully',
  click_here_to_open_buy_request_number: 'Click here to open Buy Request # ',
  agree_and_continue: 'Accept',
  decline: 'Decline',
  to_continue_sign_agreement:
    'To continue to RapNet you must agree to the updated agreement below:',
  document_alredy_connected_to_another_lot:
    'The selected document is already connected to another lot.',
  document_alredy_connected_to_another_lot_v2:
    'By continuing, the document will get disconnected from that lot.',
  document_reject_1: 'This document does not match the requirements',
  document_reject_2:
    'Pay attention that the maximum supported size is 5MB, and acceptance file types are: JPEG, JPG, PNG or PDF.',
  unpublished_tooltip: "Hides jewelry from buyer's search results. Remains in Manage My Jewelry",
  Shareable_tooltip: 'Allow other members to share this item on social media',
  own_stock_for_instant_inventory_tooltip: 'Display this item only on my Instant Inventory feed',
  save_as_new: 'Save as New',
  responded_buy_requests: 'Responded Buy Requests',
  expired_buy_requests: 'Expired Buy Requests',
  active_buy_requests: 'Active Buy Requests',
  expired_buy_request: 'Expired Buy Requests',
  with_seller_responses: 'With seller responses',
  without_seller_responses: 'Without seller responses',
  responded_to: 'Responded to',
  your_inventory_matches_filter: 'Your inventory matches',
  import_summary: 'Import Summary',
  match_columns: 'Match Columns',
  review_values: 'Review Values',
  skip_online_fix: 'Skip Online Fix And Continue File Import',
  complete_import_and_upload_images: 'Complete Import And Upload images',
  download_files: 'Download Files',
  download_latest_error_file: 'Download Latest Error File',
  download_my_current_jewelry_listing: 'Download my current jewelry listing',
  help_listing_multiple_jewelry_items: 'Help listing multiple jewelry items',
  rapnet_jewelry_fields_dictionary: 'RapNet Jewelry Fields Dictionary',
  help_and_instructions: 'Help & Instructions',
  upload_multiple_jewelry_items_using_csv_file: 'Upload Multiple Jewelry items Using CSV File',
  please_review_column_values_below: 'Please review the column values below.',
  review_column_values_note:
    'If you notice incorrect values, you can either replace them or remove them by clicking on the edit icon.',
  upload_items_as_own_tock_items_for_your_instant_inventory:
    'Upload items as “Own Stock” items for your Instant Inventory',
  create_listing: 'Create Listing',
  choose_different_file: 'Choose a different File',
  match_your_columns: 'Match Your Columns',
  ignore: 'Ignore',
  are_you_sure_you_want_to_ignore_this_value: 'Are you sure you want to ignore this value?',
  please_match_the_columns_in_your_uploaded_file_to_rapNet_jewelry_fields:
    'Please match the columns in your uploaded file to RapNet Jewelry fields.',
  jewelry_multiple_upload_match_columns_note:
    'Each column header below should be mapped to a jewelry property. Some of these have already been mapped based on their names. Anything that hasn’t been mapped yet can be manually mapped with the dropdown menu. You can always choose “Don’t import column”',
  rapnet_column_name: 'RapNet Column Name',
  your_column_name: 'Your Column Name',
  sample_from_your_file: 'Sample From Your File',
  csv_image_upload_note:
    'Note: Image filenames matching the stock number auto-connect to the correct jewelry item.',
  csv_image_upload_requirements:
    'Make sure that the images are at least 1280px wide. The maximum supported ZIP archive size is 500MB. The best photos use natural or diffused lighting, and don’t use a flash',
  skip_and_upload_later: 'Skip and upload later',
  successfully_upload: 'Successfully Upload',
  error_item: 'Error Item',
  download_error_file: 'Download Error File',
  all_errors_will_now_be_removed: 'All errors will now be removed from your error file',
  all_errors_will_now_be_removed_full_note:
    'Note: This file is only available once for download. Please save your downloaded error file as it will not be available for re-download.',
  confirm_and_download: 'Confirm and Download',
  go_to_manage_my_jewelry: 'Go to Manage My Jewelry',
  click_here_for_instructions_how_to_upload_diamonds_to_the_show:
    'Click for instructions on how to upload diamonds to Show Listings',
  upload_the_diamonds_that_you_will_be_selling_at_the_show:
    'Upload the diamonds that you will be selling at the show.  ',
  for_instructions_on_how_to_upload_diamonds_to_show_listings:
    'for instructions on how to upload diamonds to showlistings',
  enter_the_url_of_the_company_website: 'Enter Company Website URL',
  type_select: 'Type / Select...',
  search_by_lot_number_stock_number: 'Search by Lot#, Stock#',
  source: 'Source',
  shape_and_size_are_required: 'Shape and Size are required',
  there_are_no_items_in_this_list: 'There are no items in this list',
  gemstone_description: 'Gemstone Description',

  /* ftp setup */
  ftp_upload_to_rapnet: 'FTP Upload to RapNet',
  ftp_explanation:
    'FTP (File Transfer Protocol) is a way of moving files from your computer directly to another computer. Using RapNet’s FTP allows you to easily upload photographs to your RapNet Media Library.',
  ftp_upload_you_need: 'To use RapNet FTP Upload you will need the following:',
  ftp_upload_steps: 'RapNet FTP Upload Steps',
  install_ftp_client: 'Install an FTP Client',
  install_ftp_client_description:
    'This is the communication program used to transfer your data. It needs to be installed on your computer or server',
  set_up_ftp_and_log_on: 'Set up FTP and log on',
  ftp_client:
    'An FTP client. This is a program that is installed on the computer or server where your images are stored.',
  we_recommend_downloading: 'We recommend downloading',
  ftp_logon_steps: 'Logon following these steps:',
  ftp_step1: 'Step 1',
  ftp_step1_set_protocol: 'Set Protocol to',
  sftp: 'SFTP',
  ftps: 'FTPS',
  ftp: 'FTP',
  ftp_step2: 'Step 2',
  ftp_step2_set_host: 'Set Host to the following: ',
  ftp_step3: 'Step 3',
  ftp_step3_set_username: 'Username: ',
  ftp_step4: 'Step 4',
  ftp_step4_run_save_download: 'On the same computer you will need to Generate an FTP Password:',
  download_save_ppk: 'Download & Save this',
  generate_ftp_password: 'Generate an FTP Password',
  key_file: 'Key File',
  ftp_full_instuctions: 'for full instructions on how to set up RapNet FTP Upload',
  filezilla: 'FileZilla',
  open_in_br_screen: 'Open Buy Request Response',
  not_available_for_jeweler: 'Not available for those on RapNet Buyer Pro plan',
  no_saved_serches: 'No Saved searches',
  items_cannot_be_sheared: 'Item(s) cannot be sheared',
  contactSellerQueueMessage: (count: number) =>
    `Your request is being processed and the seller${count === 1 ? '' : 's'} ${
      count === 1 ? 'is' : 'are'
    } being notified of your interest in their diamonds. You may continue using RapNet and you will receive a notification when the process is complete`,
  stock_lattices: "Stock #'s",
  single_diamond_upload:
    'RapNet strictly prohibits the list of a) lab-grown diamonds, b) white diamonds with a green tinge/hue/shade and c) any diamonds originating from Zimbabwe. Please also note: Any/all treatments on diamonds must be clearly disclosed in the treatment fields and misrepresentation is not allowed(laser drilled, color treated, HPHT etc.)',
  diamond_information: 'Diamond Information',
  type_stock_number_the_matching_pair:
    'Type the stock number of the matching diamond to connect the pair',
  other_certificate: 'Other Certificate',
  must_be_bigger_than_count: (count: any) => `Must be bigger than ${count}`,
  upload_image_from_library: 'Upload Images from media library',
  upload_image_from_local: 'Upload Images from local file',
  upload_docs: 'Upload Docs',
  upload_new_file: 'Upload new file',
  all_files: 'All Files',
  connected_files: 'Connected Files',
  not_connected_files: 'Not Connected Files',
  no_data_to_display: 'No data to display',
  files: 'File(s)',
  file: 'File',
  upload_certificates_accceptable_file_types:
    'Upload pdf, gif, jpg or zip files. Keep file size to under 2MB per document. Zip file maximum is 100 MB. For best results, file name should be the same as the report number or stock number of the diamond',
  upload_files: 'Upload File(s)',
  upload_docs_from_library: 'Upload Docs from media library',
  load_gemological_data_from_gia: 'Load Gemological Data from GIA',
  enter_gia_report_lat: 'Enter GIA Report #',
  single_diamond_upload_maximum_file_size_only_format_accepted:
    'Maximum Single File Size is 10MB. Only JPEG, PNG, GIF are accepted.',
  please_fill_in_all_required_fields: 'Please fill in all required fields',
  certificate_must_consist_of_at_least_one_number:
    'Certificate must consist of at least one number',
  member_joined_years: 'Member (years)',
  search_by_company_name_member_or_rapnet_id: 'Search by company name, member or RapNet ID',
  advanced_search: 'Advanced Search',
  jewelry_items_list: 'Jewelry Items Listed',
  telephone_full: 'Telephone',
  add_feedback: 'Add Feedback',
  enter_message: 'Enter Message',
  company_diamonds: 'Company DIAMONDS',
  last_year: 'Last Year',
  show_this_members_diamonds_in_my_search: 'Show this member’s diamonds in my search',
  allow_this_member_download_my_listings:
    'Allow this member to display my inventory in their online store/website',
  add_member: 'Add Member',
  add_note: 'Add Note',
  edit_note: 'Edit Note',
  edit_cover: 'Edit Cover',
  jewelry_pieces: 'Jewelry Pieces',
  edit_company_information: 'Edit Company Information',
  enter_city: 'Enter City',
  linkedin: 'LinkedIn',
  twitter: 'X',
  show_my_profile_in_the_member_directory_search: 'Show my Profile in Member Directory Search.',
  incorect_url_format: 'Incorrect URL format',
  should_be_a_valid_url:
    ' should be a valid URL, check the spelling and presence of http: or https:',
  primary_company_sub_type: 'Primary Company Sub Type',
  secondary_company_sub_type: 'Second Company Sub Type',
  third_company_sub_type: 'Third Company Sub Type',
  returns_accepted_subject_to_conditions: 'Returns accepted, subject to conditions',
  watch_video: 'Watch Video',
  eye_clean_means: '"Eye Clean" means that',
  please_enter_3_characters_and_more_to_search: 'Please enter 3 characters and more to search',
  cannot_use_special_characters_for_search: `You can't use special characters to search`,
  we_found_no_members_that_match_your_search_criteria:
    'We found no members that match your search criteria. Please expand your search or ',
  reset_your_filters: 'reset your filters',
  please_enter_3_characters_or_more_to_search: 'Please enter 3 characters or more to search',
  no_special_characters_allowed: 'No special characters allowed',
  source_of_rough: 'Source of Rough',
  rough_diamond_source: 'Rough Diamond Source',
  russian_source: 'Russian rough source',
  rough_source: 'Rough Source',
  rough_source_provider: 'Rough Source Provider',
  source_provider: 'Source Provider',
  start_typing_rough_source: 'Start typing Rough Source name',
  sell_diamonds_with_auctions: 'Sell Your Diamonds Even Faster with Rapaport Auctions',
  advantage_monthly_auctions:
    'Take advantage of Rapaport’s monthly auctions in trading centers worldwide to turn your diamonds into cash - safely and quickly!',
  market_price: 'Highest cash market prices',
  bids_from_hundreds: 'Bids from hundreds of motivated buyers around the world.',
  hassle_free_process: 'Easy and hassle-free process',
  export_oversee_process: 'Rapaport’s experts oversee the entire process for you.',
  export_and_personal_service: 'Expert & personal service',
  boiling_sorting_and_more: 'Boiling, sorting, certification, consulting & more.',
  risk_free_trading: 'Risk-free trading',
  service_or_penalty: 'No service or penalty fee if your diamonds do not sell.',
  more_information: 'Speak to our auctions expert to find out more.',
  contact_me_button: 'CONTACT ME',
  auction_My_diamond: ' Auction My Diamond',
  rap_net_id: 'RapNet id',
  ok: 'OK',
  placeholder: 'Type here',
  upcoming_auctions: 'UPCOMING AUCTIONS',
  melee_auction: 'Melee Auction',
  request_appointment: 'REGISTER NOW',
  quarterly_pawnshop_auction: 'Quarterly Pawnshop Auction',
  single_stone_auction: 'Single Stone Auction',
  important: 'Important',
  rapnet_strictly_prohibits_the_listing_of: 'RapNet strictly prohibits the listing of',
  lab_grown_diamonds: 'Lab-grown diamonds',
  white_diamonds_with_a_green_tingle_hue_shade: 'White diamonds with a green tinge/hue/shade',
  any_diamonds_originating_from_zimbabwe_diamonds_of_russian_source_or_sanctioned_products:
    'Any diamonds originating from Zimbabwe, diamonds of Russian Source or Sanctioned Products',
  all_types_of_treatments_must_be_specified_in_the_treatment_field_and_misrepresentation_is_not_allowed:
    'All types of treatments MUST be specified in the Treatment field and misrepresentation is not allowed (laser drilled, color-treated, HPHT, etc.)',
  upload_your_diamond_to_rapnet: 'Upload your diamond to RapNet',
  please_fill_out_this_form_to_upload_a_diamond: 'Please Fill Out This Form To Upload A Diamond',
  to_upload_a_gia_graded_diamond_please_enter_the_report_number_here:
    'To upload a GIA graded diamond, please enter the Report Number here',
  for_other_labs_or_uncertified_diamonds: 'For other labs or uncertified diamonds',
  please_click_here: 'Please click here',
  gia_graded_diamond: 'GIA Graded Diamond',
  decline_agreement:
    'Please let us know why you do not wish to accept the RapNet Member License Agreement',
  thank_you: 'Thank You!',
  be_in_touch: 'We will be in touch with you soon.',
  mine: 'Mine',
  show_report_on_rapnet: 'Show report # on RapNet',
  diamond_images: 'Diamond Image/s',
  contact_seller_notice_2: 'Note: contact seller to your own diamond(s) will be ignored.',
  please_fill_in_all_measurements: 'Please fill in all measurements',
  reason_for_declining: 'Reason for declining',
  invalid_price: 'Invalid Price',
  please_review_and_correct_the_highlighted_data: 'Please review and correct the highlighted data',
  only_numbers_and_letters_allowed_in_this_field: 'Only numbers and letters allowed in this field',
  privacy: 'PRIVACY & SECURITY',
  security: ' Security',
  pending_verification: 'Pending Verification',
  invalid_lots_no_pending: 'Invalid Lots',
  result: 'result',
  upload_id: 'Upload ID',
  gia_report: 'GIA Report',
  my_items_under_review: 'My Items Under Review',
  jewelry_review: 'Jewelry Review',
  admin_unpublished_items: 'Admin Unpublished Items',
  buy_and_sell_diamonds_with_auctions:
    'Buy & Sell Your Diamonds & Jewelry Faster, Safer, & Hassle-free With Rapaport Auctions',
  join_thousands:
    'Join thousands of diamond traders buying and selling certified and uncertified polished diamonds, melee, parcels, and jewelry at our monthly auctions in major trading centers around the world.',
  partners_you_can_trust: 'Partners you can trust',
  we_take_full_responsibility:
    'We take full responsibility for marketing, security, delivery, and payments.',
  announcments: 'Announcements',
  dealers: 'Dealers',
  Jewelry: 'Jewelry',
  financial: 'Financial',
  industry: 'Industry',
  legal: 'Legal',
  your_diamond_search_results:
    'Your diamond search has exceeded the amount of results that can be displayed. ',
  for_optimum_results:
    'For optimum performance please modify your search to narrow down the number of results.',
  exclude: 'Exclude',
  diamond_shape_and_treatment: 'Diamond Shape and Treatment',
  select_shape: 'Select Shape',
  tracr_id: 'Tracr ID',
  are_you_sure_you_want_to_delete_all_media_files:
    'All your images will be deleted.  Are you sure you want to continue?',
  delete_all_media: 'Empty Media Library',
  ct_from: 'ctFrom',
  ct_to: 'ctTo',
  mm_from: 'mmFrom',
  mm_to: 'mmTo',
  sieve_from: 'sieveFrom',
  sieve_to: 'sieveTo',
  gia_dor: 'GIA DOR',
  tracr: 'Tracr',
  seller_provided_source: 'Seller provided source',
  type_ii_a: 'Type IIa',
  crystal_type: 'Crystal Type',
  diamond_type: 'Diamond Type',
  buy_and_sell: 'Buy and Sell with Auctions',
  greenstar_diamonds: 'Green Star Diamonds',
  notification_update_to_user_at_compact_view:
    'On May 22nd, 2023, the Compact Search form that you use for searching diamonds on RapNet, will be removed.  We recommend that you move over now to either the Classic or Standard diamond search forms.  Click on the “Compact View” button at the top of the search form to select Classic or Standard.We understand that changing the way you are accustomed to working can be difficult and we are here to support you. Please email us at help@diamonds.net for personal service and assistance with this adjustment.',
  notification_update_user_for_deleting_compact_view_from_rapnet:
    'On June 5, 2023, the Compact Search form that you use for searching diamonds on RapNet, will be removed.  We recommend that you move over now to either the Classic or Standard diamond search forms.  Click on the “Compact View” button at the top of the search form to select Classic or Standard.',
  notification_update_user_for_deleting_compact_view_from_rapnet_second_paragraph:
    'We understand that changing the way you are accustomed to working can be difficult and we are here to support you. Please email us at help@diamonds.net for personal service and assistance with this adjustment.',
  rapaport_rough_source_apporoved: 'Rapaport Rough Source Approved',
  guaranteed_diamonds_available_immediate_sale:
    'Diamonds that are guaranteed by the seller to be available for immediate sale',
  ftp_setup: 'FTP Setup',
  dear_customer_rapnet_india: 'Dear Customer, RapNet India is available only on Mobile.',
  please_make_sure: 'Please make sure that you have the latest RapNet App (v3.8x and above)',
  fancy_color_diamonds: 'Fancy Color Diamonds (All Shapes)',
  search_notification_title: 'You have reached your Saved Search Notification Limit!',
  // search_notification_error:
  //   ' Active Notifications on Saved Searches are limited to 20 active notifications per account. To activate this Saved Search Notification,you will need to deactivate one of your other active Saved Search Notifications.',
  search_notification_error_1:
    'Active Notifications on Saved Searches are limited to 20 active notifications per account.',
  search_notification_error_2:
    'To activate this Saved Search Notification, you will need to deactivate one of your other active Saved Search Notifications.',

  go_to_my_saved_searches: ' My Saved Searches',
  markup_diamond_prices: 'Markup diamond prices to show your customers',
  you_can_create_up_to_5:
    '• You can create up to 5 markup rules that can be applied when showing RapNet diamonds to a customer.',
  A_markup_rule: '• A markup rule can have a percentage and/or a fixed US$ markup.',
  Prices_on_RapNet_diamond:
    "• Prices on RapNet diamond search will be marked up according to the active rule and the seller's name will be hidden from the search results screen.",
  note_you_can_activate: 'NOTE: You can activate one at a time to use.',
  scan_government_id: 'Government Issues ID',
  access_only_assigned_trades: 'Access Only Assigned Trades',
  generate_password: 'Generate password',
  trouble_fetching_diamonds: 'We are having trouble fetching your diamond results.',
  please_refresh_page: 'Please refresh the page',
  active_notifications: 'Active Notifications',
  activate: 'Activate',
  criteria: 'Criteria',
  rename_saved_search: 'Rename Saved Search',
  search_name: 'Search Name',
  search_abc: 'Search ABC',
  coniferm_the_delete: 'Are you sure you want to delete this Search?',
  classifies_diamonds_into_different: 'Classifies diamonds into different quality groups.',
  to_read_more: 'to read more',
  access_code_tooltip: 'Apply a price markup when showing diamonds to your customers.',
  for_guidance: 'for guidance.',
  active_buy_and_sell_trades: 'Active Buy & Sell Trades',
  raptrade_empty_cart: 'Your RapTrade Cart is empty',
  click_here_to_buy_diamonds: 'Click here to buy diamonds now',
  your_raptrade_cart: 'Your RapTrade Cart',
  click_here_without_space: 'Click here',
  go_to_cart: 'Go to Cart',
  api_access: 'API Access',
  order_placed: 'Order Placed',
  edit_cart: 'Edit Cart',
  order_summary: 'Order Summary',
  order_upper_case: 'ORDER',
  total_number_diamonds: 'Total Number of Diamonds',
  total_number_carats: 'Total Number of Carats',
  subtotal: 'Subtotal',
  order_total: 'Order Total',
  thank_you_for_your_order: 'Thank you for your order!',
  we_have_emailed_order_confirmations: 'We have emailed your order confirmations to ',
  please_click: 'Please click ',
  to_view_your_orders: ' to view your order.',
  checkout: 'Checkout',
  cart: 'Cart',
  cart_table_header_diamond_details: 'Diamond Details',
  cart_table_header_total: 'Total',
  cart_table_header_remove: 'Remove',
  cart_diamond_unavailable: 'This diamond is no longer available',
  cart_location_group: 'Location: {{ location }}',
  cart_order_summary: 'ORDER SUMMARY',
  cart_order_summary_total_num_diamonds: 'Total Number of Diamonds',
  cart_order_summary_total_num_carats: 'Total Number of Carats',
  cart_order_summary_order_total: 'Order Total',
  cart_proceed_to_checkout: 'Proceed to Checkout',
  cart_remove_diamond_modal_title: 'Remove Diamond',
  cart_remove_diamond_modal_body: 'Are you sure you want to remove this diamond?',
  qc_tests: 'QC Tests',
  raptrade: 'RapTrade',
  continue_shopping: 'Continue Shopping',
  item_added_to_cart: 'Item added to cart',
  important_title: 'IMPORTANT:',
  type_special_qc_instructions: 'Type special QC instructions and/or promotion code...',
  choose_shipping_option: 'Choose shipping option',
  overnight: 'Overnight',
  standard: 'Standard',
  pickup_from_local_office: 'Pickup from local Rapaport office',
  confirm_order: ' Confirm Order',
  verification_code: 'Verification Code',
  a_code_will_be_sent_to: 'A code will be sent to ',
  how_do_you_want_to_receive_the_code: 'How do you want to receive the code?',
  text_message: 'Text Message',
  voice_call: 'Voice Call',
  verify: 'Verify',
  additional_user:
    ' The additional user will be processed and activated once all documents are approved and payment has been received.',
  please_enter_the_6_digit_code:
    'Please enter the 6-digit verification code we have sent to the phone number above',
  didnt_get_the_code: "Didn't get the code? ",
  resend: 'Resend',
  code_sent: 'Code Sent',
  enter_code: 'Enter Code...',
  resend_code: 'Resend Code',
  incorrect_verification_code: 'The verification code is not correct',
  security_code_confirmed: 'Security Code Confirmed!',
  if_you_want_to_change_your_address_please: 'If you want to change your address please ',
  contact_us_lower: 'contact us',
  all_rapnet_diamonds: 'All RapNet Diamonds',
  buynow_price: 'BuyNow Price',
  gridle: 'Gridle',
  diamond_lot_lattice: 'Diamond Lot #',
  which_information_do_you_want_to_request_from_the_seller:
    'Which information do you want to request from the seller',
  diamond_information_request: 'Diamond Information Request',
  add_to_cart_note1:
    'Final shipping charges will be calculated based on your total invoice price, with reduced or discounted shipping fees for larger diamond orders.',
  add_to_cart_note2:
    'Adding the diamond to your cart does not secure or reserve it; the order process is initiated and confirmed only upon checkout.',
  qc_instructions_placeholder: 'Type special QC instructions and/or promotion code...',
  your_cart: 'Your cart ',
  your_cart_is_empty: 'Your cart is empty',
  Active_BuyNow_Orders: 'Active BuyNow Orders',
  active_unread_bynow_purchases: 'Active/Unread BuyNow Purchases',
  active_unread_bynow_sales: 'Active/Unread BuyNow Sales',
  bgm: 'BGM',
  buynow: 'BuyNow',
  purchases: 'Purchases',
  sarin_id_validation:
    'Sarine ID must be between 10 -13 characters, numbers and capital letters only',
  only_buy_now_diamonds: 'Only BuyNow Diamonds',
  transaction_services_through_rapaport:
    'Transaction services through Rapaport offering QC and consolidated shipping',
  provider: 'Provider',
  just_polishing_diamond: 'Just polishing this diamond for you, ',
  please_wait: 'please wait...',
  notifications_we_send_you: 'Notifications we send you',
  agree_to_rapnet: 'I agree to RapNet',
  agree_to_rapaport: 'I agree to Rapaport',
  terms_and_conditions: 'Terms & Conditions',
  confirm_and_checkout: 'Confirm & Checkout',
  order_confirmed: 'Order Confirmed',
  confirm_order_details:
    ' To process your RapNet membership, we require proof of industry affiliation, such as an active business license and evidence of operating in the diamond and jewelry business in good standing.',
  complete_rapaport_registration: 'Complete Rapaport Registration',
  subscribe_to_rapaport_newsletters: 'Subscribe to Rapaport Newsletters',
  membership:
    'Your membership will be automatically renewed on an annual/monthly basis, and your card will be charged accordingly.',
  payment_details: 'Payment',
  contact_for_payment: 'Other Payment Method',
  your_plan: 'Your Plan',
  rapaport_magazine_tooltip:
    'In-depth articles, news and market analysis related to the diamond, gem and jewelry industry.',
  additional_user_tooltip: 'Your RapNet plan includes one login',
  instant_inventory_tooltip: 'Add RapNet diamonds and jewelry to your online store or website',
  rapaport_research_report_addon_tooltip:
    'Monthly review of diamond prices, the RapNet Diamond Index (RAPI). Plus in-depth analysis of polished, rough, and retail markets.',
  rapnet_buyer_text:
    'For members of the trade looking to buy diamonds and jewelry, and access diamond pricing information and tools.',
  rapnet_buyer_india_text:
    'For members of the trade in India looking to buy diamonds and jewelery only from Indian suppliers, and access diamond pricing information and tools.',
  rapnet_buyer_pro_text:
    'For members of the trade looking to buy diamonds and jewelry, access diamond pricing info and list jewelry and up to 50 diamonds at once.',
  rapnet_dealer_text: 'For diamond dealers who are looking to buy and sell diamonds & jewelry',
  rapnet_primary_supplier_text:
    'For major diamond manufacturers or dealers. All the features of RapNet Dealer plus sell an unlimited number of diamonds and display the Primary Supplier badge.',
  rapaport_monthly_price_list_text:
    'Weekly Rapaport Price List updates via email, mobile, and online, with diamond pricing tools on desktop and app.',
  rapaport_weekly_price_list_text:
    'Weekly Rapaport Price List updates via email, mobile, and online, featuring diamond pricing tools on desktop and app, API access, and premium editorial and analytical content for added value.',
  rapaport_research_report_text:
    'In-depth monthly report reviewing the global diamond markets, analyzing key industry issues. Also includes pricing and inventory data from RapNet to track supply and demand trends.',
  other_available_plans: 'Other Available Plans',
  available_addons: 'Available Add-Ons',
  thank_you_for_subscribing: 'Thank you for subscribing to RapNet',
  a_rapnet_representative_will_follow_up_with_you:
    'A RapNet representative will follow up with you within 48 hours to process your membership. \n Your subscription will be activated once all documents are approved, and payment has been received.',
  please_contact_uor_team: 'If you have any questions please contact our team at ',
  we_were_unable_to_process_your_credit_card:
    "We're sorry, we were unable to process your credit card.",
  please_double_check_your_payment_information_first:
    "Please double-check your payment information or choose 'Other Payment Method' ",
  please_double_check_your_payment_information_second:
    'and wait for a Rapaport representative to contact you',
  plot_and_diagram: 'Plot and Diagram',
  click_here_to_find_out_more: 'Click here to find out more',
  You_need_to_select: 'To search, please select another parameter',
  billed_monthly: 'Billed Monthly',
  billed_annually: 'Billed Annually',
  one_year: '1 Year',
  year: 'Year',
  month: 'Month',
  polishing_your_membership_request: 'Polishing your membership request...',
  error_request_failed: 'Error request failed, please try again',
  error: 'Error',
  request_failed_please: 'Request Failed. Please ',
  for_assistance: ' for assistance.',
  you_save: 'You Save ',
  renew_my_subscription_automatically: 'Renew my subscription automatically',
  a_daily_news_digest_delivered:
    ' Daily news digest delivered to your inbox Monday through Thursday.',
  a_weekly_newsletter_sent: ' Weekly e-newsletter with the latest marketing news and updates.',
  your_source_for_essential: ' Your source for essential jewelry insights.',
  bi_monthly: 'Bi-Monthly Rapaport Magazine Online',
  edit_plan: 'Edit Plan',
  view_link: 'view link',
  show_only_diamonds_listed:
    'Show only diamonds listed on RN for the first time in the last 7 days',
  orders: 'Orders',
  purchase_invoices: 'Purchase Invoices',
  includes_rapaport_magazine: 'Includes Rapaport Magazine',
  must_be_a_number_no_greater_than_50: 'Must be a number no greater than 50',
  rapaport_research_report_adoon_tooltip:
    'Monthly review of diamond prices, the RapNet Diamond Index (RAPI). Plus in-depth analysis of polished, rough, and retail markets.',
  thank_you_for_subscribing_price_list: 'Thank you for subscribing to Rapaport!',
  you_will_receive_an_email_1: "You'll receive an email shortly with",
  you_will_receive_an_email_2:
    'your membership confirmation, receipt of payment and login information.',
  calculate_diamond_prices_on_the_go: 'Calculate diamond prices on the go:',
  download_the_rapnet_app: 'Download the RapNet App from the',
  renewal_request_has_been_sent:
    'Your subscription request has been sent, and a Rapaport representative will contact you shortly for payment.',
  processed_once_payment_has_been_received:
    'Your subscription will be processed once payment has been received.',
  any_questions: 'For any questions, please contact our team at ',
  help_support: 'help@diamonds.net',
  if_you_have_any_questions_please_feel_free: 'If you have any questions, please feel free to ',
  process_your_rapnet_membership: 'To process your RapNet membership, we require these documents:',
  active_business_license_or_certificate: 'Active Business License / Certificate of Incorporation',
  showing_your_involvement: 'Confirming your involvement in the diamond or jewelry trade.',
  government_issued_photo_id: 'Government-issued Photo ID',
  necessary_for_the_company_owner:
    'Required for the company owner and employees needing RapNet access.',
  trade_reputation_and_industry_affiliation: 'Trade Reputation & Industry Affiliation',
  two_trade_references: '   •Two Trade References - ',
  from_reputable_diamond_or_jewelry_companies:
    ' From diamond or jewelry companies you’ve worked with in the',
  last_six_months: '    last 6 months(client for at least 1 year).',
  two_trade_invoices: '   •Two Trade Invoices - ',
  dated_within_last_six_months: ' Dated within the last 6 months.',
  please_email_documents: 'Please email these documents to ',
  market_intelligence: 'Market Intelligence',
  rapnet_reports: 'RapNet Reports',
  tableau: 'Tableau',
  im_interested_contact_me: "I'm Interested, Contact Me",
  introducing_our_advanced_pricing_tool:
    'Introducing our advanced pricing tool for the diamond market!',
  with_interactive_dashboards:
    'With interactive dashboards you can customize your data exploration to fit your specific business needs,',
  unlocking_tailored_insights: 'unlocking tailored insights that drive smarter decision-making.',
  unlock_insights: 'Unlock insights, identify trends, and maximize profitability.',
  daily_news_brief: 'Daily NewsBrief',
  weekly_trade_wire: 'Weekly TradeWire',
  weekly_jewelry: 'Weekly Jewelry Connoisseur Newsletter',
  bi: 'Bi',
  terms_of_service: 'Terms of Service',
  rapaport_with_year: 'Rapaport © 2025',
  shipping_could_not_be_calculated:
    'We encountered an error calculating the shipping to your address. You may proceed to have your order shipped to the Rapaport NY office for pick-up and contact customer service after confirmation to arrange delivery from the NY office to your address if required.',
  back_to_cart: 'Back to Cart',
  arrange_shipping_to_your_address:
    ' to contact customer service to arrange shipping to your address.',
  subscription_expires:
    'If you cancel before your current subscription expires, we will provide a refund for the unused months remaining on your subscription.',
  by_clicking_submit_you_agree_to_the: 'By clicking Submit, you agree to the',
  only: 'Only ',
  empty_text: ' ',
  buy_now_terms: 'BuyNow Terms and Conditions',
  rename_group: 'Rename Group',
  group_abc: 'Group ABC',
  delete_group: 'Delete Group',
  confirm_delete_group: 'Are you sure you want to delete this Group?',
  including_shipping_and_handling: 'Including shipping to your local Rapaport office and handling',
  processing_your_order: 'Processing your order...',
  please_select_diamond: 'Please select diamond(s)',
  all_rapnet: 'All RapNet',
  all_rapnet_diamonds_option_explanation_1: 'Regular RapNet search, including diamonds',
  all_rapnet_diamonds_option_explanation_2: 'which require you to handle all payment,',
  all_rapnet_diamonds_option_explanation_3: 'shipping, logistics, and compliance.',
  only_buy_now_diamonds_option_explanation_1: 'Search only RapNet BuyNow diamonds, that',
  only_buy_now_diamonds_option_explanation_2: 'are easier, safer and more cost-effective to',
  only_buy_now_diamonds_option_explanation_3: 'buy, with Rapaport taking care of shipping,',
  only_buy_now_diamonds_option_explanation_4: 'payment, QC and compliance.',
  buynow_diamond: 'BuyNow Diamond',
  items_capital: 'Items',
  free_shipping_to_rapaport_israel_office:
    'Free Shipping to Rapaport office in the Ramat Gan Diamond Exchange',
  buyNow_price: 'BuyNow Price',
  buynow_diamonds: 'BuyNow Diamonds',
  dont_show_me_again: "Don't Show Me Again",
  buynow_price_cannot_be_empty_or_higher:
    'BuyNow price cannot be higher than your RapNet price. Please edit or delete BuyNow price.',
  buynow_price_note:
    'The BuyNow price includes processing, shipping to your local Rapaport office, payment, QC, and compliance.',
  added_to_cart: 'Added to Cart',
  one_or_more_items_are_no_longer_available:
    'One or more of the items in your cart are no longer available.\nPlease adjust your order in your cart or search for new diamonds.',
  all_rapaport_pricelists: 'All Rapaport Price Lists',
  return_to_cart: 'Return to Cart',
  download_price_data: 'Download Price Data',
  rapnet_prices: 'RapNet Prices',
  i_agree_to_the: 'I hereby agree to the',
  terms_and_conditions_2: 'Terms and Conditions',
  of_rapnet_buynow: 'of  RapNet   BuyNow',
  please_agree_to_terms_and_conditions: 'Please Agree to Terms and Conditions  ',
  asking_and_or_cash_price_is_required: 'Asking and/or Cash Price is required',
  price_calculator: 'Price Calculator',
  type_in_shape_size_color_and_clarity_of_your_diamond:
    'Type in the shape, size, color and clarity of your diamond, then click ',
  adjust_your_ct_or_total_or_rap_and: 'Adjust your $/ct, $Total or Rap% and ',
  continue_calculating_before_printing_or_exporting_results:
    'Continue calculating before printing or exporting results.',
  print_export_excel_calculator: ' Print or export your results to Excel (.csv format).',
  diamond_details_will_automatically_be_inserted_here_as_part_of_your_message:
    'The diamond details will automatically be inserted here as part of your message',
  type_and_three_dots: 'Type...',
  diamonds_selected_for_buynow: 'Diamonds Selected for BuyNow',
  save_result: 'Save Result',
  calculate: 'Calculate',
  rapaport_prices_in_rupees: 'Rapaport Diamond Prices in Indian Rupees',
  Image: 'Image',
  we_have_not_placed_order: "We've encountered an issue and were unable to process the order.",
  please_try_again_or_conact: 'Please try again or contact customer service ',
  please: 'Please ',
  or_contact: ' or contact customer service ',
  print_full_price_list: 'Print Full Price List',
  download_rapaport_price_lists: 'Download Rapaport Price Lists',
  image_requested: 'Image Requested',
  video_requested: 'Video Requested',
  image_video_requested: 'Image and Video Requested',
  rapaport_price_list_in_usd: 'Rapaport Price List in USD',
  the_price_has_changed: 'The price of this item has changed',
  note_for_exiting_users:
    'We do not allow name changes for existing users. If the RapNet user has changed, please create a new user. Once approved, we will remove this user from your account.',
  reached_your_maximum_members: 'You have reached your maximum\n number of members!',
  cannot_activate_new_members: 'You cannot activate any new members.',
  purchase_additional_users: ' to contact customer service to purchase additional users.',
  user_activation_pending_approval: 'User Activation Pending Approval',
  the_additional_user_will_be_processed:
    'The additional user will be processed and activated once all documents are approved, and payment has been received.',
  if_you_have_any_questions: ' if you have any questions or require support.',
  dollar_space_total: '$ Total',
  certificate_id: 'Certificate ID',
  click_here_not_captial: 'click here. ',
  update_multiple_diamonds: 'Update Multiple Diamonds',
  click_here_to_update_availbility_price_location:
    'Click here to update the availability, price or location for multiple diamonds',
  availability_status: 'Availability Status',
  diamond_id_type: 'Diamond ID Type',
  availability_price_and_location: 'Availability, Price & Location',
  please_type_in_diamond_ids: "Please type in diamond ID's",
  separating_each_id_with_a_comma: 'separating each ID with a comma.',
  rapnet_lot_id_must_be_a_number: 'RapNet Lot ID must be a number',
  loading_text: 'Loading Shipping Info...',
  instagram: 'Instagram',
  seller_or_diamond: 'Seller/Diamond',
  seller_or_diamond_location: 'Seller/Diamond Location',
  include_diamonds_from_sellers_in_the_selected_location:
    'Include diamonds from sellers in the selected location',
  diamond_update_completed: 'Diamond Update Completed',
  your_diamonds_are_in_the_queue_for_processing: 'Your diamonds are in the queue for processing.',
  once_processed_they_will_be_updated_and_available_on_RapNet:
    'Once processed, they will be updated and available on RapNet.',
  you_can_check_the_processing_status_in_your_upload_history:
    'You can check the processing status in your upload history',
  or_stay_on_this_page_to_view_and_edit_other_listings_in_manage_my_diamonds:
    'or stay on this page to view and edit other listings in Manage My Diamonds.',
  the_following_ids_were_not_recognized_and_could_not_be_updated:
    'The following IDs were not recognized and could not be updated:',
  you_left_diamonds_in_your_cart: 'Welcome Back! You Left Diamonds in Your Cart...',
  there_are_buynow_diamonds_waiting_for_you_in_your_cart:
    'There are BuyNow diamonds waiting for you in your cart.\nPick up where you left off and secure your diamonds before they’re gone.\n\nVisit your cart now to complete your purchase. ',
  x_buyers_have_this_diamond_in_their_cart: ' Buyers currently have this diamond in their Cart',
  one_buyer_has_this_diamond_in_their_cart: ' Buyer currently has this diamond in their Cart',
  save: 'Save',
  manage_my_gemstones: 'Manage my gemstones',
  upload_gemstone: 'Upload Gemstone',
  here_you_can_update_the_availability:
    'Here you can update the availability, price or location for multiple diamonds',
  view_less: 'View Less ',
  view_more: 'View More ',
  discount_and_promotion_codes_note:
    'Note: Discounts and/or promotion codes will be deducted from the invoice and are not accounted for here in the total.',
  contact_for_price: 'Contact for Price',
  stock_num: 'Stock#',
  specifications: 'Specifications',
  color_details: 'Color Details',
  color_description: 'Color Description',
  color_system: 'Color System',
  treatment_type: 'Treatment Type',
  origin: 'Origin',
  supplier_description: 'Supplier Description',
  back_to_results: 'Back to Results',
  member_of: 'Member of',

  member_for_years: `Member for {{ val }} Years`,
  seller_gems: `Seller's other {{ val }} gemstones`,
  agree_to_receive_texts_per_the_sms_terms:
    'I agree to receive texts per the SMS Terms & Conditions',
  program_description_title: 'Program Description',
  program_description:
    ' Rapaport and RapNet allows their customers to register their phone numbers to receive alerts.',
  cost_description:
    'There are no premium charges for customers using Rapaport and RapNet text alerts. Message and data rates may apply.',
  message_frequency_title: 'Message Frequency',
  message_frequency_description:
    ' Subscribers to Rapaport and RapNet text alerts will receive account-based messaging, approximately 2-3 per year for annual subscribers. Subscribers may sign up for additional alerts and notifications in their account settings.',
  how_to_opt_out_title: 'How to Opt Out',
  how_to_opt_out_description:
    'To opt-out, please reply STOP to any text message you receive from Rapaport/RapNet. An unsubscribe message will be sent to your number confirming the cancellation, but no more messages will be sent after that one.',
  support_or_help_title: 'Support/Help',
  support_or_help_description:
    'For support or information about Rapaport and RapNet text alerts, you may',
  proceed_to_payment: 'Proceed to Payment',
  update_my_plan: 'Update My Plan',
  create_your_rapnet_account: 'Create Your RapNet Account',
  create_your_rapaport_account: 'Create Your Rapaport Account',
  membership_payment_terms: 'Membership Payment Terms',
  recurring_payments: 'Recurring Payments: ',
  membership_fees_are_billed_automatically:
    ' Membership fees are billed automatically for each subscription period.',
  billing_cycle: 'Billing Cycle: ',
  charges_are_processed_within_14_days_before_your_subscription_renewal_date:
    ' Charges are processed within 14 days before your subscription renewal date.',
  easy_cancellation: 'Easy Cancellation: ',
  You_can_cancel_at_any_time_with_a_single_click:
    ' You can cancel at any time with a single click, by logging into your',
  account_and_removing_your_saved_payment_method: 'account and removing your saved payment method.',
  account_approval_requirement: 'Account Approval Requirement: ',
  you_will_not_be_billed_until_your_rapnet_account_has:
    ' You will not be billed until your RapNet account has',
  been_approved: 'been approved.',
  please_select_your_country_first_to_view_other_available_plans:
    'Please select your country first to view Other Available Plans',
  this_email_address_is_already_associated_with_an_account:
    'This email address is already associated with an account.',
  sign_in: 'sign in',
  contact_us_lowercase: 'contact us',
  email_is_not_valid: 'Email is not valid.',
  email_already_exists_please: 'Email already exists. Please',
  log_in_lower_case: ' log in',
  to_your: 'to your',
  for_support: ' for support.',
  account_or: ' account, or',
  great_news: 'Great News!',
  you_already_have_an_active_subscription:
    'You already have an active subscription associated with your email address.',
  to_access_all_members_features_and_content: "To access all members' features and content, ",
  click_here_to_login: 'click here to login.',
  your_username_is_your_email_address:
    'Your username is your email address. If necessary, you can reset your password.',
  we_looking_forward_to_serving_you: 'We look forward to serving you! ',
  an_account_already_exists_for_your_company: 'An account already exists for your company. ',
  administrator_will_follow_up:
    ' We’ve notified your Rapaport account administrator, who will follow up within 2 business days to assist with your registration.',
  if_you_have_any_question_feel_free_to: 'If you have any questions, feel free to ',
  we_looking_forward_to_assisting_you: 'We look forward to assisting you',
  your_account_has_been_suspended:
    'Your account has been suspended, and we are unable to process your registration at this time.',
  for_more_details_or_assistance: 'for more details or assistance.',
  we_looking_forward_to_resolving_and_to_assisting_you:
    'We look forward to resolving this and assisting you further',
  if_you_require_further_support: 'if you require further support.'
};
